import { useEffect, useState, useRef, useMemo } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { BlueEye, Eye, Filter, AddwithBlueCircle, CrosswithGreyCircle, SubmitArrowHead1, InfoIcon } from "../../AllSvg";
import { ButtonVariants, customSortByKey, generateCustomFileForUpload, renderDangerousHTML, ViewChatImageorFile, getMonthName, CustomTooltip, formatCurrencyIndian, AttachmentIcon, ViewDynamicApprovalStatus, CustomTooltipOld, DateRangePicker } from "../../CustomFunctions";
import { formatDate, formattedDate, formattedDateLong } from "../../Date";
import { BASE_URL, IMAGE_URL, STAGING_URL } from "../../../config/axios";
import { handleErrorToast, isValidTwoDecimalNumber, formatFieldName, inputMinLimit, calculateDaysBetween, calculateDaysFromDateList, getFileNameFromUrl } from "../../CustomFunctions";
import Loader from "../../Loader";
import {
    UpdatePencil,
    DeleteDustbin,
    CloudUpload,
    AddwithWhiteCircle,
    WarnYellow,
    AttendanceReguralizeicon,
} from "../../AllSvg";


import { handleAllError, getMonthBoundaryDate } from "../../CustomFunctions";
import usePermission from "../../../config/permissions";
import ReactQuill from "react-quill";
import { QuillEditorFormats, QuillEditorModules } from "../../CustomUtilities";
import { formatToYYYYMM, getPreviousMonth, MultiDateSelect, MultiDateSelectBackupLatest } from "../../CustomFilters";
import { SandwichRuleExplanation } from "../PortalSettings/PortalSettingsComponents"

const AddPopup = ({ SUPER_ADMIN, SUB_COMPANIES, getPopup }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    const [loading, setLoading] = useState(false);
    const [inputState, setInputState] = useState({});
    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const quillRef = useRef(null);

    const popupSizeOptions = [
        { value: "half", label: "50% of Viewpage (50vw)" },
        { value: "three_fourth", label: "60% of Viewpage (60vw)" },
        { value: "fourth_fifth", label: "70% of Viewpage (70vw)" },
        { value: "fifth_sixth", label: "80% of Viewpage (80vw)" },
    ];

    const initialData = {
        title: "",
        description: "",
        document: null,
        // content_alignment: "center",
        hyper_link: "",
        start_visibility: formattedDate,
        end_visibility: '',
        popup_size: "",
        sub_company: sessionStorage.getItem("company_id"),
    }
    const [formData, setFormData] = useState(initialData);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "description",
            // formData.document ? "content_alignment" : null,
            "start_visibility",
            "end_visibility",
            "popup_size",
            "sub_company"
        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const convertSpaces = (html) => {
        return html.replace(/  /g, "&nbsp;&nbsp;");
    };

    const onEditorContentChange = (content) => {
        const contentWithSpaces = convertSpaces(content);
        const fixedContent = contentWithSpaces.replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );
        setFormData((prev) => ({
            ...prev,
            description: fixedContent,
        }));

        if (isSubmitted && content.trim() !== '') {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.description;
                return newErrors;
            });

            setInputState((prev) => ({
                ...prev,
                description: true,
            }));
        }
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const uploadData = new FormData();
            uploadData.append("title", formData.title);
            uploadData.append("description", formData.description);
            uploadData.append("hyper_link", formData.hyper_link);
            uploadData.append("start_visibility", formData.start_visibility);
            uploadData.append("end_visibility", formData.end_visibility);
            uploadData.append("popup_size", formData.popup_size);
            uploadData.append("sub_company", formData.sub_company);

            const attachmentFile = formData.document;
            if (attachmentFile && typeof attachmentFile !== 'string') {
                const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                uploadData.append("document", customFile);
                // uploadData.append("content_alignment", formData.content_alignment);
            }

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/popup/`,
                    uploadData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200 || res.status === 201) {
                    await getPopup();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Popup created successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button title="Add Popup Notification" className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Popup</span>
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Add Popup</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {SUPER_ADMIN && (
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <select
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className="form-input"
                                        >
                                            <option value="">Select a Company</option>
                                            {SUB_COMPANIES.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.title}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">
                                                {errors.sub_company}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="flex-column">
                                    <label
                                        htmlFor="title"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Title<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData.title}
                                        className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                            }`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text">
                                            {errors.title}
                                        </span>
                                    )}
                                </div>

                                <div title="description" className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    font-size-subheading mb-2"
                                    >
                                        Description<span className="required">*</span>
                                    </label>
                                    <ReactQuill
                                        ref={quillRef}
                                        theme="snow"
                                        value={formData.description}
                                        onChange={onEditorContentChange}
                                        modules={QuillEditorModules}
                                        formats={QuillEditorFormats}
                                        className={`form-input subCompany-quill-editor ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column mt-3 mb-3">
                                    <label
                                        htmlFor="document"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Attachment
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px" }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="document"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.document
                                                    ? formData?.document instanceof File
                                                        ? formData?.document.name
                                                        : getFileNameFromUrl(formData?.document)
                                                    : "No file selected"}
                                            </span>
                                        </label>

                                        <input
                                            type="file"
                                            id="document"
                                            name="document"
                                            accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
                                            onChange={handleFileChange}
                                            className="popup-input"

                                        />
                                        <br />
                                        {formData?.document && (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("document")}
                                            >
                                                Clear
                                            </span>
                                        )}
                                        {errors.document && (
                                            <span className="error-message font-size-text ">
                                                {errors.document}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* {formData.document && <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Attachment Alignment
                                    </label>
                                    <select
                                        name="content_alignment"
                                        value={formData.content_alignment}
                                        onChange={handleInputChange}
                                        className="form-input"
                                    >
                                        <option value="">Select Alignment</option>
                                        <option value="left">Left</option>
                                        <option value="center">Center</option>
                                        <option value="right">Right</option>
                                    </select>
                                </div>} */}

                                <div className="flex-column">
                                    <label
                                        htmlFor="hyper_link"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Hyper Link
                                    </label>
                                    <input
                                        type="text"
                                        id="hyper_link"
                                        name="hyper_link"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData?.hyper_link}
                                        className={`form-input form-input-background`}
                                    />
                                    {errors.hyper_link && (
                                        <span className="error-message font-size-text">
                                            {errors.hyper_link}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-row multi-day-input">
                                    <div className="flex-column multi-day">
                                        <label
                                            htmlFor="start_visibility"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Visible From Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="start_visibility"
                                            name="start_visibility"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            max={formData.end_visibility}
                                            value={formData.start_visibility}
                                            className={`multi-day-input1 form-input-background ${errors.start_visibility
                                                ? "error"
                                                : inputState.start_visibility
                                                    ? "success"
                                                    : ""
                                                }`}

                                        />
                                        {errors.start_visibility && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.start_visibility}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column multi-day">
                                        <label
                                            htmlFor="end_visibility"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Visible Till Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="end_visibility"
                                            name="end_visibility"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            min={formData.start_visibility}
                                            value={formData.end_visibility}
                                            className={`multi-day-input1 form-input-background  ${errors.end_visibility
                                                ? "error"
                                                : inputState.end_visibility
                                                    ? "success"
                                                    : ""
                                                }`}

                                        />
                                        {errors.end_visibility && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.end_visibility}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="popup_size"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Modal Width<span className="required">*</span>
                                    </label>
                                    <select
                                        id="popup_size"
                                        name="popup_size"
                                        value={formData.popup_size}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.popup_size
                                            ? "error"
                                            : inputState.popup_size
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select Modal Width</option>
                                        {popupSizeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.popup_size && (
                                        <span className="error-message font-size-text">
                                            {errors.popup_size}
                                        </span>
                                    )}
                                </div>


                                <div className="button-models  ">
                                    <button
                                        type="button"
                                        className="model-button  font-weight500 popupdisplay-cancel-btn"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <ViewPopup i={formData} infoflag={true} button_varient={'Model-Name'} button_display_name={'Preview'} />
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                                <p className="error-message font-size-text">
                                    {isSubmitted && Object.keys(errors).length > 0 && (
                                        Object.keys(errors).length > 5 ? (
                                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                                        ) : (
                                            <h6 className="text-center">
                                                {Object.keys(errors).map((field) =>
                                                    field.charAt(0).toUpperCase() + field.slice(1)
                                                ).join(', ') + ' are required!'}
                                            </h6>
                                        )
                                    )}
                                </p>
                                {/* </div> */}
                            </form>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const PopupUpdate = ({ i, SUPER_ADMIN, SUB_COMPANIES, getPopup }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);
    const quillRef = useRef(null);

    const popupSizeOptions = [
        { value: "half", label: "50% of Viewpage (50vw)" },
        { value: "three_fourth", label: "60% of Viewpage (60vw)" },
        { value: "fourth_fifth", label: "70% of Viewpage (70vw)" },
        { value: "fifth_sixth", label: "80% of Viewpage (80vw)" },
    ];

    const [formData, setFormData] = useState({
        title: "",
        description: "",
        document: null,
        // content_alignment: "center",
        hyper_link: "",
        start_visibility: "",
        end_visibility: '',
        popup_size: "",
        sub_company: sessionStorage.getItem("company_id"),
    });

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "title",
            "description",
            // formData.document ? "content_alignment" : null,
            "start_visibility",
            "end_visibility",
            "popup_size",
            "sub_company"
        ].filter(Boolean)
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    useEffect(() => {
        setFormData(i);
    }, [i]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };

    const convertSpaces = (html) => {
        return html.replace(/  /g, "&nbsp;&nbsp;");
    };
    const onEditorContentChange = (content) => {
        const contentWithSpaces = convertSpaces(content);
        const fixedContent = contentWithSpaces.replace(
            /href="(?!http)([^"]+)"/g,
            'href="https://$1"'
        );
        setFormData((prev) => ({
            ...prev,
            description: fixedContent,
        }));

        if (isSubmitted && content.trim() !== '') {
            setErrors((prevErrors) => {
                const newErrors = { ...prevErrors };
                delete newErrors.description;
                return newErrors;
            });

            setInputState((prev) => ({
                ...prev,
                description: true,
            }));
        }
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });

    };

    const handleFileClear = (e, fieldName) => {
        setFormData((prev) => ({
            ...prev,
            [fieldName]: null,
        }));
        if (e.target.type === "file") {
            e.target.value = null;
        }
        e.stopPropagation();
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            setLoading(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            const uploadData = new FormData();
            uploadData.append("title", formData.title);
            uploadData.append("description", formData.description);
            uploadData.append("hyper_link", formData.hyper_link);
            uploadData.append("start_visibility", formData.start_visibility);
            uploadData.append("end_visibility", formData.end_visibility);
            uploadData.append("popup_size", formData.popup_size);
            uploadData.append("sub_company", formData.sub_company);

            const attachmentFile = formData.document;
            if (attachmentFile && typeof attachmentFile !== 'string') {
                const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                uploadData.append("document", customFile);
                // uploadData.append("content_alignment", formData.content_alignment);
            }
            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/popup/${i.id}/`,
                    uploadData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    await getPopup();
                    setShow(false);
                    toast.success("Popup updated successfully!");
                } else {
                    console.error("Something went wrong: " + res.statusText);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button
                title="Update Popup Display"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Update Popup -{" "}
                        <span className="dynamic-modal-title">{formData?.title}</span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                {/* <div className="form-flex-wrap"> */}
                                {SUPER_ADMIN && (
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <select
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className="form-input"
                                        >
                                            <option value="">Select a Company</option>
                                            {SUB_COMPANIES.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.title}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">
                                                {errors.sub_company}
                                            </span>
                                        )}
                                    </div>
                                )}

                                <div className="flex-column">
                                    <label
                                        htmlFor="title"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Title<span className="required">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData?.title}
                                        className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                            }`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text">
                                            {errors.title}
                                        </span>
                                    )}
                                </div>

                                <div title="description" className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels  font-weight500    font-size-subheading mb-2"
                                    >
                                        Description<span className="required">*</span>
                                    </label>
                                    <ReactQuill
                                        ref={quillRef}
                                        theme="snow"
                                        value={formData.description}
                                        onChange={onEditorContentChange}
                                        modules={QuillEditorModules}
                                        formats={QuillEditorFormats}
                                        className={`form-input subCompany-quill-editor ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />
                                    {errors.description && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.description}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-column mt-3 mb-3">
                                    <label
                                        htmlFor="document"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Attachment
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px" }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="document"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.document
                                                    ? formData?.document instanceof File
                                                        ? formData?.document.name
                                                        : getFileNameFromUrl(formData?.document)
                                                    : "No file selected"}
                                            </span>
                                        </label>

                                        {/* File Input */}
                                        <input
                                            type="file"
                                            name="document"
                                            id="document"
                                            accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
                                            onChange={handleFileChange}
                                            className="popup-input"
                                        />

                                        {/* Clear Button */}
                                        {formData?.document && (
                                            <span
                                                className="file-clear"
                                                style={{ padding: "0px 10px" }}
                                                onClick={(e) => handleFileClear(e, "document")}
                                            >
                                                Clear
                                            </span>
                                        )}
                                        {errors.document && (
                                            <span className="error-message font-size-text ">
                                                {errors.document}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                {/* {formData.document && <div className="flex-column">
                                    <label className="form-labels">
                                        Attachment Alignment<span className="required">*</span>
                                    </label>
                                    <select
                                        name="content_alignment"
                                        value={formData.content_alignment}
                                        onChange={handleInputChange}
                                        className="form-input"
                                    >
                                        <option value="">Select Alignment</option>
                                        <option value="left">Left</option>
                                        <option value="center">Center</option>
                                        <option value="right">Right</option>
                                    </select>
                                    {errors.content_alignment && (
                                        <span className="error-message font-size-text mt-2">
                                            {errors.content_alignment}
                                        </span>
                                    )}
                                </div>} */}

                                <div className="flex-column">
                                    <label
                                        htmlFor="hyper_link"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Hyper Link
                                    </label>
                                    <input
                                        type="text"
                                        id="hyper_link"
                                        name="hyper_link"
                                        maxLength={150}
                                        onChange={handleInputChange}
                                        value={formData?.hyper_link}
                                        className={`form-input form-input-background`}
                                    />
                                    {errors.hyper_link && (
                                        <span className="error-message font-size-text">
                                            {errors.hyper_link}
                                        </span>
                                    )}
                                </div>

                                <div className="flex-row multi-day-input">
                                    <div className="flex-column multi-day">
                                        <label
                                            htmlFor="start_visibility"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Visible From Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="start_visibility"
                                            name="start_visibility"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            value={formData.start_visibility}
                                            className={`multi-day-input1 form-input-background ${errors.start_visibility
                                                ? "error"
                                                : inputState.start_visibility
                                                    ? "success"
                                                    : ""
                                                }`}
                                        />
                                        {errors.start_visibility && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.start_visibility}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column multi-day">
                                        <label
                                            htmlFor="end_visibility"
                                            className="form-labels font-weight500 font-size-subheading"
                                        >
                                            Visible Till Date<span className="required">*</span>
                                        </label>
                                        <input
                                            type="date"
                                            id="end_visibility"
                                            name="end_visibility"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            value={formData.end_visibility}
                                            className={`multi-day-input1 form-input-background  ${errors.end_visibility
                                                ? "error"
                                                : inputState.end_visibility
                                                    ? "success"
                                                    : ""
                                                }`}

                                        />
                                        {errors.end_visibility && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.end_visibility}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels font-weight500 font-size-subheading"
                                    >
                                        Modal Width<span className="required">*</span>
                                    </label>
                                    <select
                                        id="popup_size"
                                        name="popup_size"
                                        value={formData.popup_size}
                                        onChange={handleInputChange}
                                        className={`form-input ${errors.popup_size
                                            ? "error"
                                            : inputState.popup_size
                                                ? "success"
                                                : ""
                                            }`}
                                    >
                                        <option value="">Select Modal Width</option>
                                        {popupSizeOptions.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.popup_size && (
                                        <span className="error-message font-size-text">
                                            {errors.popup_size}
                                        </span>
                                    )}
                                </div>

                                <div className="button-models ">
                                    <button
                                        type="button"
                                        className="model-button font-weight500 popupdisplay-cancel-btn"
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </button>
                                    <ViewPopup i={formData} infoflag={true} button_varient={'Model-Name'} button_display_name={'Preview'} />
                                    <button
                                        type="submit"
                                        className="model-button model-button-leave font-weight500 font-size-heading"
                                        disabled={loading}
                                        onClick={handleSubmit}
                                    >
                                        Submit
                                    </button>
                                </div>
                                <p className="error-message font-size-text">
                                    {isSubmitted && Object.keys(errors).length > 0 && (
                                        Object.keys(errors).length > 5 ? (
                                            <h5 className="text-center">Please fill all mandatory fields!</h5>
                                        ) : (
                                            <h6 className="text-center">
                                                {Object.keys(errors).map((field) =>
                                                    field.charAt(0).toUpperCase() + field.slice(1)
                                                ).join(', ') + ' are required!'}
                                            </h6>
                                        )
                                    )}
                                </p>
                                {/* </div> */}
                            </form>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const PopupDelete = ({ i, getPopup }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/popup/${i.id}/`);
            if (res.status === 200) {
                await getPopup();
                setShow(false);
                toast.success("Popup Deleted Successfully!");
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete PopUp {i?.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete popup of <b>{i?.title}</b>
                        <div className="button-models">
                            <button
                                type="button"
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const ViewPopup = ({ i, infoflag, buttonhide, display, onclose, button_varient, button_display_name }) => {
    const [showModal, setShowModal] = useState(display || false);

    const handleView = () => setShowModal(true);
    const handleCloseModal = () => {
        if (onclose) {
            onclose();
        }
        setShowModal(false)
    };

    const attachmentFile =
        i?.document instanceof Blob ? URL.createObjectURL(i?.document) : i?.document;

    const imageTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif", "image/webp"];

    const popupSizeOptions = [
        { value: "half", class: "half-modal" },
        { value: "three_fourth", class: "three-fourth-modal" },
        { value: "fourth_fifth", class: "four-fifth-modal" },
        { value: "fifth_sixth", class: "five-sixth-modal" },
    ];

    const popupSizeClass =
        popupSizeOptions.find(opt => opt.value === i?.popup_size)?.class || "half-modal";


    return (
        <>
            {buttonhide ? null :
                <ButtonVariants
                    buttonDisplay={button_varient}
                    buttonDisplayName={button_display_name}
                    handleShow={handleView}
                />}

            <Modal
                show={showModal}
                onHide={handleCloseModal}
                dialogClassName={popupSizeClass}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <div className="flex-row">
                            {i?.title}
                            {" "}
                            {infoflag && <div className="modal-info flex-row">
                                <button
                                    className="model-partial-button"
                                    style={{
                                        width: "20px",
                                        fontSize: "14px",
                                        cursor: "pointer",
                                    }}
                                >
                                    <WarnYellow />
                                </button>
                                <span className="info-details">
                                    <strong>Start Date:</strong>{" "}
                                    {i?.start_visibility ? formatDate(i?.start_visibility) : ""} <br />
                                    <strong>End Date:</strong>{" "}
                                    {i?.end_visibility ? formatDate(i?.end_visibility) : ""} <br />
                                </span>
                            </div>}
                        </div>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div >
                        <div>
                            {renderDangerousHTML(i?.description)}
                        </div>

                        {/* <div style={{ textAlign: i?.content_alignment }}> */}
                        {/* <div style={{ textAlign: 'center' }}> */}
                        <div >
                            {i?.document ? (
                                imageTypes.includes(i.document.type) ? (
                                    <img
                                        src={attachmentFile}
                                        alt="Attachment-Preview"
                                        className="w-full"
                                        style={{
                                            objectFit: "contain",
                                            maxHeight: "70vh",
                                            height: "auto",
                                        }}
                                    />
                                ) : (
                                    <div className="align-center">
                                        <ViewChatImageorFile
                                            textcss="link-to-image"
                                            filesrc={attachmentFile}
                                        // customCss="viewLinktoImage-Container"
                                        />
                                    </div >
                                )
                            ) : (
                                null
                            )}
                        </div>
                    </div>

                </Modal.Body>
            </Modal >
        </>
    );
};

const ShowBannerPopups = () => {
    const popups = JSON.parse(localStorage.getItem("companyPopups") || "[]");
    return (
        <>
            {popups.map((i) =>
                localStorage.getItem(`popup-${i.id}`) === "true" ? (
                    <ViewPopup
                        key={i.id}
                        i={i}
                        buttonhide={true}
                        display={true}
                        onclose={() => localStorage.setItem(`popup-${i.id}`, "false")}
                    />
                ) : null
            )}
        </>
    );
};

//---------------------------------------- Announce Table
const AnnouncentAdd = ({ getAnnouncement }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        title: "",
        file: "",
        description: "",
        date: formattedDate,
        start_visibility: formattedDate,
        end_visibility: formattedDate,
        sub_company: sessionStorage.getItem('company_id'),
    });

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["title", "description", "date", "file", "start_visibility", "end_visibility"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //
    const [loading, setLoading] = useState(false); //loading logic

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            const formDataa = new FormData();
            formDataa.append("title", formData.title);
            formDataa.append("description", formData.description);
            formDataa.append("date", formData.date);
            formDataa.append("start_visibility", formData.start_visibility);
            formDataa.append("end_visibility", formData.end_visibility);
            formDataa.append("sub_company", formData.sub_company);



            try {
                const originalFile = formData.file;
                if (originalFile) {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("file", customFile);
                }

                let res = await axios.post(
                    `${BASE_URL}/settings/informationboardAPI/`,
                    formDataa,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    toast.success('Successfully Added Announcement');
                    await getAnnouncement()
                    handleClose()
                    // window.location.reload();
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleAllError(err)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ];

            if (validFileTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: "", // Clear any previous errors for this field
                });
            } else {
                setErrors({
                    ...errors,
                    [name]: "Invalid file type. Please select a PDF or DOC file.",
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };


    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />{" "}Announcement
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Announcment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                <div className="flex-column">
                                    <label htmlFor="title" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                        Title
                                    </label>
                                    <input
                                        id="title"
                                        type="title"
                                        name="title"
                                        maxLength={50}
                                        placeholder="title"
                                        onChange={handleInputChange}
                                        value={formData.title}
                                        className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                            }`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text ">{errors.title}</span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                        Date
                                    </label>
                                    <input
                                        id="date"
                                        type="date"
                                        name="date"
                                        placeholder="date"
                                        onChange={handleInputChange}
                                        value={formData.date}
                                        className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                                            }`}
                                    />
                                    {errors.date && (
                                        <span className="error-message font-size-text ">{errors.date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <textarea
                                        placeholder="Task Description"
                                        type="text"
                                        name="description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />

                                    {errors.description && (
                                        <span className="error-message font-size-text ">{errors.description}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="file"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Attachment
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px" }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="file"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.file
                                                    ? formData?.file instanceof File
                                                        ? formData?.file.name
                                                        : getFileNameFromUrl(formData?.file)
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            type="file"
                                            id="file"
                                            name="file"
                                            accept=".pdf, .doc, .docx"
                                            onChange={handleFileChange}
                                            className="popup-input"

                                        />
                                        {formData?.file && (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("file")}
                                            >
                                                Clear
                                            </span>
                                        )}
                                        {errors.file && (
                                            <span className="error-message font-size-text ">
                                                {errors.file}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-row multi-day-input">
                                    <div className="flex-column multi-day">
                                        <label className="form-labels font-weight500 font-size-subheading">Visible From Date</label>
                                        <input
                                            id="start_visibility"
                                            name="start_visibility"
                                            type="date"
                                            className="multi-day-input1 form-input-background"
                                            style={{ cursor: 'not-allowed' }}
                                            value={formData.start_visibility}
                                            // onChange={handleInputChange}
                                            max={formData.end_visibility ? formData.end_visibility : null}
                                        />
                                        {errors.start_visibility && (
                                            <span className="error-message font-size-text ">{errors.start_visibility}</span>
                                        )}
                                    </div>
                                    <div className="flex-column multi-day">
                                        <label className="form-labels font-weight500 font-size-subheading">Visible Till Date</label>
                                        <input
                                            id="end_visibility"
                                            name="end_visibility"
                                            type="date"
                                            className="multi-day-input1 form-input-background"
                                            value={formData.end_visibility}
                                            onChange={handleInputChange}
                                            min={formData.start_visibility ? formData.start_visibility : null}
                                        />
                                        {errors.end_visibility && (
                                            <span className="error-message font-size-text ">{errors.end_visibility}</span>
                                        )}
                                    </div>
                                </div>

                            </form>
                            <div className="button-models">
                                <button className="model-button  font-weight500   model-button-cancel" onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button  font-weight500    model-button-leave font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const AnnouncementUpdate = ({ i, getAnnouncement }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const [formData, setFormData] = useState({
        title: "",
        file: "",
        description: "",
        date: formattedDate,
        start_visibility: formattedDate,
        end_visibility: formattedDate,
        sub_company: sessionStorage.getItem('company_id'),
    });

    useEffect(() => {
        setFormData(i);
    }, [i]);

    // !  ************** Validation start **************  ! //

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["title", "description", "date", "file", "start_visibility", "end_visibility"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    // ?  ************** Validation End **************  ! //

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const formDataa = new FormData();
            formDataa.append("title", formData.title);
            formDataa.append("description", formData.description);
            formDataa.append("date", formData.date);
            formDataa.append("start_visibility", formData.start_visibility);
            formDataa.append("end_visibility", formData.end_visibility);
            formDataa.append("sub_company", formData.sub_company);



            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

            try {
                const originalFile = formData.file;

                if (originalFile && typeof originalFile !== 'string') {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("file", customFile);
                }
                let res = await axios.put(
                    `${BASE_URL}/settings/informationboardAPI/${i.id}/`,
                    formDataa,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    toast.success('Successfully Updated Announcement');
                    await getAnnouncement()
                    handleClose()
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleAllError(err)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        if (file) {
            const validFileTypes = [
                "application/pdf",
                "application/msword",
                "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
            ];
            if (validFileTypes.includes(file.type)) {
                setFormData({
                    ...formData,
                    [name]: file,
                });
                setErrors({
                    ...errors,
                    [name]: "", // Clear any previous errors for this field
                });
            } else {
                setErrors({
                    ...errors,
                    [name]: "Invalid file type. Please select a PDF or DOC file.",
                });
            }
        } else {
            setFormData({
                ...formData,
                [name]: null,
            });
        }
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button className="model-edit-button-ml" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Announcment "{i.title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <form>
                                <div className="flex-column">
                                    <label htmlFor="title" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                        Title
                                    </label>
                                    <input
                                        id="title"
                                        type="title"
                                        name="title"
                                        placeholder="title"
                                        onChange={handleInputChange}
                                        value={formData.title}
                                        className={`form-input ${errors.title ? "error" : inputState.title ? "success" : ""
                                            }`}
                                    />
                                    {errors.title && (
                                        <span className="error-message font-size-text ">{errors.title}</span>
                                    )}
                                </div>
                                <div className="flex-column">
                                    <label htmlFor="date" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                        Date
                                    </label>
                                    <input
                                        id="date"
                                        type="date"
                                        name="date"
                                        placeholder="date"
                                        onChange={handleInputChange}
                                        value={formData.date}
                                        className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
                                            }`}
                                    />
                                    {errors.date && (
                                        <span className="error-message font-size-text ">{errors.date}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label
                                        htmlFor="description"
                                        className="form-labels font-weight500    announce-date font-weight400  font-size-heading"
                                    >
                                        Description
                                    </label>
                                    <textarea
                                        placeholder="Task Description"
                                        type="text"
                                        name="description"
                                        onChange={handleInputChange}
                                        value={formData.description}
                                        className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.description
                                            ? "error"
                                            : inputState.description
                                                ? "success"
                                                : ""
                                            }`}
                                    />

                                    {errors.description && (
                                        <span className="error-message font-size-text ">{errors.description}</span>
                                    )}
                                </div>

                                <div className="flex-column">
                                    <label htmlFor="file" className="form-labels font-weight500    announce-date font-weight400  font-size-heading">
                                        Attachment
                                    </label>
                                    <div
                                        className={`file-upload-container flex-row justify-between file-in-upload`}
                                        style={{ padding: "0 3px" }}
                                    >
                                        <label
                                            className="popup-label"
                                            htmlFor="file"
                                        >
                                            <CloudUpload />
                                            <span className="truncate-url">
                                                {formData?.file
                                                    ? formData?.file instanceof File
                                                        ? formData?.file.name
                                                        : getFileNameFromUrl(formData?.file)
                                                    : "No file selected"}
                                            </span>
                                        </label>
                                        <input
                                            type="file"
                                            id="file"
                                            name="file"
                                            accept=".pdf, .doc, .docx"
                                            onChange={handleFileChange}
                                            className="popup-input"

                                        />
                                        {formData?.file && (
                                            <span
                                                className="file-clear"
                                                onClick={() => handleFileClear("file")}
                                            >
                                                Clear
                                            </span>
                                        )}
                                        {errors.file && (
                                            <span className="error-message font-size-text ">
                                                {errors.file}
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className="flex-row multi-day-input">
                                    <div className="flex-column multi-day">
                                        <label className="form-labels font-weight500 font-size-subheading">Visible From Date</label>
                                        <input
                                            id="start_visibility"
                                            name="start_visibility"
                                            type="date"
                                            className="multi-day-input1 form-input-background"
                                            // style={{ cursor: 'not-allowed' }}
                                            value={formData.start_visibility}
                                            onChange={handleInputChange}
                                            // disabled
                                            max={formData.end_visibility ? formData.end_visibility : null}
                                        />
                                        {errors.start_visibility && (
                                            <span className="error-message font-size-text ">{errors.start_visibility}</span>
                                        )}
                                    </div>
                                    <div className="flex-column multi-day">
                                        <label className="form-labels font-weight500 font-size-subheading">Visible Till Date</label>
                                        <input
                                            id="end_visibility"
                                            name="end_visibility"
                                            type="date"
                                            className="multi-day-input1 form-input-background"
                                            value={formData.end_visibility}
                                            onChange={handleInputChange}
                                            min={formData.start_visibility ? formData.start_visibility : null}
                                        />
                                        {errors.end_visibility && (
                                            <span className="error-message font-size-text ">{errors.end_visibility}</span>
                                        )}
                                    </div>
                                </div>

                            </form>
                            <div className="button-models">
                                <button className="model-button model-button-cancel font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button  font-weight500    model-button-leave font-weight500    font-size-heading"
                                    onClick={handleSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const AnnouncementDelete = ({ i, getAnnouncement }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/settings/informationboardAPI/${i.id}/`
            );

            if (res.status === 200) {
                await getAnnouncement();
                setShow(false);
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Announcment "{i.title}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete department {i.title}
                        <div className="button-models">
                            <button className="model-button  font-weight500  model-button-cancel  " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button  font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

//---------------------- Attendance Table -----------------------

// Updated
const AttReguralizeAdd = ({ SUPER_ADMIN, SUB_COMPANIES, getAttendanceRegLogsData }) => {
    const [show, setShow] = useState(false);
    const isSubmittingRef = useRef(false);
    const handleShow = () => {
        // getAllEmpList()
        setShow(true);
    }
    const todayDate = new Date();
    const y2 = todayDate.getFullYear();
    const m2 = todayDate.getMonth() + 1;
    const d2 = todayDate.getDate();

    const formattedDate = `${y2}-${m2.toString().padStart(2, "0")}-${d2
        .toString()
        .padStart(2, "0")}`;


    const today = new Date();
    today.setDate(today.getDate() - 60);

    const year = today.getFullYear();
    const month = today.getMonth() + 1;
    const day = today.getDate();

    const formattedDatee = `${year}-${month.toString().padStart(2, "0")}-${day
        .toString()
        .padStart(2, "0")}`;

    const handleClose = () => {
        setFormData({
            sub_company: sessionStorage.getItem('company_id'),
            // date: "",
            start_date: "",
            end_date: "",
            reason: "",
            emp_code: [],
            newDayStatus: "",
            newAttendanceStatus: "",
        })
        setStartDate(formattedDatee);
        setEndDate(formattedDate);
        setToggleCompany(sessionStorage.getItem('company_id'));
        setEmpList([])
        setShow(false);
    }
    const [buffer1, setBuffering1] = useState(false);
    const [buffer2, setBuffering2] = useState(false);
    const [buffer3, setBuffering3] = useState(false);
    const [loading, setLoading] = useState(false);
    const [multipleEmpTimeline, setMultipleEmpTimeline] = useState({})
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem("company_id"));
    const [active, setEmployeeStatus] = useState('active');
    const [startdate, setStartDate] = useState(`${formattedDatee}`);
    const [enddate, setEndDate] = useState(`${formattedDate}`);
    const [empList, setEmpList] = useState([]);
    const [filteredEmpAttendances, setFilteredEmpAttendances] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    const [companyTimeLine, setCompanyTimeline] = useState({});
    const [employeeAttendanceSelection, setEmployeeAttendanceSelection] = useState("specific");
    const [filters, setFilters] = useState({
        dayStatus: "",
        attendanceStatus: "",
        workHours: "",
        workHoursOperator: "equals",
        punchInTime: "",
        punchInOperator: "equals",
        punchOutTime: "",
        punchOutOperator: "equals",
    });
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [conditionalEmpCodes, setConditionalEmpCodes] = useState([]);

    const [formData, setFormData] = useState({
        sub_company: sessionStorage.getItem('company_id'),
        // date: "",
        start_date: "",
        end_date: "",
        reason: "",
        emp_code: [],
        newDayStatus: "",
        newAttendanceStatus: "",
    });

    const DAY_STATUS_OPTS = [
        "absent", "halfday", "halfdayleave", "hdoutduty", "holiday", "late", "paidleave",
        "misspunch", "ontime", "outduty", "rlm", "shortleave", "shortoutduty",
        "unpaidleavehd", "unpaidleave", "unpaidshortleave", "weeklyoff", "wop"
    ];
    const ATT_STATUS_OPTS = ["leave", "absent", "holiday", "weeklyoff", "present"];

    const PAIRED_STATUS_OPTS = [
        { dayStatus: "shortleave", attendanceStatus: "leave" },
        { dayStatus: "halfdayleave", attendanceStatus: "leave" },
        { dayStatus: "paidleave", attendanceStatus: "leave" },
        { dayStatus: "unpaidshortleave", attendanceStatus: "leave" },
        { dayStatus: "unpaidleavehd", attendanceStatus: "leave" },
        { dayStatus: "unpaidleave", attendanceStatus: "leave" },
        { dayStatus: "absent", attendanceStatus: "absent" },
        { dayStatus: "misspunch", attendanceStatus: "present" },
        { dayStatus: "late", attendanceStatus: "present" },
        { dayStatus: "halfday", attendanceStatus: "present" },
        { dayStatus: "ontime", attendanceStatus: "present" },
        { dayStatus: "rlm", attendanceStatus: "present" },
        { dayStatus: "shortoutduty", attendanceStatus: "present" },
        { dayStatus: "hdoutduty", attendanceStatus: "present" },
        { dayStatus: "outduty", attendanceStatus: "present" },
        { dayStatus: "wop", attendanceStatus: "present" },
        { dayStatus: "weeklyoff", attendanceStatus: "weeklyoff" },
        { dayStatus: "holiday", attendanceStatus: "holiday" },
        // { dayStatus: "workfromhome", attendanceStatus: "present" },
    ];

    const getAllEmpList = async (date) => {
        setBuffering1(true)
        try {
            setFormData(prev => ({
                ...prev,
                emp_code: []
            }));
            const res = await axios.get(
                // `${BASE_URL}/wfm/employeefilter-by-subcompany-status-date/${toggleCompany}/${active}/${date}/`
                `${BASE_URL}/wfm/employeefilter-by-subcompany-status-date/${toggleCompany}/${active}/${formData.start_date}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering1(false)
        }
    };


    const attendanceModeRef = useRef(employeeAttendanceSelection);

    useEffect(() => {
        attendanceModeRef.current = employeeAttendanceSelection;
    }, [employeeAttendanceSelection]);


    const getFilteredEmpAttendanceList = async (empCodes) => {
        // if (!formData.date) return;
        if (!formData.start_date) return;

        const toggleSelected = attendanceModeRef.current;
        setBuffering2(true);

        try {
            let payload = {};

            if (toggleSelected === "specific") {
                payload = {
                    employee_list: empCodes || [],
                };
            } else {
                payload = {
                    filter_conditions: {
                        dayStatus: filters.dayStatus,
                        attendanceStatus: filters.attendanceStatus,
                        workHours: filters.workHours,
                        workHoursOperator: filters.workHoursOperator,
                        punchInTime: filters.punchInTime,
                        punchInOperator: filters.punchInOperator,
                        punchOutTime: filters.punchOutTime,
                        punchOutOperator: filters.punchOutOperator,
                    },
                };
            }

            const res = await axios.post(
                //  `${BASE_URL}/wfm/regularizationattendance-bydate-byemplist/${toggleCompany}/${formData.date}/`,
                `${BASE_URL}/wfm/regularizationattendance-bydate-byemplist/${toggleCompany}/${formData.start_date}/`,
                payload
            );


            if (attendanceModeRef.current !== toggleSelected) {
                console.log("Mode changed during API call, ignoring result");
                return;
            }

            const sortedList = customSortByKey(res.data, "emp_code");
            setFilteredEmpAttendances(sortedList);

            if (toggleSelected === "conditional") {
                const empOptionsFromResponse = sortedList
                    .filter(emp => !(emp.arrear_details && emp.arrear_details.length > 0))
                    .map(emp => ({
                        value: emp.emp_code,
                        label: `${emp.emp_code}-${emp.name}`,
                    }));
                setSelectedOptions(empOptionsFromResponse || []);
                setFormData(prev => ({
                    ...prev,
                    emp_code: empOptionsFromResponse.map(opt => opt.value)
                }));
            }

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering2(false);
        }
    };

    // useEffect(() => {
    //     if (formData.date) {
    //         getAllEmpList(formData.date)
    //     }
    // }, [formData.date, toggleCompany, active]);

    useEffect(() => {
        if (formData.start_date) {
            getAllEmpList(formData.start_date)
        }
    }, [formData.start_date, toggleCompany, active]);

    useEffect(() => {
        if (employeeAttendanceSelection === "conditional" && formData.start_date) {
            const timer = setTimeout(() => {
                getFilteredEmpAttendanceList();
            }, 500);
            return () => clearTimeout(timer);
        }
    }, [filters, employeeAttendanceSelection, formData.start_date, toggleCompany]);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        // setFilters((prev) => ({ ...prev, [name]: value }));

        setFilters((prev) => {
            const updatedFilters = { ...prev, [name]: value };

            // If dayStatus is changed, clear attendanceStatus
            if (name === 'dayStatus') {
                updatedFilters.attendanceStatus = "";
            }

            // If attendanceStatus is changed, clear dayStatus
            if (name === 'attendanceStatus') {
                updatedFilters.dayStatus = "";
            }

            return updatedFilters;
        });
    };

    const options = empList
        .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
        .map((e) => {
            // Check if employee has arrear details
            const hasArrear = e.arrear_details && e.arrear_details.length > 0;
            const arrearPeriod = hasArrear ? e.arrear_details[0].applicable_period : null;

            return {
                value: e.emp_code,
                label: `${e.emp_code} - ${e.name}`,
                isDisabled: hasArrear, // Disable if has arrear
                arrearPeriod: arrearPeriod // Store arrear period for display
            };
        });

    const handleChangeEmpList = (selected) => {
        if (employeeAttendanceSelection === "specific") {

            const validSelected = selected ? selected.filter(item => {
                const empInList = empList.find(e => e.emp_code === item.value);
                return !(empInList?.arrear_details && empInList.arrear_details.length > 0);
            }) : [];

            const empCode = validSelected.length > 0
                ? validSelected.map((item) => item.value)
                : [];

            setSelectedOptions(validSelected || []);
            setFormData((prevState) => ({
                ...prevState,
                emp_code: empCode,
            }));

            getFilteredEmpAttendanceList(empCode)
        }
    };


    const handleCheckboxChange = (emp_code) => {
        const currentIndex = selectedOptions.findIndex(item => item.value === emp_code);
        const newCheckedEmployees = [...selectedOptions];

        if (currentIndex === -1) {
            const empToAdd = filteredEmpAttendances.find(emp => emp.emp_code === emp_code);
            if (empToAdd) {
                newCheckedEmployees.push({
                    value: empToAdd.emp_code,
                    label: `${empToAdd.emp_code}-${empToAdd.name}`
                });
            }
        } else {
            newCheckedEmployees.splice(currentIndex, 1);
        }
        setSelectedOptions(newCheckedEmployees);

        // Update form data
        const empCodes = newCheckedEmployees.map(item => item.value);
        setFormData(prev => ({
            ...prev,
            emp_code: empCodes
        }));
    };

    const handleSelectAll = (e) => {
        if (e.target.checked) {
            if (employeeAttendanceSelection === "conditional") {
                const allEmployees = filteredEmpAttendances.map(emp => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code}-${emp.name}`,
                }));
                setSelectedOptions(allEmployees);
                setFormData(prev => ({
                    ...prev,
                    emp_code: allEmployees.map(emp => emp.value)
                }));
            }
        } else {
            setSelectedOptions([]);
            setFormData(prev => ({
                ...prev,
                emp_code: []
            }));
        }
    };


    const isEmployeeChecked = (emp_code) => {
        return selectedOptions.some(item => item.value === emp_code);
    };


    useEffect(() => {
        //  if (employeeAttendanceSelection === "specific" && formData.date && formData.emp_code.length > 0) {
        if (employeeAttendanceSelection === "specific" && formData.start_date && formData.emp_code.length > 0) {
            getFilteredEmpAttendanceList(formData.emp_code);
        }
        // }, [formData.date])
    }, [formData.start_date])

    const [errors, setErrors] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const newErrors = {};
    const validateForm = () => {
        const requiredFields = ["sub_company", "start_date", "newDayStatus", "newAttendanceStatus", "reason"];
        // const requiredFields = ["sub_company", "date", "newDayStatus", "newAttendanceStatus", "reason"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };




    const getSubCompanyTimelineData = async () => {
        setBuffering3(true)
        try {

            const res = await axios.get(
                `${BASE_URL}/wfm/subcompany-latest-timeline/${toggleCompany}/summary/`
            );

            setCompanyTimeline(res.data.data);

        } catch (err) {
            handleErrorToast(err);
        } finally {
            setBuffering3(false)
        }
    };

    useEffect(() => {
        if (toggleCompany) {
            getSubCompanyTimelineData();
        }
    }, [toggleCompany]);

    // Add this function to calculate the minimum allowed date
    const getMinAllowedDate = () => {
        const payrun = companyTimeLine?.last_salary_slip;
        const tax = companyTimeLine?.last_tax_calculation;

        if (!payrun && !tax) return "";

        const payrunValue = payrun ? (payrun.year * 100 + payrun.month) : 0;
        const taxValue = tax ? (tax.year * 100 + tax.month) : 0;

        // Get the latest processed month
        const lockValue = Math.max(payrunValue, taxValue);

        let lockMonth = "";
        let lockYear = "";

        if (lockValue === payrunValue && payrun) {
            lockMonth = payrun.month;
            lockYear = payrun.year;
        } else if (tax) {
            lockMonth = tax.month;
            lockYear = tax.year;
        }

        if (lockMonth && lockYear) {

            let nextMonth = lockMonth + 1;
            let nextYear = lockYear;

            if (nextMonth > 12) {
                nextMonth = 1;
                nextYear = lockYear + 1;
            }

            const year = nextYear;
            const month = String(nextMonth).padStart(2, '0');
            return `${year}-${month}-01`;
        }

        return "";
    };

    // const handleSubmit = async (e) => {
    //     e.preventDefault();

    //     if (isSubmittingRef.current) return;
    //     isSubmittingRef.current = true;


    //     if (employeeAttendanceSelection === "conditional" && formData.emp_code.length === 0) {
    //         alert("No employees match your filter criteria. Please adjust your filters.");
    //         isSubmittingRef.current = false;
    //         return;
    //     }

    //     if (!formData.reason || formData.reason.length < 10) {
    //         alert("Reason must be at least 10 chars");
    //         isSubmittingRef.current = false;
    //         return;
    //     }

    //     // ---------------- PAYRUN OR TAX BASED VALIDATION ----------------
    //     const payrun = companyTimeLine?.last_salary_slip;
    //     const tax = companyTimeLine.last_tax_calculation;

    //     // if (formData.date && (payrun || tax)) {
    //     // if (formData.date && payrun) {
    //     if (formData.start_date && formData.end_date && payrun) {
    //         const selectedDate = new Date(formData.date);
    //         const selectedYear = selectedDate.getFullYear();
    //         const selectedMonth = selectedDate.getMonth() + 1;
    //         const selectedValue = selectedYear * 100 + selectedMonth;

    //         const payrunValue = payrun ? (payrun.year * 100 + payrun.month) : 0;
    //         const taxValue = tax ? (tax.year * 100 + tax.month) : 0;


    //         //   //  latest processed month
    //         // const lockValue = Math.max(payrunValue, taxValue);

    //         // let lockMonth = "";
    //         // let lockYear = "";

    //         // if (lockValue === payrunValue && payrun) {
    //         //     lockMonth = payrun.month;
    //         //     lockYear = payrun.year;
    //         // } else if (tax) {
    //         //     lockMonth = tax.month;
    //         //     lockYear = tax.year;
    //         // }

    //         // //  Block only past months
    //         // if (selectedValue < lockValue) {
    //         //     toast.warning(
    //         //         <span>
    //         //             You can't Regularize Attendance before{" "}
    //         //             <strong>{getMonthName(lockMonth)}-{lockYear}</strong>.
    //         //         </span>
    //         //     );
    //         //     isSubmittingRef.current = false;
    //         //     return;
    //         // }

    //         // Block only past months (before the payrun month)
    //         if (selectedValue < payrunValue) {
    //             toast.warning(
    //                 <span>
    //                     You can't Regularize Attendance before{" "}
    //                     <strong>{getMonthName(payrun.month)}-{payrun.year}</strong>.
    //                 </span>
    //             );
    //             isSubmittingRef.current = false;
    //             return;
    //         }

    //         // Also block if selected month is the same as payrun month? 
    //         // Usually you can't regularize for the same month either if payroll is already processed
    //         if (selectedValue === payrunValue) {
    //             toast.warning(
    //                 <span>
    //                     You can't Regularize Attendance for{" "}
    //                     <strong>{getMonthName(payrun.month)}-{payrun.year}</strong> as payroll is already processed.
    //                 </span>
    //             );
    //             isSubmittingRef.current = false;
    //             return;
    //         }
    //     }

    //     const dateList = getDatesInRange(formData.start_date, formData.end_date);
    //     setLoading(true);
    //     const loadingToastId = toast.loading("Loading: Please wait...");

    //     const empCodes = Array.isArray(formData.emp_code)
    //         ? formData.emp_code
    //         : [formData.emp_code];

    //     // const payload =
    //     //     employeeAttendanceSelection === "specific"
    //     //         ? {
    //     //             date: formData.date,
    //     //             emp_code: empCodes,
    //     //             day_status: formData.newDayStatus,
    //     //             attendance_status: formData.newAttendanceStatus,
    //     //             reason: formData.reason,
    //     //             updated_by: sessionStorage.getItem("emp_code"),
    //     //         }
    //     //         : {
    //     //             emp_code: empCodes,
    //     //             date: formData.date,
    //     //             day_status: formData.newDayStatus,
    //     //             attendance_status: formData.newAttendanceStatus,
    //     //             reason: formData.reason,
    //     //             updated_by: sessionStorage.getItem("emp_code"),
    //     //             filter_conditions: filters,
    //     //         };

    //     // try {
    //     //     const res = await axios.post(
    //     //         `${BASE_URL}/wfm/attendanceregularization-logs-upload/`,
    //     //         payload
    //     //     );

    //     //     if (res.status === 200 || res.status === 201) {
    //     //         await getAttendanceRegLogsData();
    //     //         setFormData(formData);
    //     //         setSelectedOptions([]);
    //     //         setShow(false);
    //     //         toast.success("Attendance added successfully!");
    //     //     } else {
    //     //         console.error(res);
    //     //     }
    //     // } catch (err) {
    //     //     handleErrorToast(err, loadingToastId);
    //     // } finally {
    //     //     setLoading(false);
    //     //     toast.dismiss(loadingToastId);
    //     //     isSubmittingRef.current = false;
    //     // }
    //     try {
    //         for (const singleDate of dateList) {
    //             const payload =
    //                 employeeAttendanceSelection === "specific"
    //                     ? {
    //                         date: singleDate,
    //                         emp_code: empCodes,
    //                         day_status: formData.newDayStatus,
    //                         attendance_status: formData.newAttendanceStatus,
    //                         reason: formData.reason,
    //                         updated_by: sessionStorage.getItem("emp_code"),
    //                     }
    //                     : {
    //                         emp_code: empCodes,
    //                         date: singleDate,
    //                         day_status: formData.newDayStatus,
    //                         attendance_status: formData.newAttendanceStatus,
    //                         reason: formData.reason,
    //                         updated_by: sessionStorage.getItem("emp_code"),
    //                         filter_conditions: filters,
    //                     };

    //             await axios.post(
    //                 `${BASE_URL}/wfm/attendanceregularization-logs-upload/`,
    //                 payload
    //             );
    //         }

    //         await getAttendanceRegLogsData();
    //         setFormData(formData);
    //         setSelectedOptions([]);
    //         setShow(false);
    //         toast.success("Attendance added successfully!");
    //     } catch (err) {
    //         handleErrorToast(err, loadingToastId);
    //     } finally {
    //         setLoading(false);
    //         toast.dismiss(loadingToastId);
    //         isSubmittingRef.current = false;
    //     }
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isSubmittingRef.current) return;
        isSubmittingRef.current = true;

        if (employeeAttendanceSelection === "conditional" && formData.emp_code.length === 0) {
            alert("No employees match your filter criteria. Please adjust your filters.");
            isSubmittingRef.current = false;
            return;
        }

        if (!formData.reason || formData.reason.length < 10) {
            alert("Reason must be at least 10 chars");
            isSubmittingRef.current = false;
            return;
        }

        if (!formData.start_date || !formData.end_date) {
            alert("Please select a valid date range");
            isSubmittingRef.current = false;
            return;
        }

        // ---------------- PAYRUN OR TAX BASED VALIDATION (checks both ends of range) ----------------
        const payrun = companyTimeLine?.last_salary_slip;
        const tax = companyTimeLine.last_tax_calculation;

        if (formData.start_date && formData.end_date && payrun) {
            const payrunValue = payrun ? (payrun.year * 100 + payrun.month) : 0;

            const getMonthValue = (dateStr) => {
                const d = new Date(dateStr);
                return d.getFullYear() * 100 + (d.getMonth() + 1);
            };

            const startValue = getMonthValue(formData.start_date);
            const endValue = getMonthValue(formData.end_date);

            // Block if any part of the range falls before or in the locked payrun month
            if (startValue <= payrunValue || endValue <= payrunValue) {
                toast.warning(
                    <span>
                        You can't Regularize Attendance for/before{" "}
                        <strong>{getMonthName(payrun.month)}-{payrun.year}</strong> as payroll is already processed.
                    </span>
                );
                isSubmittingRef.current = false;
                return;
            }
        }

        setLoading(true);
        const loadingToastId = toast.loading("Loading: Please wait...");

        const empCodes = Array.isArray(formData.emp_code)
            ? formData.emp_code
            : [formData.emp_code];

        // Build list of individual dates from the selected range
        const dateList = getDatesInRange(formData.start_date, formData.end_date);

        try {
            for (const singleDate of dateList) {
                const payload =
                    employeeAttendanceSelection === "specific"
                        ? {
                            date: singleDate,
                            emp_code: empCodes,
                            day_status: formData.newDayStatus,
                            attendance_status: formData.newAttendanceStatus,
                            reason: formData.reason,
                            updated_by: sessionStorage.getItem("emp_code"),
                        }
                        : {
                            emp_code: empCodes,
                            date: singleDate,
                            day_status: formData.newDayStatus,
                            attendance_status: formData.newAttendanceStatus,
                            reason: formData.reason,
                            updated_by: sessionStorage.getItem("emp_code"),
                            filter_conditions: filters,
                        };

                const res = await axios.post(
                    `${BASE_URL}/wfm/attendanceregularization-logs-upload/`,
                    payload
                );

                if (!(res.status === 200 || res.status === 201)) {
                    console.error(res);
                    throw new Error(`Failed for date ${singleDate}`);
                }
            }

            await getAttendanceRegLogsData();
            setFormData(formData);
            setSelectedOptions([]);
            setShow(false);
            toast.success("Attendance added successfully!");

        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
            isSubmittingRef.current = false;
        }
    };




    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            // date: "",
            // reason: "",
            emp_code: [],
            // newDayStatus: "",
            // newAttendanceStatus: "",
        }));
        setFilters({
            dayStatus: "",
            attendanceStatus: "",
            workHours: "",
            workHoursOperator: "equals",
            punchInTime: "",
            punchInOperator: "equals",
            punchOutTime: "",
            punchOutOperator: "equals"
        });
        setSelectedOptions([]);
        setFilteredEmpAttendances([]);
    }, [employeeAttendanceSelection]);



    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Enter") {
                const targetTag = e.target.tagName.toLowerCase();
                const isTextarea = targetTag === "textarea";
                const isInput = targetTag === "input";
                const isSubmitType = e.target.type === "submit";


                if (!isTextarea && (isInput || isSubmitType)) {
                    e.preventDefault();
                }
            }
        };

        if (show) {
            document.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [show]);

    const getDatesInRange = (start, end) => {
        const dates = [];
        let current = new Date(start);
        const last = new Date(end);
        while (current <= last) {
            const y = current.getFullYear();
            const m = String(current.getMonth() + 1).padStart(2, "0");
            const d = String(current.getDate()).padStart(2, "0");
            dates.push(`${y}-${m}-${d}`);
            current.setDate(current.getDate() + 1);
        }
        return dates;
    };

    return (
        <>
            <button className="upload-svg flex-row" onClick={handleShow}>
                <AddwithWhiteCircle /><span className="ms-1">Attendance Regularization</span>
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="five-sixth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Regularize Attendance </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-flex-wrap">
                        {SUPER_ADMIN && (
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Sub Company<span className="required">*</span>
                                </label>
                                <select
                                    name="sub_company"
                                    value={formData.sub_company}
                                    onChange={(e) => {
                                        setFormData((prev) => ({
                                            ...prev,
                                            sub_company: e.target.value,
                                            emp_code: [],
                                        }));
                                        setToggleCompany(e.target.value);
                                        setSelectedOptions([]);
                                        setFilteredEmpAttendances([]);
                                    }}
                                    className="form-input"
                                >
                                    <option value="">Select a Company</option>
                                    {SUB_COMPANIES?.map((i, index) => (
                                        <option key={index} value={i.id}>
                                            {i.title}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        )}

                        {/* <div className="flex-column"> */}
                        {/* <div className="flex-column"  >
                                <label htmlFor="date" className="form-labels font-weight500 font-size-subheading">
                                    Date <span className="required">*</span>
                                </label>
                                <input
                                    type="date"
                                    autoComplete="off"
                                    name="date"
                                    className={`form-input`}
                                    value={formData.date}
                                    onChange={handleInput}
                                    min={getMinAllowedDate()}
                                />
                            </div> */}
                        <div title=" Date Range" className="field-cont-div " style={{ minWidth: '600px' }}>
                            <DateRangePicker
                                startDate={startdate}
                                endDate={enddate}
                                placeHolder1="From Date"
                                placeHolder2="To Date"
                                usePortal={false}
                                onChange={(start, end) => {
                                    setStartDate(start || formattedDatee);
                                    setEndDate(end || formattedDate);
                                    setFormData(prev => ({
                                        ...prev,
                                        start_date: start || '',
                                        end_date: end || ''
                                    }))
                                }}
                            />
                            <hr className="field-cont-hr" />
                        </div>
                        {/* </div> */}

                        <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading">
                                New Status<span className="required">*</span>
                            </label>
                            <select
                                className="form-input"
                                value={`${formData.newDayStatus}-${formData.newAttendanceStatus}`}
                                onChange={(e) => {
                                    if (e.target.value) {
                                        const [dayStatus, attendanceStatus] = e.target.value.split('-');
                                        setFormData(prev => ({
                                            ...prev,
                                            newDayStatus: dayStatus,
                                            newAttendanceStatus: attendanceStatus
                                        }));
                                    } else {
                                        setFormData(prev => ({
                                            ...prev,
                                            newDayStatus: "",
                                            newAttendanceStatus: ""
                                        }));
                                    }
                                }}
                            >
                                <option value="">Select New Status</option>
                                {PAIRED_STATUS_OPTS.map((pair) => (
                                    <option
                                        key={`${pair.dayStatus}-${pair.attendanceStatus}`}
                                        value={`${pair.dayStatus}-${pair.attendanceStatus}`}
                                    >
                                        {pair.dayStatus} - {pair.attendanceStatus}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="leave-duration-tabs" style={{ width: "96%", position: "relative", display: "flex", marginBottom: "15px" }}>
                        <input
                            type="radio"
                            id="attendance-single-emp"
                            name="attendanceType"
                            value="specific"
                            checked={employeeAttendanceSelection === "specific"}
                            onChange={(e) => setEmployeeAttendanceSelection(e.target.value)}
                            hidden
                        />
                        <label htmlFor="attendance-single-emp" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                            Specific
                        </label>

                        <input
                            type="radio"
                            id="attendance-multi-emp"
                            name="attendanceType"
                            value="conditional"
                            checked={employeeAttendanceSelection === "conditional"}
                            onChange={(e) => setEmployeeAttendanceSelection(e.target.value)}
                            hidden
                        />
                        <label htmlFor="attendance-multi-emp" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
                            Conditional
                        </label>

                        <span
                            className="leave-tab-glider"
                            style={{
                                transform: employeeAttendanceSelection === "specific" ? "translateX(0%)" : "translateX(100%)",
                                width: "50%"
                            }}
                        ></span>
                    </div>

                    {employeeAttendanceSelection === "conditional" && (
                        <div className="form-flex-wrap" style={{ marginBottom: "15px" }}>

                            <div className="flex-column">
                                <label htmlFor="dayStatus" className="form-labels font-weight500 font-size-subheading">
                                    Day Status
                                </label>
                                <select
                                    name="dayStatus"
                                    value={filters.dayStatus}
                                    className={`form-input-date`}
                                    onChange={handleFilterChange}
                                >
                                    <option value="">Any Day Status</option>
                                    {DAY_STATUS_OPTS.map((v) => (
                                        <option key={v} value={v}>{v}</option>
                                    ))}
                                </select>
                            </div>


                            <div className="flex-column">
                                <label htmlFor="attendanceStatus" className="form-labels font-weight500 font-size-subheading">
                                    Attendance Status
                                </label>
                                <select
                                    name="attendanceStatus"
                                    value={filters.attendanceStatus}
                                    className={`form-input-date`}
                                    onChange={handleFilterChange}>
                                    <option value="">Any Attendance Status</option>
                                    {ATT_STATUS_OPTS.map((v) => (
                                        <option key={v} value={v}>{v}</option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Complete Status<span className="required">*</span>
                                </label>
                                <select
                                    className="form-input"
                                    value={`${filters.dayStatus}-${filters.attendanceStatus}`}
                                    onChange={(e) => {
                                        if (e.target.value) {
                                            const [dayStatus, attendanceStatus] = e.target.value.split('-');
                                            setFilters(prev => ({
                                                ...prev,
                                                dayStatus: dayStatus,
                                                attendanceStatus: attendanceStatus
                                            }));
                                        } else {
                                            setFilters(prev => ({
                                                ...prev,
                                                dayStatus: "",
                                                attendanceStatus: ""
                                            }));
                                        }
                                    }}
                                >
                                    <option value="">Select Complete Status</option>
                                    {PAIRED_STATUS_OPTS.map((pair) => (
                                        <option
                                            key={`${pair.dayStatus}-${pair.attendanceStatus}`}
                                            value={`${pair.dayStatus}-${pair.attendanceStatus}`}
                                        >
                                            {pair.dayStatus} - {pair.attendanceStatus}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="flex-column">
                                <label htmlFor="workHours" className="form-labels font-weight500 font-size-subheading">
                                    Work Hours
                                </label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    <select
                                        name="workHoursOperator"
                                        value={filters.workHoursOperator}
                                        className={`form-input-date`}
                                        onChange={handleFilterChange}
                                    // style={{ width: "30%" }}
                                    >
                                        <option value="less">&lt;</option>
                                        <option value="lessorequal">&le;</option>
                                        <option value="equals">=</option>
                                        <option value="greaterorequal">&ge;</option>
                                        <option value="greater">&gt;</option>
                                    </select>
                                    <input
                                        name="workHours"
                                        value={filters.workHours}
                                        min={0}
                                        placeholder="Hours" a
                                        onChange={handleFilterChange}
                                        className="form-input-date"
                                        type="number"
                                    // style={{ width: "70%" }}
                                    />
                                </div>
                            </div>

                            <div className="flex-column">
                                <label htmlFor="punchInTime" className="form-labels font-weight500 font-size-subheading">
                                    Punch In Time
                                </label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    <select
                                        name="punchInOperator"
                                        value={filters.punchInOperator}
                                        className={`form-input-date`}
                                        onChange={handleFilterChange}
                                    // style={{ width: "30%" }}
                                    >
                                        <option value="equals">At</option>
                                        <option value="after">After</option>
                                        <option value="before">Before</option>
                                    </select>
                                    <input
                                        name="punchInTime"
                                        value={filters.punchInTime}
                                        onChange={handleFilterChange}
                                        className="form-input-date"
                                        type="time"
                                    // style={{ width: "70%" }}
                                    />
                                </div>
                            </div>

                            <div className="flex-column">
                                <label htmlFor="punchOutTime" className="form-labels font-weight500 font-size-subheading">
                                    Punch Out Time
                                </label>
                                <div style={{ display: "flex", gap: "5px" }}>
                                    <select
                                        name="punchOutOperator"
                                        value={filters.punchOutOperator}
                                        className="form-input-date"
                                        onChange={handleFilterChange}
                                    // style={{ width: "30%" }}
                                    >
                                        <option value="equals">At</option>
                                        <option value="after">After</option>
                                        <option value="before">Before</option>
                                    </select>
                                    <input
                                        name="punchOutTime"
                                        value={filters.punchOutTime}
                                        onChange={handleFilterChange}
                                        className="form-input-date"
                                        type="time"
                                    // style={{ width: "70%" }}
                                    />
                                </div>
                            </div>

                        </div>
                    )}

                    <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading">
                            Select Employees<span className="required">*{!formData.start_date && '(Select Date First)'}</span>
                        </label>
                        {buffer1 ? (
                            <div className="form-loader">
                                <div className="bar-loader"></div>
                            </div>
                        ) : (
                            <Select
                                options={options}
                                isMulti
                                value={selectedOptions}
                                onChange={handleChangeEmpList}
                                isDisabled={employeeAttendanceSelection === "conditional" || !formData.start_date}

                                formatOptionLabel={(option, { context }) => {
                                    const empInList = empList.find(e => e.emp_code === option.value);
                                    const hasArrear = empInList?.arrear_details && empInList.arrear_details.length > 0;
                                    const arrearPeriod = hasArrear ? empInList.arrear_details[0].applicable_period : null;

                                    return (
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '98%' }}>
                                            <span>{option.label}</span>
                                            {hasArrear && arrearPeriod && (
                                                <span style={{
                                                    backgroundColor: '#ff4444',
                                                    color: 'white',
                                                    padding: '2px 5px',
                                                    borderRadius: '12px',
                                                    fontSize: '11px',
                                                    fontWeight: '500',
                                                    whiteSpace: 'nowrap'
                                                }}>
                                                    Arrear Applied in {arrearPeriod}
                                                </span>
                                            )}
                                        </div>
                                    );
                                }}

                                styles={{
                                    control: (provided) => ({
                                        ...provided,
                                        width: '98%',
                                        minHeight: '50px',
                                        borderRadius: '10px',
                                        border: '1px solid #e3e3e3',
                                        margin: '10px 0px 20px 0px',
                                        color: '#4a4a4a',
                                        backgroundColor: employeeAttendanceSelection === "conditional" ? '#f0f0f0' : '#f7f8fa',
                                        padding: '0px 10px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        borderRadius: '10px',
                                        marginTop: '0',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: '#4a4a4a',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isDisabled ? '#f5f5f5' : '',
                                        color: state.isDisabled ? '#999999' : '#4a4a4a',
                                        cursor: state.isDisabled ? 'not-allowed' : 'default',
                                        '&:hover': {
                                            backgroundColor: state.isDisabled ? '#f5f5f5' : '#f0f0f0',
                                        },
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                    }),

                                    multiValue: (provided, state) => {
                                        const empInList = empList.find(e => e.emp_code === state.data.value);
                                        const hasArrear = empInList?.arrear_details && empInList.arrear_details.length > 0;

                                        return {
                                            ...provided,
                                            backgroundColor: hasArrear ? '#ffebee' : '#e6e6e6',
                                            opacity: hasArrear ? 0.7 : 1,
                                        };
                                    },
                                }}
                            />
                        )}
                        {employeeAttendanceSelection === "conditional" && (
                            <div className="form-note">
                                <small>Employee selection is automatically populated based on your filter conditions.</small>
                            </div>
                        )}
                    </div>

                    {/* Show the same table for both modes */}

                    <div className="table-container">
                        <table className="table-css">
                            <thead>
                                <tr className="custom-table-head-tr">
                                    {employeeAttendanceSelection === "conditional" &&
                                        <th className="table-heading align-center">
                                            <label className="checkbox-click" style={{ height: '16px' }}>
                                                <input
                                                    type="checkbox"
                                                    checked={selectedOptions.length > 0 && selectedOptions.length === filteredEmpAttendances.length}
                                                    onChange={handleSelectAll}
                                                    disabled={filteredEmpAttendances.length === 0}
                                                />
                                                <div className="checkmark-medium "></div>
                                            </label>
                                        </th>
                                    }
                                    <th className="table-heading align-center">Employee</th>
                                    <th className="table-heading align-center">In Time</th>
                                    <th className="table-heading align-center">Out Time</th>
                                    <th className="table-heading align-center">Work Hours</th>
                                    <th className="table-heading align-center">Current Status</th>
                                    <th className="table-heading align-center">New Status</th>
                                </tr>
                            </thead>
                            <tbody className='align-center'>
                                {buffer2 ?
                                    <Loader container={true} /> :
                                    filteredEmpAttendances.length > 0 ? (
                                        filteredEmpAttendances.map((emp) => {
                                            const hasArrear = emp.arrear_details && emp.arrear_details.length > 0;
                                            return (
                                                <tr
                                                    key={emp.emp_code}
                                                    className="custom-table-head-td"
                                                    onClick={() => {
                                                        // Only trigger if not disabled and in conditional mode
                                                        if (employeeAttendanceSelection === "conditional" && !hasArrear) {
                                                            handleCheckboxChange(emp.emp_code);
                                                        }
                                                    }}
                                                    style={{
                                                        cursor: employeeAttendanceSelection === "conditional" && !hasArrear ? 'pointer' : 'default',
                                                        backgroundColor: hasArrear ? '#fff3f3' : 'transparent',
                                                    }}
                                                >
                                                    {employeeAttendanceSelection === "conditional" &&
                                                        <td className="align-center" onClick={(e) => e.stopPropagation()}>
                                                            {!hasArrear && <label className="checkbox-click" style={{ marginTop: '-3px' }}>
                                                                <input
                                                                    className="form-checkbox-nm"
                                                                    type="checkbox"
                                                                    checked={isEmployeeChecked(emp.emp_code)}
                                                                    onChange={() => handleCheckboxChange(emp.emp_code)}
                                                                    disabled={hasArrear}
                                                                />
                                                                <div className={`checkmark-medium ${hasArrear ? 'disabled' : ''}`}></div>
                                                                {/* <div className="checkmark-medium "></div> */}
                                                            </label>}
                                                        </td>}
                                                    <td className="align-center">
                                                        <div><span>{emp.emp_code}-{emp.name}</span></div>
                                                        {/* <div>
                                                        {emp?.regularization_logs?.length > 0 && (
                                                            <AttendanceReguralizationTable Ondate={emp?.date} AttendanceData={emp} RegularizationData={emp?.regularization_logs} />
                                                        )}
                                                    </div> */}
                                                        <div>
                                                            {(emp?.regularization_logs?.length > 0 || emp?.arrear_details) && (
                                                                <AttendanceExtraDetailsTable
                                                                    Ondate={emp?.date}
                                                                    AttendanceData={emp}
                                                                    RegularizationData={emp?.regularization_logs?.length > 0 ? emp.regularization_logs : undefined}
                                                                    ArrearData={emp?.arrear_details || undefined}
                                                                />
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td className="align-center">{emp.in_time || "-"}</td>
                                                    <td className="align-center">{emp.out_time || "-"}</td>
                                                    <td className="align-center">{emp.work_duration}</td>
                                                    <td className="align-center attendance-status" data-status={emp.day_status}>
                                                        {emp.day_status} - {emp.attendence_status}
                                                    </td>
                                                    <td className="align-center attendance-status" data-status={formData.newDayStatus}>
                                                        {formData.newDayStatus} - {formData.newAttendanceStatus}
                                                    </td>
                                                </tr>
                                            )
                                        }
                                        )
                                    ) : (
                                        <tr>
                                            <td colSpan="7" className="align-center">
                                                {!formData.start_date && "Please select a date first, "}
                                                {/* {formData.emp_code.length == 0 && "No Employee selected"} */}
                                                {formData.start_date && employeeAttendanceSelection === "specific" && "No employees selected"}
                                                {formData.start_date && employeeAttendanceSelection === "conditional" && "No employees match your filter criteria"}
                                            </td>
                                        </tr>

                                    )
                                }
                            </tbody>
                        </table>
                    </div>


                    <div className="form-flex-wrap">
                        <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading">Reason:<span className="required">*</span></label>
                            <textarea
                                id="reason"
                                name="reason"
                                placeholder="Your Reason (minimum 10 characters)"
                                className="form-input-textarea"
                                value={formData.reason}
                                onChange={handleInput}
                            // rows="3"
                            />
                        </div>
                    </div>

                    <div className="button-models">
                        <button
                            type="button"
                            className="model-button model-button-cancel font-weight500"
                            onClick={handleClose}
                        >
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="model-button model-button-leave font-weight500 font-size-heading"
                            onClick={handleSubmit}
                            disabled={loading}
                        >
                            {loading ? "Processing..." : "Submit"}
                        </button>
                    </div>
                </Modal.Body>
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
            </Modal >
        </>
    );
};



const AttReguralizeUpdate = ({ i, SUPER_ADMIN, SUB_COMPANIES, getAttendanceRegLogsData }) => {
    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        reason: i.reason || "",
    });

    const DAY_STATUS_OPTS = [
        "absent", "halfday", "halfdayleave", "hdoutduty", "holiday", "late", "paidleave",
        "misspunch", "ontime", "outduty", "rlm", "shortleave", "shortoutduty",
        "unpaidleavehd", "unpaidleave", "unpaidshortleave", "weeklyoff", "wop"
    ];
    const ATT_STATUS_OPTS = ["leave", "absent", "holiday", "weeklyoff", "present"];

    const PAIRED_STATUS_OPTS = [
        { dayStatus: "shortleave", attendanceStatus: "leave" },
        { dayStatus: "halfdayleave", attendanceStatus: "leave" },
        { dayStatus: "paidleave", attendanceStatus: "leave" },
        { dayStatus: "unpaidshortleave", attendanceStatus: "leave" },
        { dayStatus: "unpaidleavehd", attendanceStatus: "leave" },
        { dayStatus: "unpaidleave", attendanceStatus: "leave" },
        { dayStatus: "absent", attendanceStatus: "absent" },
        { dayStatus: "misspunch", attendanceStatus: "present" },
        { dayStatus: "late", attendanceStatus: "present" },
        { dayStatus: "halfday", attendanceStatus: "present" },
        { dayStatus: "ontime", attendanceStatus: "present" },
        { dayStatus: "rlm", attendanceStatus: "present" },
        { dayStatus: "shortoutduty", attendanceStatus: "present" },
        { dayStatus: "hdoutduty", attendanceStatus: "present" },
        { dayStatus: "outduty", attendanceStatus: "present" },
        { dayStatus: "wop", attendanceStatus: "present" },
        { dayStatus: "weeklyoff", attendanceStatus: "weeklyoff" },
        { dayStatus: "holiday", attendanceStatus: "holiday" },
    ];

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleInput = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleStatusChange = (e) => {
        if (e.target.value) {
            const [dayStatus, attendanceStatus] = e.target.value.split('-');
            setFormData(prev => ({
                ...prev,
                newDayStatus: dayStatus,
                newAttendanceStatus: attendanceStatus
            }));
        } else {
            setFormData(prev => ({
                ...prev,
                newDayStatus: "",
                newAttendanceStatus: ""
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.reason || formData.reason.length < 10) {
            alert("Reason must be at least 10 characters");
            return;
        }

        setLoading(true);
        const loadingToastId = toast.loading("Updating: Please wait...");

        try {
            const payload = {
                reason: formData.reason,
                updated_by: sessionStorage.getItem('emp_code'),
            };

            const res = await axios.put(
                `${BASE_URL}/wfm/attendanceregularization/${i.id}/`,
                payload
            );

            if (res.status === 200 || res.status === 201) {
                await getAttendanceRegLogsData();
                setShow(false);
                toast.success("Attendance updated successfully!");
            } else {
                console.error(res);
                toast.error("Failed to update attendance");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                title="Update log"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Attendance Regularization Log</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Update Attendance log of <b>{i.emp_name}({i.emp_code})</b>
                        <br />
                        <table className="custom-att-table vertical-table">
                            <tbody>
                                <tr>
                                    <th>Date</th>
                                    <td>{formattedDateLong(i.date)}</td>
                                </tr>
                                <tr>
                                    <th>In-Time</th>
                                    <td>{i.previous_attendance_data?.in_time || '-'}</td>
                                </tr>
                                <tr>
                                    <th>Out-Time</th>
                                    <td>{i.previous_attendance_data?.out_time || '-'}</td>
                                </tr>
                                <tr>
                                    <th>Work Duration</th>
                                    <td>{i.previous_attendance_data?.work_duration || '-'}</td>
                                </tr>
                                <tr>
                                    <th>Previous Status</th>
                                    <td className="align-center">
                                        <span
                                            className="attendance-status"
                                            data-status={i.previous_day_status}
                                        >
                                            {i.previous_day_status || '-'}
                                        </span>
                                        {' - '}
                                        {i.previous_attendance_status && (
                                            <span
                                                className="attendance-status"
                                                data-status={i.previous_attendance_status}
                                            >
                                                {i.previous_attendance_status || '-'}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Current Updated Status</th>
                                    <td className="align-center">
                                        <span
                                            className="attendance-status"
                                            data-status={i.updated_attendance_data?.day_status}
                                        >
                                            {i.updated_attendance_data?.day_status || '-'}
                                        </span>
                                        {' - '}
                                        {i.updated_attendance_status && (
                                            <span
                                                className="attendance-status"
                                                data-status={i.updated_attendance_status}
                                            >
                                                {i.updated_attendance_status || '-'}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <div style={{ marginTop: '20px' }}>
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Reason:<span className="required">*</span>
                                </label>
                                <textarea
                                    name="reason"
                                    placeholder="Update reason (minimum 10 characters)"
                                    className="form-input-textarea"
                                    value={formData.reason}
                                    onChange={handleInput}
                                    rows="3"
                                />
                            </div>
                        </div>

                        <div className="button-models">
                            <button
                                className="model-button font-weight500 model-button-cancel"
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleSubmit}
                                className="model-button font-weight500 model-button-leave"
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
        </>
    );
};

const AttReguralizeDelete = ({ i, getAttendanceRegLogsData }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/wfm/attendanceregularization/${i.id}/`
            );

            if (res.status === 200) {
                await getAttendanceRegLogsData();
                setShow(false);
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Attendance Regularization Log</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Attendance log of <b>{i.emp_name}({i.emp_code})</b>
                        <br />
                        <table className="custom-att-table vertical-table">
                            <tbody>
                                <tr>
                                    <th>Date</th>
                                    <td>{formattedDateLong(i.date)}</td>
                                </tr>
                                <tr>
                                    <th>In-Time</th>
                                    <td>{i.previous_attendance_data?.in_time}</td>
                                </tr>
                                <tr>
                                    <th>Out-Time</th>
                                    <td>{i.previous_attendance_data?.out_time}</td>
                                </tr>
                                <tr>
                                    <th>Work Duration</th>
                                    <td>{i.previous_attendance_data?.work_duration}</td>
                                </tr>
                                <tr>
                                    <th>Previous Status</th>
                                    {/* <td data-status={i.day_status} className="attendance-status">{i.day_status}</td> */}
                                    <td className="align-center">
                                        <span
                                            className="attendance-status"
                                            data-status={i.previous_day_status}
                                        >
                                            {i.previous_day_status || '-'}
                                        </span>
                                        {' - '}
                                        {i.previous_attendance_status && (
                                            <span
                                                className="attendance-status"
                                                data-status={i.previous_attendance_status}
                                            >
                                                {i.previous_attendance_status || '-'}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Updated Status</th>
                                    {/* <td data-status={i.attendence_status} className="attendance-status" >{i.attendence_status}</td> */}
                                    <td className="align-center">
                                        <span
                                            className="attendance-status"
                                            data-status={i.updated_attendance_data?.day_status}
                                        >
                                            {i.updated_attendance_data?.day_status || '-'}
                                        </span>
                                        {' - '}
                                        {i.updated_attendance_status && (
                                            <span
                                                className="attendance-status"
                                                data-status={i.updated_attendance_status}
                                            >
                                                {i.updated_attendance_status || '-'}
                                            </span>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Reason</th>
                                    <td>{i.reason}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div className="button-models">
                            <button className="model-button  font-weight500  model-button-cancel  " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button  font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};

const StarperformanceAdd = ({ getperformance }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        emp_code: "",
        title: "",
        date: "",
        reason_for_recogntion: "",
        recognized_by: "",
        image_reward: "",
        total_awards: "",
        sub_company: sessionStorage.getItem('company_id'),
    });
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const newErrors = {};
    const validateForm = () => {
        const requiredFields = [
            "emp_code",
            "title",
            "date",
            "reason_for_recogntion",
            "recognized_by",
            "image_reward",
            "total_awards",
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    //******************Valedation End*********************** */
    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const formDataa = new FormData();
            formDataa.append("emp_code", formData.emp_code);
            formDataa.append("title", formData.title);
            formDataa.append("date", formData.date);
            formDataa.append("reason_for_recogntion", formData.reason_for_recogntion);
            formDataa.append("recognized_by", formData.recognized_by);
            formDataa.append("total_awards", formData.total_awards);
            formDataa.append("sub_company", formData.sub_company);


            try {
                const originalFile = formData.image_reward;
                if (originalFile) {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("image_reward", customFile);
                }
                let res = await axios.post(`${BASE_URL}/wfm/performance/`, formDataa, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (res.status === 200) {
                    await getperformance();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };


    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };


    return (
        <>

            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />{" "}Star Performance
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Star preformance Add</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="flex-column">
                                <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                                    Emp Code
                                </label>
                                <input
                                    type="text"
                                    id="emp_code"
                                    name="emp_code"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.emp_code}
                                    className={`form-input form-input-background ${errors.emp_code
                                        ? "error"
                                        : inputState.emp_code
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.emp_code && (
                                    <span className="error-message font-size-text ">{errors.emp_code}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">{errors.title}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                                    Date
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.date}
                                    className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                                        }`}
                                />
                                {errors.date && (
                                    <span className="error-message font-size-text ">{errors.date}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="reason_for_recogntion" className="form-labels  font-weight500    font-size-subheading">
                                    Reason for recogntion
                                </label>
                                <input
                                    type="text"
                                    id="reason_for_recogntion"
                                    name="reason_for_recogntion"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.reason_for_recogntion}
                                    className={`form-input form-input-background ${errors.reason_for_recogntion
                                        ? "error"
                                        : inputState.reason_for_recogntion
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.reason_for_recogntion && (
                                    <span className="error-message font-size-text ">
                                        {errors.reason_for_recogntion}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="recognized_by" className="form-labels  font-weight500    font-size-subheading">
                                    Recognized by
                                </label>
                                <input
                                    type="text"
                                    id="recognized_by"
                                    name="recognized_by"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.recognized_by}
                                    className={`form-input form-input-background ${errors.recognized_by
                                        ? "error"
                                        : inputState.recognized_by
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.recognized_by && (
                                    <span className="error-message font-size-text ">{errors.recognized_by}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label
                                    htmlFor="image_reward"
                                    className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
                                >
                                    Image reward
                                </label>
                                <div
                                    className={`file-upload-container flex-row justify-between file-in-upload`}
                                >
                                    <label
                                        className="popup-label"
                                        htmlFor="image_reward"
                                    >
                                        <CloudUpload />
                                        <span className="truncate-url">
                                            {formData?.image_reward
                                                ? formData?.image_reward instanceof File
                                                    ? formData?.image_reward.name
                                                    : getFileNameFromUrl(formData?.image_reward)
                                                : "No file selected"}
                                        </span>
                                    </label>
                                    <input
                                        type="file"
                                        id="image_reward"
                                        name="image_reward"
                                        accept=".jpg, .jpeg, .png"
                                        onChange={handleFileChange}
                                        className="popup-input"

                                    />
                                    {formData?.image_reward && (
                                        <span
                                            className="file-clear"
                                            onClick={() => handleFileClear("image_reward")}
                                        >
                                            Clear
                                        </span>
                                    )}
                                    {errors.image_reward && (
                                        <span className="error-message font-size-text ">
                                            {errors.image_reward}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="flex-column">
                                <label htmlFor="total_awards" className="form-labels  font-weight500    font-size-subheading">
                                    Total awards
                                </label>
                                <input
                                    type="number"
                                    id="total_awards"
                                    name="total_awards"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.total_awards}
                                    className={`form-input form-input-background ${errors.total_awards
                                        ? "error"
                                        : inputState.total_awards
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.total_awards && (
                                    <span className="error-message font-size-text ">{errors.total_awards}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button  model-button-cancel font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const StarperformanceUpdate = ({ i, getperformance }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        emp_code: "",
        title: "",
        date: "",
        reason_for_recogntion: "",
        recognized_by: "",
        image_reward: "",
        total_awards: "",
        sub_company: sessionStorage.getItem('company_id'),
    });
    console.log(formData);

    useEffect(() => {
        setFormData(i);
    }, [i]);

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "emp_code",
            "title",
            "date",
            "reason_for_recogntion",
            "recognized_by",
            "image_reward",
            "total_awards",
        ];
        console.log(requiredFields);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    //******************Valedation End*********************** */

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const formDataa = new FormData();
            formDataa.append("emp_code", formData.emp_code);
            formDataa.append("title", formData.title);
            formDataa.append("date", formData.date);
            formDataa.append("reason_for_recogntion", formData.reason_for_recogntion);
            formDataa.append("recognized_by", formData.recognized_by);
            formDataa.append("total_awards", formData.total_awards);
            formDataa.append("sub_company", formData.sub_company);


            try {
                const originalFile = formData.image_reward;
                if (originalFile) {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("image_reward", customFile);
                }
                let res = await axios.put(
                    `${BASE_URL}/wfm/performance/${i.id}/`,
                    formDataa,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    await getperformance();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {

                handleErrorToast(err, loadingToastId)

            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };

    const getFileNameFromUrl = (url) => {
        const urlParts = url.split("/");
        return urlParts[urlParts.length - 1].split("?")[0];
    };

    return (
        <>
            <button
                title="Update Popup Display"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Star preformance Update</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Star preformance</h6>
                            <div className="flex-column">
                                <label htmlFor="emp_code" className="form-labels  font-weight500    font-size-subheading">
                                    Emp Code
                                </label>
                                <input
                                    type="text"
                                    id="emp_code"
                                    name="emp_code"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.emp_code}
                                    className={`form-input form-input-background ${errors.emp_code
                                        ? "error"
                                        : inputState.emp_code
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.emp_code && (
                                    <span className="error-message font-size-text ">{errors.emp_code}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">{errors.title}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                                    Date
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.date}
                                    className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                                        }`}
                                />
                                {errors.date && (
                                    <span className="error-message font-size-text ">{errors.date}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="reason_for_recogntion" className="form-labels  font-weight500    font-size-subheading">
                                    Reason for recogntion
                                </label>
                                <input
                                    type="text"
                                    id="reason_for_recogntion"
                                    name="reason_for_recogntion"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.reason_for_recogntion}
                                    className={`form-input form-input-background ${errors.reason_for_recogntion
                                        ? "error"
                                        : inputState.reason_for_recogntion
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.reason_for_recogntion && (
                                    <span className="error-message font-size-text ">
                                        {errors.reason_for_recogntion}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="recognized_by" className="form-labels  font-weight500    font-size-subheading">
                                    Recognized by
                                </label>
                                <input
                                    type="text"
                                    id="recognized_by"
                                    name="recognized_by"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.recognized_by}
                                    className={`form-input form-input-background ${errors.recognized_by
                                        ? "error"
                                        : inputState.recognized_by
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.recognized_by && (
                                    <span className="error-message font-size-text ">{errors.recognized_by}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="image_reward" className="form-labels  font-weight500     ">
                                    Image reward
                                </label>
                                <input
                                    type="file"
                                    name="image_reward"
                                    accept=".jpg, .jpeg, .png"
                                    autoComplete="off"
                                    onChange={handleFileChange}
                                    className="file-input"
                                />
                                {errors.image_reward && (
                                    <span className="error-message font-size-text ">{errors.image_reward}</span>
                                )}

                                {formData.attachment ? (
                                    <span
                                        className="file-clear"
                                        onClick={() => handleFileClear("attachment")}
                                    >
                                        Clear
                                    </span>
                                ) : null}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="total_awards" className="form-labels  font-weight500    font-size-subheading">
                                    Total awards
                                </label>
                                <input
                                    type="text"
                                    id="total_awards"
                                    name="total_awards"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.total_awards}
                                    className={`form-input form-input-background ${errors.total_awards
                                        ? "error"
                                        : inputState.total_awards
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.total_awards && (
                                    <span className="error-message font-size-text ">{errors.total_awards}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const StarperformanceDelete = ({ i, getperformance }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(`${BASE_URL}/wfm/performance/${i.id}/`);

            if (res.status === 200) {
                await getperformance();
                setShow(false);
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Starperformance {i.emp_code}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {i.title}
                        <div className="button-models">
                            <button className="model-button  model-button-cancel font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const EventAdd = ({ getevent }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        file: "",
        date: "",
        title: "",
        description: "",
        sub_company: sessionStorage.getItem('company_id'),
    });
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["file", "title", "date", "description"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    //******************Valedation End*********************** */
    const [loading, setLoading] = useState(false); //loading logic
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const formDataa = new FormData();
            formDataa.append("date", formData.date);
            formDataa.append("title", formData.title);
            formDataa.append("description", formData.description);
            formDataa.append("sub_company", formData.sub_company);
            try {
                const originalFile = formData.file;
                if (originalFile) {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("file", customFile);
                }

                let res = await axios.post(
                    `${BASE_URL}/settings/eventAPI/`,
                    formDataa,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    await getevent();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
                setLoading(false); //loading logic
            }
        }
    };
    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle />{" "}Event
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Event</h6>
                            <div className="flex-column">
                                <label htmlFor="file" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Event Image
                                </label>
                                <input
                                    type="file"
                                    name="file"
                                    accept=".jpg, .jpeg, .png"
                                    onChange={handleFileChange}
                                    className="file-input"
                                />
                                {formData.attachment ? (
                                    <span
                                        className="file-clear"
                                        onClick={() => handleFileClear("attachment")}
                                    >
                                        Clear
                                    </span>
                                ) : null}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                                    Date
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.date}
                                    className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                                        }`}
                                />
                                {errors.date && (
                                    <span className="error-message font-size-text ">{errors.date}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    autoComplete="off"
                                    maxLength={50}
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">{errors.title}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="description" className="form-labels  font-weight500    font-size-subheading">
                                    Description
                                </label>
                                <textarea
                                    type="text"
                                    id="description"
                                    name="description"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.description}
                                    className={`form-input-textarea   font-weight400  form-input form-input-background ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text ">{errors.description}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const EventUpdate = ({ i, getevent }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        file: "",
        date: "",
        title: "",
        description: "",
        sub_company: sessionStorage.getItem('company_id'),
    });

    console.log(formData);
    useEffect(() => {
        setFormData(i);
    }, [i]);
    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["file", "title", "description"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    //******************Valedation End*********************** */
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait...");

            const formDataa = new FormData();
            formDataa.append("date", formData.date);
            formDataa.append("title", formData.title);
            formDataa.append("description", formData.description);
            formDataa.append("sub_company", formData.sub_company);

            try {
                const originalFile = formData.file;
                if (originalFile) {
                    const customFile = generateCustomFileForUpload(originalFile, 'Aimantra');
                    formDataa.append("file", customFile);
                }


                let res = await axios.put(
                    `${BASE_URL}/settings/eventAPI/${i.id}/`,
                    formDataa,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );

                if (res.status === 200) {
                    await getevent();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button
                title="Update Popup Display"
                className="model-edit-button-ml"
                onClick={handleShow}
            >
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Event</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Event</h6>

                            <div className="flex-column">
                                <label htmlFor="file" className="form-labels  font-weight500     ">
                                    Event Image
                                </label>
                                <input
                                    type="file"
                                    name="file"
                                    accept=".jpg, .jpeg, .png"
                                    autoComplete="off"
                                    onChange={handleFileChange}
                                    className="file-input"
                                />
                                {errors.file && (
                                    <span className="error-message font-size-text ">{errors.file}</span>
                                )}

                                {formData.attachment ? (
                                    <span
                                        className="file-clear"
                                        onClick={() => handleFileClear("attachment")}
                                    >
                                        Clear
                                    </span>
                                ) : null}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="title" className="form-labels  font-weight500    font-size-subheading">
                                    Title
                                </label>
                                <input
                                    type="text"
                                    id="title"
                                    name="title"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.title}
                                    className={`form-input form-input-background ${errors.title ? "error" : inputState.title ? "success" : ""
                                        }`}
                                />
                                {errors.title && (
                                    <span className="error-message font-size-text ">{errors.title}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="description" className="form-labels  font-weight500    font-size-subheading">
                                    Description
                                </label>
                                <textarea
                                    type="text"
                                    id="description"
                                    name="description"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.description}
                                    className={`form-input-textarea   font-weight400  form-input form-input-background ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text ">{errors.description}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button  model-button-cancel font-weight500   " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const EventDelete = ({ i, getevent }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

        try {
            let res = await axios.delete(`${BASE_URL}/settings/eventAPI/${i.id}/`);

            if (res.status === 200) {
                await getevent();
                setShow(false);
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Starperformance {i.emp_code}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete {i.title}
                        <div className="button-models">
                            <button className="model-button  model-button-cancel font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const Importantmessage = ({ getmessage }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        date: "",
        message: "",
        sub_company: sessionStorage.getItem('company_id'),
    });

    //**************************valedation Start**************** */
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["date", "message"];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    //**************************valedation End**************** */
    const [loading, setLoading] = useState(false); //loading logic
    const [buffer, setBuffering] = useState(true); //buffering logic

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true); //loading logic
            setBuffering(true); //buffering logic // Start Buffering
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.post(
                    // `${BASE_URL}/settings/informationboardmailAPI/`,
                    `${BASE_URL}/settings/imformation-filter/${sessionStorage.getItem('company_id')}/`,
                    formData
                );

                if (res.status === 200) {
                    await getmessage();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false); //loading logic
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button className="upload-svg" onClick={handleShow}>
                <AddwithWhiteCircle /> Important Message
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Important message</h6>

                            <div className="flex-column">
                                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                                    Date
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.date}
                                    className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                                        }`}
                                />
                                {errors.date && (
                                    <span className="error-message font-size-text ">{errors.date}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="message" className="form-labels  font-weight500    font-size-subheading">
                                    Message
                                </label>
                                <textarea
                                    placeholder="Text message"
                                    type="text"
                                    maxLength={1500}
                                    name="message"
                                    onChange={handleInputChange}
                                    value={formData.message}
                                    className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.message
                                        ? "error"
                                        : inputState.message
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.message && (
                                    <span className="error-message font-size-text ">{errors.message}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const ImportantmessageUpdate = ({ i, getmessage }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [formData, setFormData] = useState({
        date: "",
        message: "",
        sub_company: sessionStorage.getItem('company_id'),
    });

    useEffect(() => {
        setFormData(i);
    }, [i]);

    //******************Valedation Start********************* */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["date", "message"];
        console.log(requiredFields);
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    //******************Valedation End*********************** */
    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            try {
                let res = await axios.put(
                    `${BASE_URL}/settings/importantnotificationAPI/${i.id}/`,
                    formData
                );

                if (res.status === 200) {
                    await getmessage();
                    setShow(false);
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button className="model-edit-button-ml" onClick={handleShow}>
                <UpdatePencil />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                {/* <Modal.Header closeButton>
          <Modal.Title>Request Leave</Modal.Title>
        </Modal.Header> */}
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <h6 className="task-Tab-heading   font-weight500    font-size-heading">Important message</h6>

                            <div className="flex-column">
                                <label htmlFor="date" className="form-labels  font-weight500    font-size-subheading">
                                    Date
                                </label>
                                <input
                                    type="date"
                                    id="date"
                                    name="date"
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    value={formData.date}
                                    className={`form-input form-input-background ${errors.date ? "error" : inputState.date ? "success" : ""
                                        }`}
                                />
                                {errors.date && (
                                    <span className="error-message font-size-text ">{errors.date}</span>
                                )}
                            </div>

                            <div className="flex-column">
                                <label htmlFor="message" className="form-labels  font-weight500    font-size-subheading">
                                    Message
                                </label>
                                <textarea
                                    placeholder="Text message"
                                    maxLength={200}
                                    type="text"
                                    name="message"
                                    onChange={handleInputChange}
                                    value={formData.message}
                                    className={`form-input-textarea   font-weight400  font-size-subheading form-input-background ${errors.message
                                        ? "error"
                                        : inputState.message
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.message && (
                                    <span className="error-message font-size-text ">{errors.message}</span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const ImportantmessageDelete = ({ i, getmessage }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleFormSubmitDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
        try {
            let res = await axios.delete(
                `${BASE_URL}/settings/importantnotificationAPI/${i.id}/`
            );

            if (res.status === 200) {
                await getmessage();
                setShow(false);
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId)
        } finally {
            toast.dismiss(loadingToastId);
        }
    };
    return (
        <>
            <button className="model-delete-button" onClick={handleShow}>
                <DeleteDustbin />
            </button>
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Delete Message {i.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Message {i.title}
                        <div className="button-models">
                            <button className="model-button  model-button-cancel font-weight500    " onClick={handleClose}>
                                Cancel
                            </button>
                            <button
                                onClick={handleFormSubmitDelete}
                                className="model-button   font-weight500    model-button-delete"
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};


const AttendanceReguralizationTable = ({ Ondate, AttendanceData, RegularizationData, button_varient, button_display_name }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setShow(true);
    };


    return (
        <>
            <button title="View Regularized Data" className="model-partial-button backgroundColor-none mt-1" onClick={handleShow}>
                {/* <WarnYellow /> */}<AttendanceReguralizeicon />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="four-fifth-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Attendance Reguralization of "{AttendanceData.emp_code}-{AttendanceData.name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body className="att-modal-body">
                    <div className="parent-div">
                        <div className="flex-row">
                            <table className="custom-att-table vertical-table att-custom-table">
                                <thead>
                                    <tr>
                                        {/* <th>Employee Code</th> */}
                                        <th>Sr.</th>
                                        <th>Date</th>
                                        <th>In Time</th>
                                        <th>Out Time</th>
                                        <th>Work Duration</th>
                                        <th>Previous Status</th>
                                        <th>Updated Status</th>
                                        <th>Updated By</th>
                                        <th>Reason</th>
                                    </tr>
                                    {/* <tr>
                                        <th>Status</th>
                                    </tr> */}
                                </thead>
                                <tbody>
                                    {RegularizationData
                                        ?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                                        ?.map((record, index) => (
                                            <tr key={index}>
                                                <td >{index + 1}</td>
                                                <td className="width-5vw">{formatDate(Ondate)}</td>
                                                <td>{record.updated_attendance_data?.in_time || '-'}</td>
                                                <td>{record.updated_attendance_data?.out_time || '-'}</td>
                                                <td>{record.updated_attendance_data?.work_duration || '0'}</td>

                                                <td className="align-center">
                                                    <span
                                                        className="attendance-status"
                                                        data-status={record.previous_day_status}
                                                    >
                                                        {record.previous_day_status || '-'}
                                                    </span>
                                                    {' - '}
                                                    {record.previous_attendance_status && (
                                                        <span
                                                            className="attendance-status"
                                                            data-status={record.previous_attendance_status}
                                                        >
                                                            {record.previous_attendance_status || '-'}
                                                        </span>
                                                    )}
                                                </td>

                                                <td className="align-center">
                                                    <span
                                                        className="attendance-status"
                                                        data-status={record.updated_attendance_data?.day_status}
                                                    >
                                                        {record.updated_attendance_data?.day_status || '-'}
                                                    </span>
                                                    {' - '}
                                                    {record.updated_attendance_status && (
                                                        <span
                                                            className="attendance-status"
                                                            data-status={record.updated_attendance_status}
                                                        >
                                                            {record.updated_attendance_status || '-'}
                                                        </span>
                                                    )}
                                                </td>
                                                <td>{record.updated_by}-{record.updated_by_name}</td>
                                                <td>{record.reason || '-'}</td>
                                            </tr>
                                        ))}
                                </tbody>

                            </table>


                        </div>
                    </div>
                </Modal.Body>
            </Modal >
        </>
    )
}


const AttendanceExtraDetailsTable = ({ Ondate, AttendanceData, RegularizationData, ArrearData, button_varient, button_display_name }) => {

    const [show, setShow] = useState(false);
    const handleClose = () => {
        setShow(false)
    };
    const handleShow = () => {
        setShow(true);
    };

    const getDependentLabel = (i) => {

        if (i.amount !== null && Number(i.amount) > 0) {
            return `${formatCurrencyIndian(i.amount)}`;
        }


        if (i.start_date && i.end_date) {
            return `${formattedDateLong(i.start_date)} to ${formattedDateLong(i.end_date)}`;
        }

        if (Array.isArray(i.date_list) && i.date_list.length > 0) {

            const formattedDates = i.date_list.map(d => formattedDateLong(d));

            const shortDisplay =
                formattedDates.length > 3
                    ? formattedDates.slice(0, 3).join(", ") + "..."
                    : formattedDates.join(", ");

            return shortDisplay;
        }

        return "-";
    };


    const getTooltipContent = (i) => {


        if (i.amount !== null && Number(i.amount) > 0) {
            return (
                <div>
                    <strong>Amount:</strong> {i.amount}
                </div>
            );
        }


        if (i.start_date && i.end_date) {
            return (
                <div>
                    <div>
                        {formattedDateLong(i.start_date)} to {formattedDateLong(i.end_date)}
                    </div>
                    <div>
                        ({i.days_calculated} days)
                    </div>
                </div>
            );
        }


        if (Array.isArray(i.date_list) && i.date_list.length > 0) {
            return (
                <div>
                    <ul style={{ paddingLeft: "18px", margin: 0, textAlign: 'left' }}>
                        {i.date_list.map((d, index) => (
                            <li key={index}>
                                {formattedDateLong(d)}
                            </li>
                        ))}
                    </ul>
                    <div style={{ marginTop: "4px" }}>
                        ({i.date_list.length} days)
                    </div>
                </div>
            );
        }

        return null;
    };

    return (
        <>
            <button title="View Regularized Data" className="model-partial-button backgroundColor-none" onClick={handleShow}>
                <InfoIcon />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="four-fifth-modal">
                {RegularizationData &&
                    <>
                        <Modal.Header>
                            <Modal.Title>Attendance Reguralization of "{AttendanceData.emp_code}-{AttendanceData.name}" for "{formattedDateLong(Ondate)}"</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="att-modal-body">
                            <div className="parent-div">
                                <div className="scroll-container-model">
                                    <table className="custom-att-table vertical-table att-custom-table">
                                        <thead>
                                            <tr>
                                                {/* <th>Employee Code</th> */}
                                                <th>Sr.</th>
                                                {/* <th>Date</th> */}
                                                <th>In Time</th>
                                                <th>Out Time</th>
                                                <th>Work Duration</th>
                                                <th>Previous Status</th>
                                                <th>Updated Status</th>
                                                <th>Updated By</th>
                                                <th>Reason</th>
                                            </tr>
                                            {/* <tr>
                                        <th>Status</th>
                                    </tr> */}
                                        </thead>
                                        <tbody>
                                            {RegularizationData
                                                ?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                                                ?.map((record, index) => (
                                                    <tr key={index}>
                                                        <td >{index + 1}</td>
                                                        {/* <td className="width-5vw">{formatDate(Ondate)}</td> */}
                                                        <td>{record.updated_attendance_data?.in_time || '-'}</td>
                                                        <td>{record.updated_attendance_data?.out_time || '-'}</td>
                                                        <td>{record.updated_attendance_data?.work_duration || '0'}</td>

                                                        <td className="align-center">
                                                            <span
                                                                className="attendance-status"
                                                                data-status={record.previous_day_status}
                                                            >
                                                                {record.previous_day_status || '-'}
                                                            </span>
                                                            {' - '}
                                                            {record.previous_attendance_status && (
                                                                <span
                                                                    className="attendance-status"
                                                                    data-status={record.previous_attendance_status}
                                                                >
                                                                    {record.previous_attendance_status || '-'}
                                                                </span>
                                                            )}
                                                        </td>

                                                        <td className="align-center">
                                                            <span
                                                                className="attendance-status"
                                                                data-status={record.updated_attendance_data?.day_status}
                                                            >
                                                                {record.updated_attendance_data?.day_status || '-'}
                                                            </span>
                                                            {' - '}
                                                            {record.updated_attendance_status && (
                                                                <span
                                                                    className="attendance-status"
                                                                    data-status={record.updated_attendance_status}
                                                                >
                                                                    {record.updated_attendance_status || '-'}
                                                                </span>
                                                            )}
                                                        </td>
                                                        <td>{record.updated_by}-{record.updated_by_name}</td>
                                                        <td>{record.reason || '-'}</td>
                                                    </tr>
                                                ))}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </Modal.Body>
                    </>}
                {RegularizationData && ArrearData && <hr className="line" />}
                {ArrearData &&
                    <>
                        <Modal.Header>
                            <Modal.Title>Arrear Details for "{formattedDateLong(Ondate)}"</Modal.Title>
                        </Modal.Header>
                        <Modal.Body className="att-modal-body">
                            <div className="parent-div">
                                <div className="scroll-container-model">
                                    <table className="custom-att-table vertical-table att-custom-table">
                                        <thead>
                                            <tr>
                                                {/* <th>Employee Code</th> */}
                                                <th>Sr.</th>
                                                <th>Nature</th>
                                                <th>Based on</th>
                                                <th>Applicable month</th>
                                                <th>Reason</th>
                                                <th>Attachment</th>
                                                <th>Status</th>
                                                <th>Approved Details</th>
                                            </tr>
                                            {/* <tr>
                                        <th>Status</th>
                                    </tr> */}
                                        </thead>
                                        <tbody>
                                            {ArrearData
                                                ?.sort((a, b) => new Date(a.created_at) - new Date(b.created_at))
                                                ?.map((record, index) => (
                                                    <tr key={index}>
                                                        <td >{index + 1}</td>
                                                        <td className="align-center">{record.nature_option || "-"}</td>
                                                        <td
                                                            style={{ cursor: 'help' }}
                                                            className="align-center"
                                                        >
                                                            <CustomTooltip
                                                                position="top"
                                                                tooltipContent={
                                                                    <div>
                                                                        {getTooltipContent(record)}
                                                                    </div>
                                                                }
                                                            >
                                                                {getDependentLabel(record)}
                                                            </CustomTooltip>
                                                        </td>
                                                        <td className="align-center">{getMonthName(record?.applicable_month)} {record?.applicable_year}</td>
                                                        <td className="align-center">{record.reason || "-"}</td>
                                                        <td className="align-center">
                                                            {record.proof ?
                                                                <a href={typeof record.proof === 'string' && record.proof?.startsWith('https://cipl-aimantra.s3.amazonaws.com') ? record.proof : `${IMAGE_URL}${record.proof}`} target="_blank" rel="noreferrer">
                                                                    <AttachmentIcon source={record.proof} />
                                                                </a>
                                                                : '-No File Attached-'}
                                                        </td>
                                                        <td className="align-center request-status text-capitalize" request-status={record.status}>{record.status || '-'}</td>
                                                        <td className="align-center">
                                                            <table style={{ borderCollapse: "collapse", width: "100%" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td className="table-body">Approved Amount</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td
                                                                            className="align-center word-wrap-20vw"
                                                                        >
                                                                            {record.approved_amount || '-'}
                                                                        </td>
                                                                    </tr>
                                                                    <tr>
                                                                        <td className="table-body">Approved Days</td>
                                                                        <td className="table-body" style={{ padding: "0px 4px" }}>:</td>
                                                                        <td
                                                                            className="align-center word-wrap-20vw"
                                                                        >
                                                                            {record.approved_days || '-'}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                ))}
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                        </Modal.Body>
                    </>
                }
            </Modal >
        </>
    )
}

// --------------------------------------------------------Arrear ---------------------


// const AddArrear = ({ getArrear, SUB_COMPANIES, SUPER_ADMIN }) => {
//     const [show, setShow] = useState(false);

//     const handleShow = () => {
//         setFormData(initialData);
//         getAllEmp_code()
//         getDynamicNatureOption()
//         setShow(true);
//     }

//     const handleClose = () => {
//         setFormData(initialData);
//         setShow(false);
//     }

//     const initialData = {
//         emp_code: "",
//         sub_company: sessionStorage.getItem('company_id'),
//         nature_option: "",
//         applicable_year: "",
//         applicable_month: "",
//         status: "pending",
//         //case 1
//         date_list: [],
//         //case 2
//         start_date: "",
//         end_date: "",
//         //case 3
//         amount: "",

//         days_calculated: "",
//         reason: "",
//         proof: "",
//         created_by: sessionStorage.getItem('emp_code'),
//         updated_by: sessionStorage.getItem('emp_code'),

//         applicable_month_year: "", // only for take month & year at once
//     }
//     const [formData, setFormData] = useState(initialData);
//     const [empList, setEmpList] = useState([]);
//     const [natureOptionList, setNatureOptionList] = useState([]);

//     const [loading, setLoading] = useState(false);
//     const [buffer, setBuffering] = useState(true);
//     const [buffer1, setBuffering1] = useState(true);
//     const [buffer2, setBuffering2] = useState(true);
//     const [buffer3, setBuffering3] = useState(true);
//     const [payrunList, setPayrunList] = useState(null);
//     const [calculationType, setCalculationType] = useState("");
//     const [existingArrears, setExistingArrears] = useState([]);
//     const [format, setFormat] = useState('arrear')

//     const getMinMaxDates = () => {
//         if (!payrunList || !payrunList.joining_date) return null;

//         const joiningDate = new Date(payrunList.joining_date);

//         const lastPayslipDate = payrunList?.last_salary_slip
//             ? new Date(
//                 payrunList.last_salary_slip.year,
//                 payrunList.last_salary_slip.month - 1,
//                 1
//             )
//             : null;

//         //  for days/months selection
//         const minBase = lastPayslipDate || new Date(
//             joiningDate.getFullYear(),
//             joiningDate.getMonth(),
//             1
//         );

//         //  for applicable month 
//         const applicableMin = lastPayslipDate
//             ? new Date(
//                 lastPayslipDate.getFullYear(),
//                 lastPayslipDate.getMonth() + 1,
//                 1
//             )
//             : new Date(
//                 joiningDate.getFullYear(),
//                 joiningDate.getMonth(),
//                 1
//             );

//         const applicableMax = new Date();
//         applicableMax.setFullYear(applicableMax.getFullYear() + 1);

//         return { minBase, applicableMin, applicableMax };
//     };

//     const minMaxDates = useMemo(() => {

//         return getMinMaxDates();
//     }, [payrunList])


//     const usedMonthsSet = useMemo(() => {
//         const set = new Set();

//         existingArrears.forEach(item => {
//             if (item.calculation_type === "days") {
//                 item.date_list?.forEach(d => {
//                     set.add(d.slice(0, 7));
//                 });
//             }

//             if (item.calculation_type === "months") {
//                 let current = new Date(item.start_date);
//                 const end = new Date(item.end_date);

//                 while (current <= end) {
//                     const key = current.toISOString().slice(0, 7);
//                     set.add(key);
//                     current.setMonth(current.getMonth() + 1);
//                 }
//             }
//         });

//         return set;
//     }, [existingArrears]);


//     const getAllEmp_code = async () => {
//         setBuffering1(true);
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
//             );
//             const sortedList = customSortByKey(res.data, "emp_code");
//             setEmpList(sortedList);
//         } catch (err) {
//         } finally {
//             setBuffering1(false);
//         }
//     };

//     const getDynamicNatureOption = async () => {
//         setBuffering2(true);
//         try {
//             const res = await axios.get(
//                 `${BASE_URL}/wfm/dynamic-nature-byfilter/${formData.sub_company}/${format}/`
//             );

//             setNatureOptionList(res.data);
//         } catch (err) {
//         } finally {
//             setBuffering2(false);
//         }
//     };

//     const getPayrunlist = async (empcode) => {
//         setBuffering3(true);
//         try {
//             const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${empcode}/`);
//             setPayrunList(res.data);
//         } catch (err) {
//         } finally {
//             setBuffering3(false);
//         }
//     }


//     useEffect(() => {
//         if (show) {
//             getAllEmp_code();
//             getDynamicNatureOption();
//         }
//     }, [formData.sub_company])


//     const handleInputChange = (e) => {
//         const { name, value } = e.target;
//         const numericFields = [
//             "amount", "approved_amount",
//         ];
//         setErrors((prevErrors) => {
//             const updatedErrors = { ...prevErrors };
//             delete updatedErrors[name];
//             return updatedErrors;
//         });

//         if (numericFields.includes(name)) {

//             if (!isValidTwoDecimalNumber(value)) {
//                 return;
//             }

//             if (value.startsWith("-") || parseFloat(value) < 0) {
//                 setErrors((prevErrors) => ({
//                     ...prevErrors,
//                     [name]: "Value cannot be negative",
//                 }));
//                 return;
//             }


//             const { success, error } = inputMinLimit(name, value, 0);

//             if (!success) {
//                 setErrors((prevErrors) => ({
//                     ...prevErrors,
//                     [name]: error,
//                 }));
//             }
//         }




//         setInputState({
//             ...inputState,
//             [name]: value.trim() ? "green" : "",
//         });

//         setFormData({
//             ...formData,
//             [name]: value,
//         });

//         if (name === "nature_option") {
//             const selected = natureOptionList.find((i) => i.id === value);
//             setCalculationType(selected?.calculation_type || "");
//         }
//         if (name === "emp_code") {
//             getPayrunlist(value);
//             setErrors(prev => ({
//                 ...prev,
//                 date_list: ""
//             }));

//         }



//     };


//     // const handleMonthInputChange = (e, type) => {
//     //     const { name, value } = e.target;

//     //     if (!value) return;

//     //     if (!formData.applicable_month_year) {
//     //         setErrors(prev => ({
//     //             ...prev,
//     //             start_date: "Please select Applicable Month & Year first.",
//     //             end_date: "Please select Applicable Month & Year first."
//     //         }));

//     //         setFormData(prev => ({
//     //             ...prev,
//     //             start_date: "",
//     //             end_date: "",
//     //             days_calculated: 0
//     //         }));

//     //         return;
//     //     }

//     //     const selectedMonthDate = new Date(value + "-01");

//     //     const applicableDate = new Date(formData.applicable_month_year + "-01");

//     //     //  Previous month of applicable
//     //     const previousMonth = new Date(
//     //         applicableDate.getFullYear(),
//     //         applicableDate.getMonth() - 1,
//     //         1
//     //     );
//     //     const today = new Date();
//     //     let errorMessage = "";

//     //     //  Future month validation
//     //     if (selectedMonthDate > today) {
//     //         errorMessage = "Future months are not allowed.";
//     //     }

//     //     //  Only previous month allowed
//     //     if (
//     //         selectedMonthDate.getFullYear() !== previousMonth.getFullYear() ||
//     //         selectedMonthDate.getMonth() !== previousMonth.getMonth()
//     //     ) {
//     //         errorMessage = `Only previous month (${previousMonth.toLocaleString(
//     //             "default",
//     //             { month: "long", year: "numeric" }
//     //         )}) is allowed.`;
//     //     }

//     //     //  Before joining
//     //     else if (payrunList?.joining_date) {
//     //         const joiningDate = new Date(payrunList.joining_date);
//     //         const joiningMonthStart = new Date(
//     //             joiningDate.getFullYear(),
//     //             joiningDate.getMonth(),
//     //             1
//     //         );

//     //         if (selectedMonthDate < joiningMonthStart) {
//     //             errorMessage = `Employee joined in ${joiningDate.toLocaleString(
//     //                 "default",
//     //                 { month: "long", year: "numeric" }
//     //             )}.`;
//     //         }
//     //     }

//     //     if (errorMessage) {
//     //         setErrors(prev => ({
//     //             ...prev,
//     //             [name]: errorMessage
//     //         }));

//     //         setFormData(prev => ({
//     //             ...prev,
//     //             [name]: "",
//     //             days_calculated: 0
//     //         }));

//     //         return;
//     //     }

//     //     const formattedDate = getMonthBoundaryDate(value, type);

//     //     setFormData(prev => {
//     //         const updated = {
//     //             ...prev,
//     //             [name]: formattedDate
//     //         };
//     //         // Validate start <= end
//     //         if (updated.start_date && updated.end_date) {
//     //             const start = new Date(updated.start_date);
//     //             const end = new Date(updated.end_date);

//     //             if (start > end) {
//     //                 setErrors(prev => ({
//     //                     ...prev,
//     //                     end_date: "End month cannot be before start month."
//     //                 }));
//     //                 updated.end_date = "";
//     //                 updated.days_calculated = 0;
//     //                 return updated;
//     //             }

//     //             updated.days_calculated = calculateDaysBetween(
//     //                 updated.start_date,
//     //                 updated.end_date
//     //             );
//     //         }

//     //         return updated;
//     //     });

//     //     setErrors(prev => ({
//     //         ...prev,
//     //         [name]: ""
//     //     }));
//     // };

//     const handleMonthInputChange = (e, type) => {
//         const { name, value } = e.target;

//         if (!value) return;

//         if (!formData.applicable_month_year) {
//             setErrors(prev => ({
//                 ...prev,
//                 start_date: "Please select Applicable Month & Year first.",
//                 end_date: "Please select Applicable Month & Year first."
//             }));

//             setFormData(prev => ({
//                 ...prev,
//                 start_date: "",
//                 end_date: "",
//                 days_calculated: 0
//             }));

//             return;
//         }

//         const selectedMonthDate = new Date(value + "-01");

//         const applicableDate = new Date(formData.applicable_month_year + "-01");

//         //  Previous month of applicable
//         const previousMonth = new Date(
//             applicableDate.getFullYear(),
//             applicableDate.getMonth() - 1,
//             1
//         );
//         const today = new Date();
//         let errorMessage = "";


//         const { minBase } = minMaxDates;

//         const currentMonth = new Date();


//         if (selectedMonthDate < minBase) {
//             errorMessage = `You can select from ${minBase.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )} onwards only`;
//         }
//         else if (selectedMonthDate > currentMonth) {
//             errorMessage = "Future months are not allowed.";
//         }

//         if (
//             selectedMonthDate.getFullYear() > applicableDate.getFullYear() ||
//             (
//                 selectedMonthDate.getFullYear() === applicableDate.getFullYear() &&
//                 selectedMonthDate.getMonth() >= applicableDate.getMonth()
//             )
//         ) {
//             errorMessage = `You can select only months before ${applicableDate.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )}`;
//         }

//         const monthKey = value;

//         if (usedMonthsSet.has(monthKey)) {
//             setErrors(prev => ({
//                 ...prev,
//                 [name]: "This month already has arrear applied."
//             }));

//             return;
//         }

//         if (errorMessage) {
//             setErrors(prev => ({
//                 ...prev,
//                 [name]: errorMessage
//             }));

//             setFormData(prev => ({
//                 ...prev,
//                 [name]: "",
//                 days_calculated: 0
//             }));

//             return;
//         }

//         const formattedDate = getMonthBoundaryDate(value, type);


//         setFormData(prev => {
//             const updated = {
//                 ...prev,
//                 [name]: formattedDate
//             };

//             if (updated.start_date && updated.end_date) {
//                 const start = new Date(updated.start_date);
//                 const end = new Date(updated.end_date);

//                 //  EXISTING CONDITION
//                 if (start > end) {
//                     setErrors(prev => ({
//                         ...prev,
//                         end_date: "End month cannot be before start month."
//                     }));
//                     updated.end_date = "";
//                     updated.days_calculated = 0;
//                     return updated;
//                 }

//                 //  NEW CONDITION (ONLY 1 MONTH ALLOWED)
//                 if (
//                     start.getFullYear() !== end.getFullYear() ||
//                     start.getMonth() !== end.getMonth()
//                 ) {
//                     setErrors(prev => ({
//                         ...prev,
//                         end_date: "Only one month duration is allowed. Start and End month must be same."
//                     }));

//                     updated.end_date = "";
//                     updated.days_calculated = 0;
//                     return updated;
//                 }

//                 //  CALCULATE DAYS (only when valid)
//                 updated.days_calculated = calculateDaysBetween(
//                     updated.start_date,
//                     updated.end_date
//                 );
//             }

//             return updated;
//         });
//         setErrors(prev => ({
//             ...prev,
//             [name]: ""
//         }));
//     };

//     const handleFileChange = (e) => {
//         const { name } = e.target;
//         const file = e.target.files[0];

//         setFormData({
//             ...formData,
//             [name]: file,
//         });

//         if (file) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };




//     const handleDateSelect = (selectedDates) => {

//         if (!formData.applicable_month_year) {
//             setErrors(prev => ({
//                 ...prev,
//                 date_list: "Please select Applicable Month & Year first."
//             }));
//             setFormData(prev => ({
//                 ...prev,
//                 date_list: [],
//                 days_calculated: 0
//             }));
//             return;
//         }

//         let filtered = [...selectedDates];
//         let errorMessage = "";

//         const applicableDate = new Date(formData.applicable_month_year + "-01");

//         const today = new Date();
//         today.setHours(0, 0, 0, 0);

//         const { minBase } = minMaxDates;


//         const conflict = selectedDates.some(d => {
//             const month = d.slice(0, 7);
//             return usedMonthsSet.has(month);
//         });

//         if (conflict) {
//             setErrors(prev => ({
//                 ...prev,
//                 date_list: "Some selected dates already exist in arrear."
//             }));
//             return;
//         }

//         //  Flags for error messages
//         let hasFutureDate = false;
//         let hasApplicableMonthDate = false;
//         let hasBeforeMinBase = false;

//         const validDates = filtered.filter(d => {
//             const date = new Date(d);

//             //  Future (including today)
//             if (date >= today) {
//                 hasFutureDate = true;
//             }

//             //  Applicable month
//             if (
//                 date.getFullYear() === applicableDate.getFullYear() &&
//                 date.getMonth() === applicableDate.getMonth()
//             ) {
//                 hasApplicableMonthDate = true;
//             }

//             //  Before minBase
//             if (date < minBase) {
//                 hasBeforeMinBase = true;
//             }

//             const isBeforeApplicableMonth =
//                 date.getFullYear() < applicableDate.getFullYear() ||
//                 (
//                     date.getFullYear() === applicableDate.getFullYear() &&
//                     date.getMonth() < applicableDate.getMonth()
//                 );

//             const isNotFutureDate = date < today;

//             return date >= minBase && isBeforeApplicableMonth && isNotFutureDate;
//         });


//         if (hasFutureDate) {
//             errorMessage = "Future dates are not allowed. Please select dates before today.";
//         }
//         else if (hasApplicableMonthDate) {
//             errorMessage = `Dates from ${applicableDate.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )} are not allowed.`;
//         }
//         else if (hasBeforeMinBase) {
//             errorMessage = `You can select dates from ${minBase.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )} onwards only.`;
//         }


//         setFormData(prev => ({
//             ...prev,
//             date_list: validDates,
//             days_calculated: validDates.length
//         }));

//         setErrors(prev => ({
//             ...prev,
//             date_list: errorMessage
//         }));
//     };
//     const handleFileClear = (name) => {
//         setFormData({
//             ...formData,
//             [name]: null,
//         });

//         setErrors((prevErrors) => ({
//             ...prevErrors,
//             [name]: "",
//         }));
//     };


//     //**************************valedation Start**************** */

//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);

//     const validateForm = () => {
//         const newErrors = {};
//         const requiredFields = [
//             "emp_code",
//             "reason",
//             "nature_option",
//             "proof",
//             "applicable_month_year",
//             // calculationType === "days" ? "date_list" : null,
//             calculationType === "months" ? "start_date" : null,
//             calculationType === "months" ? "end_date" : null,
//             calculationType === "amount" ? "amount" : null,
//         ].filter(Boolean);

//         requiredFields.forEach((field) => {
//             if (!formData[field]) {
//                 newErrors[field] = `${formatFieldName(field)} is required!`;
//             }
//         });

//         if (calculationType === "days") {
//             if (!formData.date_list || formData.date_list.length === 0) {
//                 newErrors.date_list = "At least one date is required!";
//             }
//         }



//         if (formData.applicable_month_year && payrunList) {
//             const selectedDate = new Date(formData.applicable_month_year + "-01");
//             const joiningDate = new Date(payrunList.joining_date);

//             // if (selectedDate < joiningDate) {
//             //     newErrors.applicable_month_year = `Applicable month allowed only from ${joiningDate.toLocaleString(
//             //         "default",
//             //         { month: "long", year: "numeric" }
//             //     )}.`;
//             // }
//         }


//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };

//     // const handleApplicableMonthYearChange = (e) => {
//     //     const value = e.target.value;

//     //     if (!value || !payrunList) {
//     //         setFormData(prev => ({ ...prev, applicable_month_year: value }));
//     //         return;
//     //     }

//     //     const selectedDate = new Date(value + "-01");
//     //     const joiningDate = new Date(payrunList.joining_date);


//     //     const joiningMonthStart = new Date(
//     //         joiningDate.getFullYear(),
//     //         joiningDate.getMonth(),
//     //         1
//     //     );

//     //     //block only before joing month
//     //     if (selectedDate < joiningMonthStart) {
//     //         setErrors(prev => ({
//     //             ...prev,
//     //             applicable_month_year: `This employee joined in ${joiningDate.toLocaleString(
//     //                 "default",
//     //                 { month: "long", year: "numeric" }
//     //             )}, so arrears can only be applied from that month onward.`
//     //         }));

//     //         setFormData(prev => ({
//     //             ...prev,
//     //             applicable_month_year: "",
//     //             date_list: [],
//     //             start_date: "",
//     //             end_date: "",
//     //             days_calculated: 0
//     //         }));

//     //         return;
//     //     }


//     //     setFormData(prev => ({
//     //         ...prev,
//     //         applicable_month_year: value,
//     //         date_list: [],
//     //         start_date: "",
//     //         end_date: "",
//     //         days_calculated: 0
//     //     }));

//     //     setErrors(prev => ({
//     //         ...prev,
//     //         applicable_month_year: ""
//     //     }));
//     // };

//     const handleApplicableMonthYearChange = (e) => {
//         const value = e.target.value;

//         if (!value || !minMaxDates) {
//             setFormData(prev => ({ ...prev, applicable_month_year: value }));
//             return;
//         }

//         const selectedDate = new Date(value + "-01");

//         let errorMessage = "";


//         const lastPayslip = payrunList?.last_salary_slip;

//         if (lastPayslip) {
//             const lastMonth = `${lastPayslip.year}-${String(lastPayslip.month).padStart(2, "0")}`;

//             if (value === lastMonth) {
//                 errorMessage = `Arrear cannot be applied for ${new Date(
//                     lastPayslip.year,
//                     lastPayslip.month - 1
//                 ).toLocaleString("default", { month: "long", year: "numeric" })} because salary is already processed.`;
//             }
//         }

//         if (minMaxDates.applicableMin && selectedDate < minMaxDates.applicableMin) {

//             errorMessage = `You can apply arrear from ${minMaxDates.applicableMin.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )} onwards only`;
//         }
//         else if (minMaxDates.applicableMax && selectedDate > minMaxDates.applicableMax) {
//             errorMessage = `You can select only up to ${minMaxDates.applicableMax.toLocaleString(
//                 "default",
//                 { month: "long", year: "numeric" }
//             )}`;
//         }

//         if (errorMessage) {
//             setErrors(prev => ({
//                 ...prev,
//                 applicable_month_year: errorMessage
//             }));

//             setFormData(prev => ({
//                 ...prev,
//                 applicable_month_year: ""
//             }));

//             return;
//         }

//         setFormData(prev => ({
//             ...prev,
//             applicable_month_year: value
//         }));

//         setErrors(prev => ({
//             ...prev,
//             applicable_month_year: ""
//         }));
//     };

//     // const handleApplicableMonthYearChange = (e) => {
//     //     const value = e.target.value;

//     //     if (!value || !payrunList) {
//     //         setFormData(prev => ({ ...prev, applicable_month_year: value }));
//     //         return;
//     //     }

//     //     const selectedDate = new Date(value + "-01");

//     //     const joiningDate = new Date(payrunList.joining_date);
//     //     const joiningMonthStart = new Date(
//     //         joiningDate.getFullYear(),
//     //         joiningDate.getMonth(),
//     //         1
//     //     );

//     //     const lastPayslipDate = payrunList?.last_salary_slip
//     //         ? new Date(
//     //             payrunList.last_salary_slip.year,
//     //             payrunList.last_salary_slip.month - 1,
//     //             1
//     //         )
//     //         : null;

//     //     let errorMessage = "";

//     //     if (selectedDate < joiningMonthStart) {
//     //         errorMessage = `Employee joined in ${joiningDate.toLocaleString(
//     //             "default",
//     //             { month: "long", year: "numeric" }
//     //         )}.`;
//     //     }
//     //     else if (!lastPayslipDate) {
//     //         errorMessage = "Last processed payroll not found.";
//     //     }
//     //     else {
//     //         const nextPayrollMonth = new Date(
//     //             lastPayslipDate.getFullYear(),
//     //             lastPayslipDate.getMonth() + 1,
//     //             1
//     //         );


//     //         if (
//     //             selectedDate.getFullYear() !== nextPayrollMonth.getFullYear() ||
//     //             selectedDate.getMonth() !== nextPayrollMonth.getMonth()
//     //         ) {
//     //             errorMessage = ` Arrear can only be applied in the immediate next payroll cycle (${nextPayrollMonth.toLocaleString(
//     //                 "default",
//     //                 { month: "long", year: "numeric" }
//     //             )},)`;
//     //         }
//     //     }

//     //     if (errorMessage) {
//     //         setErrors(prev => ({
//     //             ...prev,
//     //             applicable_month_year: errorMessage
//     //         }));

//     //         setFormData(prev => ({
//     //             ...prev,
//     //             applicable_month_year: "",
//     //             date_list: [],
//     //             start_date: "",
//     //             end_date: "",
//     //             days_calculated: 0
//     //         }));

//     //         return;
//     //     }

//     //     setFormData(prev => ({
//     //         ...prev,
//     //         applicable_month_year: value,
//     //         date_list: [],
//     //         start_date: "",
//     //         end_date: "",
//     //         days_calculated: 0
//     //     }));

//     //     setErrors(prev => ({
//     //         ...prev,
//     //         applicable_month_year: ""
//     //     }));
//     // };


//     const handleFormSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             setBuffering(true);

//             const loadingToastId = toast.loading("Loading: Please wait...");


//             let applicableYear = "";
//             let applicableMonth = "";

//             if (formData.applicable_month_year) {
//                 const [year, month] = formData.applicable_month_year.split("-");
//                 applicableYear = year;
//                 applicableMonth = month;
//             }


//             const uploadData = new FormData();
//             uploadData.append("emp_code", formData.emp_code);
//             uploadData.append("reason", formData.reason);
//             uploadData.append("nature_option", formData.nature_option);
//             uploadData.append("applicable_year", applicableYear);
//             uploadData.append("applicable_month", applicableMonth);
//             uploadData.append("status", formData.status);
//             uploadData.append("sub_company", formData.sub_company);
//             uploadData.append('days_calculated', formData.days_calculated || 0);
//             uploadData.append("created_by", formData.created_by);
//             uploadData.append("updated_by", formData.updated_by);

//             const attachmentFile = formData.proof;
//             if (attachmentFile && typeof attachmentFile !== 'string') {
//                 const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
//                 uploadData.append("proof", customFile);

//             }

//             if (calculationType === "amount") {
//                 uploadData.append("amount", formData.amount);
//             }
//             else if (calculationType === "days") {
//                 uploadData.append("date_list", JSON.stringify(formData.date_list));

//             }
//             else if (calculationType === "months") {
//                 uploadData.append('start_date', formData.start_date);
//                 uploadData.append('end_date', formData.end_date);
//             }

//             try {
//                 let res = await axios.post(
//                     `${BASE_URL}/wfm/arrear/`,
//                     uploadData, {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                     },
//                 }
//                 );
//                 if (res.status === 200 || res.status === 201) {
//                     await getArrear();
//                     setShow(false);
//                     setFormData(initialData);
//                     toast.success("Arrear created successfully!");
//                 } else {
//                     console.error(res);
//                 }
//             } catch (err) {
//                 handleErrorToast(err, loadingToastId)
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };

//     useEffect(() => {
//         if (isSubmitted) {
//             validateForm();
//         }
//     }, [formData.applicable_month_year]);



//     return (
//         <>
//             <button className="upload-svg" onClick={handleShow} title="Add Arrear">
//                 <AddwithWhiteCircle />  Arrear Prev
//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Add Arrear</Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         <div className="bdy-div">
//                             {SUPER_ADMIN && (
//                                 <div className="flex-column">
//                                     <label className="form-labels font-weight500 font-size-subheading">
//                                         Sub Company<span className="required">*</span>
//                                     </label>
//                                     <select
//                                         name="sub_company"
//                                         value={formData.sub_company}
//                                         onChange={handleInputChange}
//                                         className={`form-input w-auto ${errors.sub_company
//                                             ? "error"
//                                             : inputState.sub_company
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                         required
//                                     >
//                                         <option value="">Select a Company</option>
//                                         {SUB_COMPANIES.map((i, index) => (
//                                             <option key={index} value={i.id}>
//                                                 {i.title}
//                                             </option>
//                                         ))}
//                                     </select>
//                                     {errors.sub_company && (
//                                         <span className="error-message font-size-text ">
//                                             {errors.sub_company}
//                                         </span>
//                                     )}
//                                 </div>
//                             )}

//                             <div className="flex-column ">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     To Employee<span className="required">*</span>
//                                 </label>
//                                 {buffer1 ? (
//                                     <div className="form-loader">
//                                         <div className="bar-loader"></div>
//                                     </div>
//                                 ) : (
//                                     <select
//                                         name="emp_code"
//                                         value={formData.emp_code}
//                                         onChange={handleInputChange}
//                                         className={`form-input w-auto ${errors.emp_code
//                                             ? "error"
//                                             : inputState.emp_code
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                         required
//                                     >
//                                         <option value="">Select An Employee</option>
//                                         {empList
//                                             .sort((a, b) => a.emp_code - b.emp_code)
//                                             .map((i, index) => (
//                                                 <option value={i.emp_code}>
//                                                     {i.name} - {i.emp_code}
//                                                 </option>
//                                             ))}
//                                     </select>
//                                 )}
//                                 {errors.emp_code && (
//                                     <span className="error-message font-size-text ">
//                                         {errors.emp_code}
//                                     </span>
//                                 )}
//                             </div>



//                             {/* <div className="flex-column">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Applicable Month & Year <span className="required">*</span>
//                                 </label>

//                                 <input
//                                     type="month"
//                                     name="applicable_month_year"
//                                     value={formData.applicable_month_year}
//                                     min={payrunList?.joining_date?.slice(0, 7)}
//                                     max={new Date().toISOString().slice(0, 7)}
//                                     onChange={handleApplicableMonthYearChange}
//                                     className={`multi-day-input1 form-input w-auto form-input-background 
//             ${errors.applicable_month_year ? "error" : inputState.applicable_month_year ? "success" : ""}`}
//                                 />

//                                 {errors.applicable_month_year && (
//                                     <span className="error-message font-size-text">
//                                         {errors.applicable_month_year}
//                                     </span>
//                                 )}
//                             </div> */}
//                             <div className="flex-column">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Applicable Month & Year <span className="required">*</span>
//                                 </label>

//                                 <input
//                                     type="month"
//                                     name="applicable_month_year"
//                                     value={formData.applicable_month_year}
//                                     // min={payrunList?.joining_date?.slice(0, 7)}
//                                     // max={new Date().toISOString().slice(0, 7)}
//                                     // min={getMinMaxDates()?.applicableMin?.toISOString().slice(0, 7)}
//                                     // max={getMinMaxDates()?.applicableMax?.toISOString().slice(0, 7)}
//                                     min={minMaxDates?.applicableMin
//                                         ? minMaxDates.applicableMin.toISOString().slice(0, 7)
//                                         : undefined}
//                                     max={
//                                         minMaxDates?.applicableMax
//                                             ? minMaxDates.applicableMax.toISOString().slice(0, 7)
//                                             : undefined
//                                     }
//                                     onChange={handleApplicableMonthYearChange}
//                                     className={`multi-day-input1 form-input w-auto form-input-background 
//                                     ${errors.applicable_month_year ? "error" : inputState.applicable_month_year ? "success" : ""}`}
//                                 />

//                                 {errors.applicable_month_year && (
//                                     <span className="error-message font-size-text">
//                                         {errors.applicable_month_year}
//                                     </span>
//                                 )}
//                             </div>

//                             <div className="flex-column ">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Nature<span className="required">*</span>
//                                 </label>
//                                 {buffer2 ? (
//                                     <div className="form-loader">
//                                         <div className="bar-loader"></div>
//                                     </div>
//                                 ) : (
//                                     <select
//                                         name="nature_option"
//                                         value={formData.nature_option}
//                                         onChange={handleInputChange}
//                                         className={`form-input w-auto ${errors.nature_option
//                                             ? "error"
//                                             : inputState.nature_option
//                                                 ? "success"
//                                                 : ""
//                                             }`}
//                                         required
//                                     >
//                                         <option value="">Select Nature</option>
//                                         {natureOptionList
//                                             .map((i, index) => (
//                                                 <option value={i.id}>
//                                                     {i.name}
//                                                 </option>
//                                             ))}
//                                     </select>
//                                 )}

//                                 {errors.nature_option && (
//                                     <span className="error-message font-size-text ">
//                                         {errors.nature_option}
//                                     </span>
//                                 )}
//                             </div>

//                             {calculationType === "amount" && <div className="flex-column">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Amount<span className="required">*</span>
//                                 </label>
//                                 <input
//                                     type="number"
//                                     name="amount"
//                                     min={0}
//                                     placeholder="Enter amount"
//                                     onWheel={(e) => e.target.blur()}
//                                     value={formData.amount}
//                                     onChange={handleInputChange}
//                                     className={` form-input w-auto ${errors.amount ? "error" : inputState.amount ? "success" : ""}`}
//                                 />
//                                 {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
//                             </div>}

//                             {calculationType === "days" && (
//                                 <div className="flex-column">
//                                     <label className="form-labels font-weight500 font-size-subheading">
//                                         Date <span className="required">*</span>
//                                     </label>

//                                     <MultiDateSelect
//                                         value={formData.date_list}

//                                         onChange={(selectedDates) => handleDateSelect(selectedDates)}
//                                         placeholder="Click to select dates"
//                                         error={errors.date_list}
//                                         disabled={loading || buffer2}
//                                         style={{
//                                             width: '98%',
//                                         }}
//                                     />


//                                     {formData.date_list.length > 0 && (
//                                         <div style={{
//                                             fontSize: '12px',
//                                             color: '#666',
//                                             marginTop: '4px',
//                                             marginLeft: '4px',
//                                         }}>
//                                             Selected {formData.date_list.length} date(s) •
//                                             Total days: {formData.days_calculated}
//                                         </div>
//                                     )}
//                                 </div>
//                             )}

//                             {calculationType === "months" && (
//                                 <div className="form-flex-wrap flex-row" style={{ marginBottom: '20px' }}>
//                                     <div className="flex-column">
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             Start Month<span className="required">*</span>
//                                         </label>
//                                         <input
//                                             type="month"
//                                             name="start_date"
//                                             value={formData.start_date?.slice(0, 7) || ""}
//                                             onChange={(e) => handleMonthInputChange(e, "start")}
//                                             // max={formData.end_date?.slice(0, 7) || ""}
//                                             max={formData.applicable_month_year}
//                                             min={payrunList?.joining_date?.slice(0, 7)}

//                                             className={`multi-day-input1 form-input-background ${errors.start_date ? "error" : inputState.start_date ? "success" : ""
//                                                 }`}
//                                         />
//                                         {errors.start_date && (
//                                             <span className="error-message font-size-text mt-2">
//                                                 {errors.start_date}
//                                             </span>
//                                         )}
//                                     </div>

//                                     <div className="flex-column">
//                                         <label className="form-labels font-weight500 font-size-subheading">
//                                             End Month<span className="required">*</span>
//                                         </label>
//                                         <input
//                                             type="month"
//                                             name="end_date"
//                                             value={formData.end_date?.slice(0, 7) || ""}
//                                             onChange={(e) => handleMonthInputChange(e, "end")}
//                                             min={formData.start_date?.slice(0, 7)}
//                                             max={formData.applicable_month_year}

//                                             // min={formData.start_date?.slice(0, 7) || ""}
//                                             className={`multi-day-input1 form-input-background ${errors.end_date ? "error" : inputState.end_date ? "success" : ""
//                                                 }`}
//                                         />
//                                         {errors.end_date && (
//                                             <span className="error-message font-size-text mt-2">
//                                                 {errors.end_date}
//                                             </span>
//                                         )}
//                                     </div>
//                                 </div>
//                             )}




//                             <div className="flex-column">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Reason<span className="required">*</span>
//                                 </label>
//                                 <textarea
//                                     id="reason"
//                                     type="text"
//                                     name="reason"
//                                     placeholder="Reason"
//                                     onChange={handleInputChange}
//                                     // maxLength={200}
//                                     value={formData.reason}
//                                     className={`form-input-textarea w-auto font-weight400  font-size-subheading ${errors.reason
//                                         ? "error"
//                                         : inputState.reason
//                                             ? "success"
//                                             : ""
//                                         }`}
//                                 />
//                                 {errors.reason && <span className="error-message font-size-text">{errors.reason}</span>}
//                             </div>



//                             <div className="flex-column">
//                                 <label className="form-labels font-weight500 font-size-subheading">
//                                     Proof<span className="required">*</span>
//                                 </label>

//                                 <div
//                                     className={`file-upload-container flex-row justify-between file-in-upload w-auto`}
//                                     style={{ padding: "0 3px", marginBottom: '20px' }}
//                                 >
//                                     <label
//                                         className="popup-label"
//                                         htmlFor="proof"
//                                     >
//                                         <CloudUpload />
//                                         <span className="truncate-url">
//                                             {formData?.proof
//                                                 ? formData?.proof instanceof File
//                                                     ? formData?.proof.name
//                                                     : getFileNameFromUrl(formData?.proof)
//                                                 : "No file selected"}
//                                         </span>
//                                     </label>

//                                     <input
//                                         type="file"
//                                         id="proof"
//                                         name="proof"
//                                         accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
//                                         onChange={handleFileChange}
//                                         className="popup-input w-auto"

//                                     />
//                                     <br />
//                                     {formData?.proof && (
//                                         <span
//                                             className="file-clear"
//                                             onClick={() => handleFileClear("proof")}
//                                         >
//                                             Clear
//                                         </span>
//                                     )}

//                                 </div>
//                                 {errors.proof && (
//                                     <span className="error-message font-size-text">
//                                         {errors.proof}
//                                     </span>
//                                 )}
//                             </div>

//                             <div className="button-models">
//                                 <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
//                                     Cancel
//                                 </button>
//                                 <button
//                                     type="submit"
//                                     className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
//                                     onClick={handleFormSubmit}
//                                     disabled={loading}
//                                 >
//                                     Add
//                                 </button>
//                             </div>
//                         </div>
//                     </div>
//                     <p className="error-message font-size-text">
//                         {/* {isSubmitted &&
//                             (() => {
//                                 const relevantKeys = getRelevantErrorKeys();

//                                 const filteredErrors = Object.keys(errors).filter(
//                                     (key) => errors[key] && relevantKeys.includes(key)
//                                 );

//                                 if (filteredErrors.length === 0) return null;

//                                 return filteredErrors.length > 5 ? (
//                                     <h5 className="text-center">
//                                         Please fill all mandatory fields!
//                                     </h5>
//                                 ) : (
//                                     <h6 className="text-center">
//                                         {filteredErrors
//                                             .map((field) =>
//                                                 field
//                                                     .replace(/_/g, " ")
//                                                     .replace(/\b\w/g, (c) => c.toUpperCase())
//                                             )
//                                             .join(", ") + " are required!"}
//                                     </h6>
//                                 );
//                             })()} */}
//                         {isSubmitted && Object.keys(errors).length > 0 && (
//                             Object.keys(errors).length > 5 ? (
//                                 <h5 className="text-center">Please fill all mandatory fields!</h5>
//                             ) : (
//                                 <h6 className="text-center">
//                                     {Object.keys(errors)
//                                         .map((field) =>
//                                             field
//                                                 .replace(/_/g, ' ')
//                                                 .replace(/\b\w/g, (char) => char.toUpperCase())
//                                         )
//                                         .join(', ') + ' are required!'}
//                                 </h6>
//                             )
//                         )}
//                     </p>

//                     <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//                 </Modal.Body>
//             </Modal >
//         </>
//     );
// };

const AddArrear = ({ getArrear, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);

    const handleShow = () => {
        setFormData(initialData);
        getAllEmp_code();
        getDynamicNatureOption();
        setShow(true);
    }

    const handleClose = () => {
        setFormData(initialData);
        setErrors({})
        setShow(false);
    }

    const initialData = {
        emp_code: "",
        sub_company: sessionStorage.getItem('company_id'),
        nature_option: "",
        applicable_year: "",
        applicable_month: "",
        status: "pending",
        //case 1
        date_list: [],
        //case 2
        start_date: "",
        end_date: "",
        //case 3
        amount: "",

        days_calculated: "",
        reason: "",
        proof: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),

        applicable_month_year: "", // only for take month & year at once
    }
    const [formData, setFormData] = useState(initialData);
    const [empList, setEmpList] = useState([]);
    const [natureOptionList, setNatureOptionList] = useState([]);

    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [payrunList, setPayrunList] = useState(null);
    const [calculationType, setCalculationType] = useState("");
    const [existingArrears, setExistingArrears] = useState([]);
    const [format, setFormat] = useState('arrear')

    const getMinMaxDates = () => {
        if (!payrunList || !payrunList.joining_date) return null;

        const joiningDate = new Date(payrunList.joining_date);

        const lastPayslipDate = payrunList?.last_salary_slip
            ? new Date(
                payrunList.last_salary_slip.year,
                payrunList.last_salary_slip.month - 1,
                1
            )
            : null;

        //  for days/months selection
        const minBase = lastPayslipDate || new Date(
            joiningDate.getFullYear(),
            joiningDate.getMonth(),
            1
        );

        //  for applicable month 
        const applicableMin = lastPayslipDate
            ? new Date(
                lastPayslipDate.getFullYear(),
                lastPayslipDate.getMonth() + 1,
                1
            )
            : new Date(
                joiningDate.getFullYear(),
                joiningDate.getMonth(),
                1
            );

        const applicableMax = new Date();
        applicableMax.setFullYear(applicableMax.getFullYear() + 1);

        return { minBase, applicableMin, applicableMax };
    };

    const minMaxDates = useMemo(() => {
        return getMinMaxDates();
    }, [payrunList])



    // const usedMonthsSet = useMemo(() => {
    //     const set = new Set();

    //     existingArrears.forEach(item => {
    //         if (item.calculation_type === "days") {
    //             item.date_list?.forEach(d => {
    //                 set.add(d.slice(0, 7));
    //             });
    //         }

    //         if (item.calculation_type === "months") {
    //             let current = new Date(item.start_date);
    //             const end = new Date(item.end_date);

    //             while (current <= end) {
    //                 const key = current.toISOString().slice(0, 7);
    //                 set.add(key);
    //                 current.setMonth(current.getMonth() + 1);
    //             }
    //         }
    //     });

    //     return set;
    // }, [existingArrears]);

    const { usedMonthTypeSet, usedDatesSet, usedDaysMonthSet } = useMemo(() => {
        const monthType = new Set();
        const dates = new Set();
        const daysMonth = new Set();

        //  1. Existing arrears 
        existingArrears.forEach(item => {
            if (item.calculation_type === "days") {
                item.date_list?.forEach(d => {
                    dates.add(d);
                    daysMonth.add(d.slice(0, 7));
                });
            }

            if (item.calculation_type === "months") {
                let current = new Date(item.start_date);
                const end = new Date(item.end_date);

                while (current <= end) {
                    const key = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}`;
                    monthType.add(key);
                    current.setMonth(current.getMonth() + 1);
                }
            }
        });

        //get employee timeline data
        const arrearData = payrunList?.arrear_data;

        // Used Months (FULL LOCK)
        arrearData?.used_months?.forEach(m => {
            const key = `${m.year}-${String(m.month).padStart(2, '0')}`;
            monthType.add(key);
        });

        // Used Dates (PARTIAL LOCK)
        arrearData?.used_dates?.forEach(d => {
            dates.add(d);
            daysMonth.add(d.slice(0, 7));
        });

        return {
            usedMonthTypeSet: monthType,
            usedDatesSet: dates,
            usedDaysMonthSet: daysMonth
        };
    }, [existingArrears, payrunList]);


    const getAllEmp_code = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getDynamicNatureOption = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamic-nature-byfilter/${formData.sub_company}/${format}/`
            );

            setNatureOptionList(res.data);
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };

    const getEmployeeTimeline = async (empcode) => {
        setBuffering3(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${empcode}/`);
            setPayrunList(res.data);
        } catch (err) {
        } finally {
            setBuffering3(false);
        }
    }


    useEffect(() => {
        if (show) {
            getAllEmp_code();
            getDynamicNatureOption();
        }
    }, [formData.sub_company])


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "amount", "approved_amount",
        ];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });

        if (name === "nature_option") {
            const selected = natureOptionList.find((i) => i.id === value);
            setCalculationType(selected?.calculation_type || "");
        }
        if (name === "emp_code") {
            getEmployeeTimeline(value);
            setErrors(prev => ({
                ...prev,
                date_list: ""
            }));

        }
    };


    const handleMonthInputChange = (e, type) => {
        const { name, value } = e.target;

        if (!value) return;

        // if (!formData.applicable_month_year) {
        //     setErrors(prev => ({
        //         ...prev,
        //         start_date: "Please select Applicable Month & Year first.",
        //         end_date: "Please select Applicable Month & Year first."
        //     }));

        //     setFormData(prev => ({
        //         ...prev,
        //         start_date: "",
        //         end_date: "",
        //         days_calculated: 0
        //     }));

        //     return;
        // }

        const selectedMonthDate = new Date(value + "-01");

        const applicableDate = new Date(formData.applicable_month_year + "-01");

        //  Previous month of applicable
        const previousMonth = new Date(
            applicableDate.getFullYear(),
            applicableDate.getMonth() - 1,
            1
        );
        const today = new Date();
        let errorMessage = "";


        const { minBase } = minMaxDates;

        // if (selectedMonthDate < minBase) {
        //     errorMessage = `You can select from ${minBase.toLocaleString(
        //         "default",
        //         { month: "long", year: "numeric" }
        //     )} onwards only`;
        // }
        // else if (selectedMonthDate > currentMonth) {
        //     errorMessage = "Future months are not allowed.";
        // }



        //  ONLY allow minBase month
        if (
            selectedMonthDate.getFullYear() !== minBase.getFullYear() ||
            selectedMonthDate.getMonth() !== minBase.getMonth()
        ) {
            setErrors(prev => ({
                ...prev,
                [name]: `Only ${minBase.toLocaleString("default", {
                    month: "long",
                    year: "numeric"
                })} is allowed.`
            }));

            setFormData(prev => ({
                ...prev,
                [name]: "",
                days_calculated: 0
            }));

            return;
        }

        if (
            selectedMonthDate.getFullYear() > applicableDate.getFullYear() ||
            (
                selectedMonthDate.getFullYear() === applicableDate.getFullYear() &&
                selectedMonthDate.getMonth() >= applicableDate.getMonth()
            )
        ) {
            errorMessage = `You can select only months before ${applicableDate.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )}`;
        }

        const monthKey = value;

        //  If month already used in month-type
        if (usedMonthTypeSet.has(monthKey)) {
            setErrors(prev => ({
                ...prev,
                [name]: "This month already has arrear applied."
            }));
            return;
        }

        //  If ANY days exist in that month → block
        if (usedDaysMonthSet.has(monthKey)) {
            setErrors(prev => ({
                ...prev,
                [name]: "Cannot apply full month arrear because some days are already used."
            }));
            return;
        }

        if (errorMessage) {
            setErrors(prev => ({
                ...prev,
                [name]: errorMessage
            }));

            setFormData(prev => ({
                ...prev,
                [name]: "",
                days_calculated: 0
            }));

            return;
        }

        const formattedDate = getMonthBoundaryDate(value, type);


        // setFormData(prev => {
        //     const updated = {
        //         ...prev,
        //         [name]: formattedDate
        //     };

        //     if (updated.start_date && updated.end_date) {
        //         const start = new Date(updated.start_date);
        //         const end = new Date(updated.end_date);

        //         //  EXISTING CONDITION
        //         if (start > end) {
        //             setErrors(prev => ({
        //                 ...prev,
        //                 end_date: "End month cannot be before start month."
        //             }));
        //             updated.end_date = "";
        //             updated.days_calculated = 0;
        //             return updated;
        //         }

        //         //  NEW CONDITION (ONLY 1 MONTH ALLOWED)
        //         if (
        //             start.getFullYear() !== end.getFullYear() ||
        //             start.getMonth() !== end.getMonth()
        //         ) {
        //             setErrors(prev => ({
        //                 ...prev,
        //                 end_date: "Only one month duration is allowed. Start and End month must be same."
        //             }));

        //             updated.end_date = "";
        //             updated.days_calculated = 0;
        //             return updated;
        //         }

        //         //  CALCULATE DAYS (only when valid)
        //         updated.days_calculated = calculateDaysBetween(
        //             updated.start_date,
        //             updated.end_date
        //         );
        //     }

        //     return updated;
        // });
        setFormData(prev => {
            const updated = {
                ...prev,
                [name]: formattedDate
            };

            //  AUTO SET END MONTH = START MONTH
            if (type === "start") {
                updated.end_date = formattedDate;
            }

            if (updated.start_date && updated.end_date) {
                const start = new Date(updated.start_date);
                const end = new Date(updated.end_date);

                //  Start > End
                if (start > end) {
                    setErrors(prev => ({
                        ...prev,
                        end_date: "End month cannot be before start month."
                    }));
                    updated.end_date = "";
                    updated.days_calculated = 0;
                    return updated;
                }

                //  Different months 
                if (
                    start.getFullYear() !== end.getFullYear() ||
                    start.getMonth() !== end.getMonth()
                ) {
                    setErrors(prev => ({
                        ...prev,
                        end_date: "Only one month allowed. Start and End must be same."
                    }));

                    updated.end_date = "";
                    updated.days_calculated = 0;
                    return updated;
                }

                //  Calculate days
                updated.days_calculated = calculateDaysBetween(
                    updated.start_date,
                    updated.end_date
                );
            }

            return updated;
        });
        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];

        setFormData({
            ...formData,
            [name]: file,
        });

        if (file) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }
    };




    const handleDateSelect = (selectedDates) => {

        // if (!formData.applicable_month_year) {
        //     setErrors(prev => ({
        //         ...prev,
        //         date_list: "Please select Applicable Month & Year first."
        //     }));
        //     setFormData(prev => ({
        //         ...prev,
        //         date_list: [],
        //         days_calculated: 0
        //     }));
        //     return;
        // }

        let filtered = [...selectedDates];
        let errorMessage = "";

        const applicableDate = new Date(formData.applicable_month_year + "-01");

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const { minBase } = minMaxDates;


        // const conflict = selectedDates.some(d => {
        //     const month = d.slice(0, 7);
        //     return usedMonthsSet.has(month);
        // });
        const conflict = selectedDates.some(d => {
            const month = d.slice(0, 7);

            //  If month already used in MONTH type - block
            if (usedMonthTypeSet.has(month)) return true;

            //  If exact date already used - block
            if (usedDatesSet.has(d)) return true;

            return false;
        });


        if (conflict) {
            setErrors(prev => ({
                ...prev,
                date_list: "Some selected dates or month already used in arrear."
            }));
            return;
        }

        //  Flags for error messages
        let hasFutureDate = false;
        let hasApplicableMonthDate = false;
        let hasBeforeMinBase = false;

        const validDates = filtered.filter(d => {
            const date = new Date(d);

            //  Future (including today)
            if (date >= today) {
                hasFutureDate = true;
            }

            //  Applicable month
            if (
                date.getFullYear() === applicableDate.getFullYear() &&
                date.getMonth() === applicableDate.getMonth()
            ) {
                hasApplicableMonthDate = true;
            }

            //  Before minBase
            if (date < minBase) {
                hasBeforeMinBase = true;
            }

            const isBeforeApplicableMonth =
                date.getFullYear() < applicableDate.getFullYear() ||
                (
                    date.getFullYear() === applicableDate.getFullYear() &&
                    date.getMonth() < applicableDate.getMonth()
                );

            const isNotFutureDate = date < today;

            return date >= minBase && isBeforeApplicableMonth && isNotFutureDate;
        });


        if (hasFutureDate) {
            errorMessage = "Future dates are not allowed. Please select dates before today.";
        }
        else if (hasApplicableMonthDate) {
            errorMessage = `Dates from ${applicableDate.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} are not allowed.`;
        }
        else if (hasBeforeMinBase) {
            errorMessage = `You can select dates from ${minBase.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} onwards only.`;
        }


        setFormData(prev => ({
            ...prev,
            date_list: validDates,
            days_calculated: validDates.length
        }));

        setErrors(prev => ({
            ...prev,
            date_list: errorMessage
        }));
    };
    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };


    //**************************valedation Start**************** */

    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "emp_code",
            "reason",
            "nature_option",
            "proof",
            "applicable_month_year",
            // calculationType === "days" ? "date_list" : null,
            calculationType === "months" ? "start_date" : null,
            calculationType === "months" ? "end_date" : null,
            calculationType === "amount" ? "amount" : null,
        ].filter(Boolean);

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${formatFieldName(field)} is required!`;
            }
        });

        if (calculationType === "days") {
            if (!formData.date_list || formData.date_list.length === 0) {
                newErrors.date_list = "At least one date is required!";
            }
        }



        if (formData.applicable_month_year && payrunList) {
            const selectedDate = new Date(formData.applicable_month_year + "-01");
            const joiningDate = new Date(payrunList.joining_date);

            // if (selectedDate < joiningDate) {
            //     newErrors.applicable_month_year = `Applicable month allowed only from ${joiningDate.toLocaleString(
            //         "default",
            //         { month: "long", year: "numeric" }
            //     )}.`;
            // }
        }


        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleApplicableMonthYearChange = (e) => {
        const value = e.target.value;

        if (!value || !minMaxDates) {
            setFormData(prev => ({ ...prev, applicable_month_year: value }));
            return;
        }

        const selectedDate = new Date(value + "-01");

        let errorMessage = "";


        const lastPayslip = payrunList?.last_salary_slip;

        if (lastPayslip) {
            const lastMonth = `${lastPayslip.year}-${String(lastPayslip.month).padStart(2, "0")}`;

            if (value === lastMonth) {
                errorMessage = `Arrear cannot be applied for ${new Date(
                    lastPayslip.year,
                    lastPayslip.month - 1
                ).toLocaleString("default", { month: "long", year: "numeric" })} because salary is already processed.`;
            }
        }

        if (minMaxDates.applicableMin && selectedDate < minMaxDates.applicableMin) {

            errorMessage = `You can apply arrear from ${minMaxDates.applicableMin.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} onwards only`;
        }
        else if (minMaxDates.applicableMax && selectedDate > minMaxDates.applicableMax) {
            errorMessage = `You can select only up to ${minMaxDates.applicableMax.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )}`;
        }

        if (errorMessage) {
            setErrors(prev => ({
                ...prev,
                applicable_month_year: errorMessage
            }));

            setFormData(prev => ({
                ...prev,
                applicable_month_year: ""
            }));

            return;
        }

        setFormData(prev => ({
            ...prev,
            applicable_month_year: value
        }));

        setErrors(prev => ({
            ...prev,
            applicable_month_year: ""
        }));
    };



    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait...");


            let applicableYear = "";
            let applicableMonth = "";

            if (formData.applicable_month_year) {
                const [year, month] = formData.applicable_month_year.split("-");
                applicableYear = year;
                applicableMonth = month;
            }


            const uploadData = new FormData();
            uploadData.append("emp_code", formData.emp_code);
            uploadData.append("reason", formData.reason);
            uploadData.append("nature_option", formData.nature_option);
            uploadData.append("applicable_year", applicableYear);
            uploadData.append("applicable_month", applicableMonth);
            uploadData.append("status", formData.status);
            uploadData.append("sub_company", formData.sub_company);
            uploadData.append('days_calculated', formData.days_calculated || 0);
            uploadData.append("created_by", formData.created_by);
            uploadData.append("updated_by", formData.updated_by);

            const attachmentFile = formData.proof;
            if (attachmentFile && typeof attachmentFile !== 'string') {
                const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                uploadData.append("proof", customFile);

            }

            if (calculationType === "amount") {
                uploadData.append("amount", formData.amount);
            }
            else if (calculationType === "days") {
                uploadData.append("date_list", JSON.stringify(formData.date_list));

            }
            else if (calculationType === "months") {
                uploadData.append('start_date', formData.start_date);
                uploadData.append('end_date', formData.end_date);
            }
            console.log(formData, "formadat");

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/arrear/`,
                    uploadData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
                );
                if (res.status === 200 || res.status === 201) {
                    await getArrear();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Arrear created successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };

    useEffect(() => {
        if (isSubmitted) {
            validateForm();
        }
    }, [formData.applicable_month_year]);



    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Add Arrear">
                <AddwithWhiteCircle />  Arrear
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Arrear</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.sub_company
                                            ? "error"
                                            : inputState.sub_company
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>
                                                {i.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.sub_company && (
                                        <span className="error-message font-size-text ">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>
                            )}

                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    To Employee<span className="required">*</span>
                                </label>
                                {buffer1 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <select
                                        name="emp_code"
                                        value={formData.emp_code}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select An Employee</option>
                                        {empList
                                            .sort((a, b) => a.emp_code - b.emp_code)
                                            .map((i, index) => (
                                                <option value={i.emp_code}>
                                                    {i.emp_code} - {i.name}
                                                </option>
                                            ))}
                                    </select>
                                )}
                                {errors.emp_code && (
                                    <span className="error-message font-size-text ">
                                        {errors.emp_code}
                                    </span>
                                )}
                            </div>



                            {/* <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Applicable Month & Year <span className="required">*</span>
                                </label>

                                <input
                                    type="month"
                                    name="applicable_month_year"
                                    value={formData.applicable_month_year}
                                    min={payrunList?.joining_date?.slice(0, 7)}
                                    max={new Date().toISOString().slice(0, 7)}
                                    onChange={handleApplicableMonthYearChange}
                                    className={`multi-day-input1 form-input w-auto form-input-background 
            ${errors.applicable_month_year ? "error" : inputState.applicable_month_year ? "success" : ""}`}
                                />

                                {errors.applicable_month_year && (
                                    <span className="error-message font-size-text">
                                        {errors.applicable_month_year}
                                    </span>
                                )}
                            </div> */}
                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Applicable Month & Year <span className="required">*</span>
                                </label>

                                <input
                                    type="month"
                                    name="applicable_month_year"
                                    value={formData.applicable_month_year}
                                    // min={payrunList?.joining_date?.slice(0, 7)}
                                    // max={new Date().toISOString().slice(0, 7)}
                                    // min={getMinMaxDates()?.applicableMin?.toISOString().slice(0, 7)}
                                    // max={getMinMaxDates()?.applicableMax?.toISOString().slice(0, 7)}
                                    min={
                                        minMaxDates?.applicableMin
                                            ? formatToYYYYMM(minMaxDates.applicableMin)
                                            : undefined
                                    }
                                    max={
                                        minMaxDates?.applicableMax
                                            ? formatToYYYYMM(minMaxDates.applicableMax)
                                            : undefined
                                    }
                                    onChange={handleApplicableMonthYearChange}
                                    className={`multi-day-input1 form-input w-auto form-input-background 
                                    ${errors.applicable_month_year ? "error" : inputState.applicable_month_year ? "success" : ""}`}
                                />

                                {errors.applicable_month_year && (
                                    <span className="error-message font-size-text">
                                        {errors.applicable_month_year}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column ">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Nature<span className="required">*</span>
                                </label>
                                {buffer2 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <select
                                        name="nature_option"
                                        value={formData.nature_option}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.nature_option
                                            ? "error"
                                            : inputState.nature_option
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select Nature</option>
                                        {natureOptionList
                                            .map((i, index) => (
                                                <option value={i.id}>
                                                    {i.name}
                                                </option>
                                            ))}
                                    </select>
                                )}

                                {errors.nature_option && (
                                    <span className="error-message font-size-text ">
                                        {errors.nature_option}
                                    </span>
                                )}
                            </div>

                            {calculationType === "amount" && <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Amount<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    name="amount"
                                    min={0}
                                    disabled={!formData.applicable_month_year}
                                    title={
                                        !formData.applicable_month_year
                                            ? "Please select Applicable Month & Year first"
                                            : ""
                                    }
                                    style={{
                                        cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                    }}
                                    placeholder="Enter amount"
                                    onWheel={(e) => e.target.blur()}
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    className={` form-input w-auto ${errors.amount ? "error" : inputState.amount ? "success" : ""}`}
                                />
                                {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
                            </div>}

                            {calculationType === "days" && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Date <span className="required">*</span>
                                    </label>


                                    <MultiDateSelectBackupLatest
                                        value={formData.date_list}
                                        onChange={(selectedDates) => handleDateSelect(selectedDates)}
                                        placeholder="Click to select dates"
                                        error={errors.date_list}
                                        // Disabledtitle={
                                        //     !formData.applicable_month_year
                                        //         ? "Please select Applicable Month & Year first"
                                        //         : ""
                                        // }
                                        disabled={loading || buffer2 || !formData.applicable_month_year}

                                        style={{
                                            // width: '98%',
                                            cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                        }}
                                        // disableDate={(current) => {
                                        //     if (!formData.applicable_month_year) return true;
                                        //     if (!current || !minMaxDates) return false;

                                        //     const date = current.toDate();
                                        //     const today = new Date();
                                        //     today.setHours(0, 0, 0, 0);

                                        //     const applicableDate = new Date(formData.applicable_month_year + "-01");
                                        //     const { minBase } = minMaxDates;

                                        //     const monthKey = current.format("YYYY-MM");

                                        //     // ❌ Before allowed range


                                        //     if (
                                        //         date.getFullYear() !== minBase.getFullYear() ||
                                        //         date.getMonth() !== minBase.getMonth()
                                        //     ) return true;

                                        //     // ❌ Future dates
                                        //     if (date >= today) return true;

                                        //     // ❌ Same month as applicable
                                        //     if (
                                        //         date.getFullYear() === applicableDate.getFullYear() &&
                                        //         date.getMonth() === applicableDate.getMonth()
                                        //     ) return true;

                                        //     // ❌ block full month if month-type used
                                        //     if (usedMonthTypeSet.has(monthKey)) return true;

                                        //     // ❌ block specific used dates
                                        //     if (usedDatesSet.has(current.format("YYYY-MM-DD"))) return true;

                                        //     return false;
                                        // }}
                                        disableDate={(current) => {
                                            if (!formData.applicable_month_year) return true;

                                            if (!current || !minMaxDates) return { disabled: false };

                                            const date = current.toDate();
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);

                                            const applicableDate = new Date(formData.applicable_month_year + "-01");
                                            const { minBase } = minMaxDates;

                                            const monthKey = current.format("YYYY-MM");
                                            const dateStr = current.format("YYYY-MM-DD");

                                            // ❌ Only allowed month
                                            if (
                                                date.getFullYear() !== minBase.getFullYear() ||
                                                date.getMonth() !== minBase.getMonth()
                                            ) return true;

                                            // ❌ Future
                                            if (date >= today) {
                                                return { disabled: true, reason: "Future dates are not allowed" };
                                            }

                                            // ❌ Applicable month
                                            if (
                                                date.getFullYear() === applicableDate.getFullYear() &&
                                                date.getMonth() === applicableDate.getMonth()
                                            ) {
                                                return { disabled: true, reason: "Applicable month dates not allowed" };
                                            }

                                            // ❌ Full month lock
                                            if (usedMonthTypeSet.has(monthKey)) {
                                                return { disabled: true, reason: "This month already has arrear applied" };
                                            }

                                            // ❌ Specific date lock
                                            if (usedDatesSet.has(dateStr)) {
                                                return { disabled: true, reason: "This date already has arrear applied" };
                                            }

                                            return { disabled: false };
                                        }}
                                    />


                                    {formData.date_list.length > 0 && (
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#666',
                                            marginTop: '4px',
                                            marginLeft: '4px',
                                        }}>
                                            Selected {formData.date_list.length} date(s) •
                                            Total days: {formData.days_calculated}
                                        </div>
                                    )}


                                    {(usedMonthTypeSet.size > 0 || usedDatesSet.size > 0) && (
                                        <div style={{
                                            fontSize: "12px",
                                            color: "#999",
                                            marginTop: "4px"
                                        }}>
                                            {usedMonthTypeSet.size > 0 && (
                                                <div>
                                                    Full months locked: {[...usedMonthTypeSet].join(", ")} because of already applied
                                                </div>
                                            )}

                                            {usedDatesSet.size > 0 && (
                                                <div>
                                                    Some dates are already used and cannot be selected again.
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}

                            {calculationType === "months" && (
                                <div className="form-flex-wrap flex-row" style={{ marginBottom: '20px' }}>
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Start Month<span className="required">*</span>
                                        </label>
                                        <input
                                            type="month"
                                            name="start_date"
                                            value={formData.start_date?.slice(0, 7) || ""}
                                            onChange={(e) => handleMonthInputChange(e, "start")}
                                            // max={formData.end_date?.slice(0, 7) || ""}
                                            disabled={!formData.applicable_month_year}
                                            title={
                                                !formData.applicable_month_year
                                                    ? "Please select Applicable Month & Year first"
                                                    : ""
                                            }
                                            style={{
                                                cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                            }}
                                            max={formatToYYYYMM(minMaxDates?.minBase)}
                                            min={minMaxDates?.minBase ? formatToYYYYMM(minMaxDates.minBase) : undefined}
                                            // max={formData.applicable_month_year ? getPreviousMonth(formData.applicable_month_year) : undefined}
                                            // max={formData.applicable_month_year}
                                            // min={payrunList?.joining_date?.slice(0, 7)}

                                            className={`multi-day-input1 form-input-background ${errors.start_date ? "error" : inputState.start_date ? "success" : ""
                                                }`}
                                        />
                                        {errors.start_date && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.start_date}
                                            </span>
                                        )}
                                    </div>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            End Month<span className="required">*</span>
                                        </label>
                                        <input
                                            type="month"
                                            name="end_date"
                                            value={formData.end_date?.slice(0, 7) || ""}
                                            onChange={(e) => handleMonthInputChange(e, "end")}
                                            disabled={!formData.applicable_month_year}
                                            title={
                                                !formData.applicable_month_year
                                                    ? "Please select Applicable Month & Year first"
                                                    : ""
                                            }
                                            style={{
                                                cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                            }}
                                            // min={formData.start_date?.slice(0, 7)}
                                            // max={formData.applicable_month_year ? getPreviousMonth(formData.applicable_month_year) : undefined}
                                            min={formData.start_date?.slice(0, 7)}
                                            max={formData.start_date?.slice(0, 7)}
                                            // max={formData.applicable_month_year}

                                            // min={formData.start_date?.slice(0, 7) || ""}
                                            className={`multi-day-input1 form-input-background ${errors.end_date ? "error" : inputState.end_date ? "success" : ""
                                                }`}
                                        />
                                        {errors.end_date && (
                                            <span className="error-message font-size-text mt-2">
                                                {errors.end_date}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            )}




                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Reason<span className="required">*</span>
                                </label>
                                <textarea
                                    id="reason"
                                    type="text"
                                    name="reason"
                                    placeholder="Reason"
                                    onChange={handleInputChange}
                                    // maxLength={200}
                                    value={formData.reason}
                                    className={`form-input-textarea w-auto font-weight400  font-size-subheading ${errors.reason
                                        ? "error"
                                        : inputState.reason
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.reason && <span className="error-message font-size-text">{errors.reason}</span>}
                            </div>



                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Proof<span className="required">*</span>
                                </label>

                                <div
                                    className={`file-upload-container flex-row justify-between file-in-upload w-auto`}
                                    style={{ padding: "0 3px", marginBottom: '20px' }}
                                >
                                    <label
                                        className="popup-label"
                                        htmlFor="proof"
                                    >
                                        <CloudUpload />
                                        <span className="truncate-url">
                                            {formData?.proof
                                                ? formData?.proof instanceof File
                                                    ? formData?.proof.name
                                                    : getFileNameFromUrl(formData?.proof)
                                                : "No file selected"}
                                        </span>
                                    </label>

                                    <input
                                        type="file"
                                        id="proof"
                                        name="proof"
                                        accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
                                        onChange={handleFileChange}
                                        className="popup-input w-auto"

                                    />
                                    <br />
                                    {formData?.proof && (
                                        <span
                                            className="file-clear"
                                            onClick={() => handleFileClear("proof")}
                                        >
                                            Clear
                                        </span>
                                    )}

                                </div>
                                {errors.proof && (
                                    <span className="error-message font-size-text">
                                        {errors.proof}
                                    </span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <p className="error-message font-size-text">
                        {/* {isSubmitted &&
                            (() => {
                                const relevantKeys = getRelevantErrorKeys();

                                const filteredErrors = Object.keys(errors).filter(
                                    (key) => errors[key] && relevantKeys.includes(key)
                                );

                                if (filteredErrors.length === 0) return null;

                                return filteredErrors.length > 5 ? (
                                    <h5 className="text-center">
                                        Please fill all mandatory fields!
                                    </h5>
                                ) : (
                                    <h6 className="text-center">
                                        {filteredErrors
                                            .map((field) =>
                                                field
                                                    .replace(/_/g, " ")
                                                    .replace(/\b\w/g, (c) => c.toUpperCase())
                                            )
                                            .join(", ") + " are required!"}
                                    </h6>
                                );
                            })()} */}
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors)
                                        .map((field) =>
                                            field
                                                .replace(/_/g, ' ')
                                                .replace(/\b\w/g, (char) => char.toUpperCase())
                                        )
                                        .join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};

const UpdateArrear = ({ i, getArrear, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [emp_code, setEmp_code] = useState(i?.emp_code);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        // setFormData(i);
        getAllEmp_code();
        getDynamicNatureOption();
        if (emp_code) {
            getEmployeeTimeline(emp_code);
        }
        setShow(true);
    };



    // --------------------- Initial Data---------------------
    const initialData = {
        emp_code: "",
        sub_company: sessionStorage.getItem('company_id'),
        nature_option: "",
        applicable_year: "",
        applicable_month: "",
        status: "pending",
        //case 1
        date_list: [],
        //case 2
        start_date: "",
        end_date: "",
        //case 3
        amount: "",

        days_calculated: "",
        reason: "",
        proof: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),

        applicable_month_year: "", // only for take month & year at once
    }

    const [formData, setFormData] = useState(initialData);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [empList, setEmpList] = useState([]);
    const [natureOptionList, setNatureOptionList] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [buffer3, setBuffering3] = useState(true);
    const [payrunList, setPayrunList] = useState([]);
    const [calculationType, setCalculationType] = useState("");
    const [loading, setLoading] = useState(false);
    const [existingArrears, setExistingArrears] = useState([]);
    //**************************valedation Start**************** */

    const getMinMaxDates = () => {
        if (!payrunList || !payrunList.joining_date) return null;

        const joiningDate = new Date(payrunList.joining_date);

        const lastPayslipDate = payrunList?.last_salary_slip
            ? new Date(
                payrunList.last_salary_slip.year,
                payrunList.last_salary_slip.month - 1,
                1
            )
            : null;

        //  for days/months selection
        const minBase = lastPayslipDate || new Date(
            joiningDate.getFullYear(),
            joiningDate.getMonth(),
            1
        );

        //  for applicable month 
        const applicableMin = lastPayslipDate
            ? new Date(
                lastPayslipDate.getFullYear(),
                lastPayslipDate.getMonth() + 1,
                1
            )
            : new Date(
                joiningDate.getFullYear(),
                joiningDate.getMonth(),
                1
            );

        const applicableMax = new Date();
        applicableMax.setFullYear(applicableMax.getFullYear() + 1);

        return { minBase, applicableMin, applicableMax };
    };

    const minMaxDates = useMemo(() => {
        return getMinMaxDates();
    }, [payrunList])

    const { usedMonthTypeSet, usedDatesSet, usedDaysMonthSet } = useMemo(() => {
        const monthType = new Set();
        const dates = new Set();
        const daysMonth = new Set();

        //  1. Existing arrears 
        existingArrears.forEach(item => {
            if (item.calculation_type === "days") {
                item.date_list?.forEach(d => {
                    dates.add(d);
                    daysMonth.add(d.slice(0, 7));
                });
            }

            if (item.calculation_type === "months") {
                let current = new Date(item.start_date);
                const end = new Date(item.end_date);

                while (current <= end) {
                    const key = `${current.getFullYear()}-${String(current.getMonth() + 1).padStart(2, '0')}`;
                    monthType.add(key);
                    current.setMonth(current.getMonth() + 1);
                }
            }
        });

        //get employee timeline data
        const arrearData = payrunList?.arrear_data;

        // Used Months (FULL LOCK)
        arrearData?.used_months?.forEach(m => {
            const key = `${m.year}-${String(m.month).padStart(2, '0')}`;
            monthType.add(key);
        });

        // Used Dates (PARTIAL LOCK)
        arrearData?.used_dates?.forEach(d => {
            dates.add(d);
            daysMonth.add(d.slice(0, 7));
        });

        return {
            usedMonthTypeSet: monthType,
            usedDatesSet: dates,
            usedDaysMonthSet: daysMonth
        };
    }, [existingArrears, payrunList]);


    const getAllEmp_code = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );
            const sortedList = customSortByKey(res.data, "emp_code");
            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getDynamicNatureOption = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamic-nature-byfilter/${formData.sub_company}/arrear/`
            );
            setNatureOptionList(res.data);
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };

    const getEmployeeTimeline = async (empcode) => {
        setBuffering3(true);
        try {
            const res = await axios.get(`${BASE_URL}/wfm/employee-latest-timeline/${empcode}/`);
            setPayrunList(res.data);
        } catch (err) {
        } finally {
            setBuffering3(false);
        }
    }

    const validateForm = () => {
        const newErrors = {};

        const requiredFields = [
            "emp_code",
            "reason",
            "nature_option",
            "proof",
            "applicable_month_year",
            calculationType === "days" ? "date_list" : null,
            calculationType === "months" ? "start_date" : null,
            calculationType === "months" ? "end_date" : null,
            calculationType === "amount" ? "amount" : null,
        ].filter(Boolean);

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = `${formatFieldName(field)} is required!`;
            }
        });

        if (calculationType === "days") {
            if (!formData.date_list || formData.date_list.length === 0) {
                newErrors.date_list = "At least one date is required!";
            }
        }



        if (formData.applicable_month_year && payrunList) {
            const selectedDate = new Date(formData.applicable_month_year + "-01");
            const joiningDate = new Date(payrunList.joining_date);

            // if (selectedDate < joiningDate) {
            //     newErrors.applicable_month_year = `Applicable month allowed only from ${joiningDate.toLocaleString(
            //         "default",
            //         { month: "long", year: "numeric" }
            //     )}.`;
            // }
        }

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = ["amount", "approved_amount"];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) return;

            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors(prev => ({
                    ...prev,
                    [name]: "Value cannot be negative",
                }));
                return;
            }

            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors(prev => ({
                    ...prev,
                    [name]: error,
                }));
            }
        }
        if (name === "start_date" || name === "end_date") {

            const updatedForm = {
                ...formData,
                [name]: value,
            };

            if (updatedForm.start_date && updatedForm.end_date) {
                updatedForm.days_calculated = calculateDaysBetween(
                    updatedForm.start_date,
                    updatedForm.end_date
                );
            }

            setFormData(updatedForm);
            return;
        }


        if (name === "nature_option") {

            const selected = natureOptionList.find(i => i.id === value);

            const type = selected?.calculation_type || "";

            setCalculationType(type);

            setFormData(prev => ({
                ...prev,
                nature_option: value,

                amount: type === "amount" ? prev.amount : "",
                date_list: type === "days" ? prev.date_list : [],
                start_date: type === "months" ? prev.start_date : "",
                end_date: type === "months" ? prev.end_date : "",
                days_calculated:
                    type === "days"
                        ? prev.date_list?.length || 0
                        : type === "months"
                            ? prev.days_calculated || 0
                            : "",
                // days_calculated: 0
            }));

            return;
        }

        if (name === "emp_code") {
            setFormData(prev => ({
                ...prev,
                emp_code: value,
                date_list: prev.date_list || [],
            }));

            getEmployeeTimeline(value);
            setErrors(prev => ({
                ...prev,
                date_list: ""
            }));
        }

        setInputState(prev => ({
            ...prev,
            [name]: value.trim() ? "green" : "",
        }));

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };


    useEffect(() => {
        if (i && natureOptionList.length > 0) {

            const selectedNature = natureOptionList.find(
                n => n.id === i.nature_option
            );

            const type = selectedNature?.calculation_type || "";

            setCalculationType(type);

            const monthStr = String(i.applicable_month).padStart(2, "0");

            setFormData({
                ...i,
                applicable_month_year: `${i.applicable_year}-${monthStr}`,
                date_list: i.date_list || [],
            });
        }
    }, [i, natureOptionList]);


    const handleApplicableMonthYearChange = (e) => {
        const value = e.target.value;

        if (!value || !minMaxDates) {
            setFormData(prev => ({ ...prev, applicable_month_year: value }));
            return;
        }

        const selectedDate = new Date(value + "-01");

        let errorMessage = "";


        const lastPayslip = payrunList?.last_salary_slip;

        if (lastPayslip) {
            const lastMonth = `${lastPayslip.year}-${String(lastPayslip.month).padStart(2, "0")}`;

            if (value === lastMonth) {
                errorMessage = `Arrear cannot be applied for ${new Date(
                    lastPayslip.year,
                    lastPayslip.month - 1
                ).toLocaleString("default", { month: "long", year: "numeric" })} because salary is already processed.`;
            }
        }

        if (minMaxDates.applicableMin && selectedDate < minMaxDates.applicableMin) {

            errorMessage = `You can apply arrear from ${minMaxDates.applicableMin.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} onwards only`;
        }
        else if (minMaxDates.applicableMax && selectedDate > minMaxDates.applicableMax) {
            errorMessage = `You can select only up to ${minMaxDates.applicableMax.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )}`;
        }

        if (errorMessage) {
            setErrors(prev => ({
                ...prev,
                applicable_month_year: errorMessage
            }));

            setFormData(prev => ({
                ...prev,
                applicable_month_year: ""
            }));

            return;
        }

        setFormData(prev => ({
            ...prev,
            applicable_month_year: value
        }));

        setErrors(prev => ({
            ...prev,
            applicable_month_year: ""
        }));
    };

    const handleMonthInputChange = (e, type) => {
        const { name, value } = e.target;

        if (!value) return;

        // if (!formData.applicable_month_year) {
        //     setErrors(prev => ({
        //         ...prev,
        //         start_date: "Please select Applicable Month & Year first.",
        //         end_date: "Please select Applicable Month & Year first."
        //     }));

        //     setFormData(prev => ({
        //         ...prev,
        //         start_date: "",
        //         end_date: "",
        //         days_calculated: 0
        //     }));

        //     return;
        // }

        const selectedMonthDate = new Date(value + "-01");

        const applicableDate = new Date(formData.applicable_month_year + "-01");

        //  Previous month of applicable
        const previousMonth = new Date(
            applicableDate.getFullYear(),
            applicableDate.getMonth() - 1,
            1
        );
        const today = new Date();
        let errorMessage = "";


        const { minBase } = minMaxDates;

        // if (selectedMonthDate < minBase) {
        //     errorMessage = `You can select from ${minBase.toLocaleString(
        //         "default",
        //         { month: "long", year: "numeric" }
        //     )} onwards only`;
        // }
        // else if (selectedMonthDate > currentMonth) {
        //     errorMessage = "Future months are not allowed.";
        // }



        //  ONLY allow minBase month
        if (
            selectedMonthDate.getFullYear() !== minBase.getFullYear() ||
            selectedMonthDate.getMonth() !== minBase.getMonth()
        ) {
            setErrors(prev => ({
                ...prev,
                [name]: `Only ${minBase.toLocaleString("default", {
                    month: "long",
                    year: "numeric"
                })} is allowed.`
            }));

            setFormData(prev => ({
                ...prev,
                [name]: "",
                days_calculated: 0
            }));

            return;
        }

        if (
            selectedMonthDate.getFullYear() > applicableDate.getFullYear() ||
            (
                selectedMonthDate.getFullYear() === applicableDate.getFullYear() &&
                selectedMonthDate.getMonth() >= applicableDate.getMonth()
            )
        ) {
            errorMessage = `You can select only months before ${applicableDate.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )}`;
        }

        const monthKey = value;

        //  If month already used in month-type
        if (usedMonthTypeSet.has(monthKey)) {
            setErrors(prev => ({
                ...prev,
                [name]: "This month already has arrear applied."
            }));
            return;
        }

        //  If ANY days exist in that month → block
        if (usedDaysMonthSet.has(monthKey)) {
            setErrors(prev => ({
                ...prev,
                [name]: "Cannot apply full month arrear because some days are already used."
            }));
            return;
        }

        if (errorMessage) {
            setErrors(prev => ({
                ...prev,
                [name]: errorMessage
            }));

            setFormData(prev => ({
                ...prev,
                [name]: "",
                days_calculated: 0
            }));

            return;
        }

        const formattedDate = getMonthBoundaryDate(value, type);


        // setFormData(prev => {
        //     const updated = {
        //         ...prev,
        //         [name]: formattedDate
        //     };

        //     if (updated.start_date && updated.end_date) {
        //         const start = new Date(updated.start_date);
        //         const end = new Date(updated.end_date);

        //         //  EXISTING CONDITION
        //         if (start > end) {
        //             setErrors(prev => ({
        //                 ...prev,
        //                 end_date: "End month cannot be before start month."
        //             }));
        //             updated.end_date = "";
        //             updated.days_calculated = 0;
        //             return updated;
        //         }

        //         //  NEW CONDITION (ONLY 1 MONTH ALLOWED)
        //         if (
        //             start.getFullYear() !== end.getFullYear() ||
        //             start.getMonth() !== end.getMonth()
        //         ) {
        //             setErrors(prev => ({
        //                 ...prev,
        //                 end_date: "Only one month duration is allowed. Start and End month must be same."
        //             }));

        //             updated.end_date = "";
        //             updated.days_calculated = 0;
        //             return updated;
        //         }

        //         //  CALCULATE DAYS (only when valid)
        //         updated.days_calculated = calculateDaysBetween(
        //             updated.start_date,
        //             updated.end_date
        //         );
        //     }

        //     return updated;
        // });
        setFormData(prev => {
            const updated = {
                ...prev,
                [name]: formattedDate
            };

            //  AUTO SET END MONTH = START MONTH
            if (type === "start") {
                updated.end_date = formattedDate;
            }

            if (updated.start_date && updated.end_date) {
                const start = new Date(updated.start_date);
                const end = new Date(updated.end_date);

                //  Start > End
                if (start > end) {
                    setErrors(prev => ({
                        ...prev,
                        end_date: "End month cannot be before start month."
                    }));
                    updated.end_date = "";
                    updated.days_calculated = 0;
                    return updated;
                }

                //  Different months 
                if (
                    start.getFullYear() !== end.getFullYear() ||
                    start.getMonth() !== end.getMonth()
                ) {
                    setErrors(prev => ({
                        ...prev,
                        end_date: "Only one month allowed. Start and End must be same."
                    }));

                    updated.end_date = "";
                    updated.days_calculated = 0;
                    return updated;
                }

                //  Calculate days
                updated.days_calculated = calculateDaysBetween(
                    updated.start_date,
                    updated.end_date
                );
            }

            return updated;
        });
        setErrors(prev => ({
            ...prev,
            [name]: ""
        }));
    };

    const handleDateSelect = (selectedDates) => {

        // if (!formData.applicable_month_year) {
        //     setErrors(prev => ({
        //         ...prev,
        //         date_list: "Please select Applicable Month & Year first."
        //     }));
        //     setFormData(prev => ({
        //         ...prev,
        //         date_list: [],
        //         days_calculated: 0
        //     }));
        //     return;
        // }

        let filtered = [...selectedDates];
        let errorMessage = "";

        const applicableDate = new Date(formData.applicable_month_year + "-01");

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const { minBase } = minMaxDates;


        // const conflict = selectedDates.some(d => {
        //     const month = d.slice(0, 7);
        //     return usedMonthsSet.has(month);
        // });
        const conflict = selectedDates.some(d => {
            const month = d.slice(0, 7);

            //  If month already used in MONTH type - block
            if (usedMonthTypeSet.has(month)) return true;

            //  If exact date already used - block
            if (usedDatesSet.has(d)) return true;

            return false;
        });


        if (conflict) {
            setErrors(prev => ({
                ...prev,
                date_list: "Some selected dates or month already used in arrear."
            }));
            return;
        }

        //  Flags for error messages
        let hasFutureDate = false;
        let hasApplicableMonthDate = false;
        let hasBeforeMinBase = false;

        const validDates = filtered.filter(d => {
            const date = new Date(d);

            //  Future (including today)
            if (date >= today) {
                hasFutureDate = true;
            }

            //  Applicable month
            if (
                date.getFullYear() === applicableDate.getFullYear() &&
                date.getMonth() === applicableDate.getMonth()
            ) {
                hasApplicableMonthDate = true;
            }

            //  Before minBase
            if (date < minBase) {
                hasBeforeMinBase = true;
            }

            const isBeforeApplicableMonth =
                date.getFullYear() < applicableDate.getFullYear() ||
                (
                    date.getFullYear() === applicableDate.getFullYear() &&
                    date.getMonth() < applicableDate.getMonth()
                );

            const isNotFutureDate = date < today;

            return date >= minBase && isBeforeApplicableMonth && isNotFutureDate;
        });


        if (hasFutureDate) {
            errorMessage = "Future dates are not allowed. Please select dates before today.";
        }
        else if (hasApplicableMonthDate) {
            errorMessage = `Dates from ${applicableDate.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} are not allowed.`;
        }
        else if (hasBeforeMinBase) {
            errorMessage = `You can select dates from ${minBase.toLocaleString(
                "default",
                { month: "long", year: "numeric" }
            )} onwards only.`;
        }


        setFormData(prev => ({
            ...prev,
            date_list: validDates,
            days_calculated: validDates.length
        }));

        setErrors(prev => ({
            ...prev,
            date_list: errorMessage
        }));
    };

    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });

        if (file) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[name];
                return updatedErrors;
            });
        }

    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });

        setErrors((prevErrors) => ({
            ...prevErrors,
            [name]: "",
        }));
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait...");
            let applicableYear = "";
            let applicableMonth = "";

            if (formData.applicable_month_year) {
                const [year, month] = formData.applicable_month_year.split("-");
                applicableYear = Number(year);
                applicableMonth = Number(month);
            }

            const uploadData = new FormData();
            uploadData.append("emp_code", formData.emp_code);
            uploadData.append("reason", formData.reason);
            uploadData.append("nature_option", formData.nature_option);
            uploadData.append("applicable_year", applicableYear);
            uploadData.append("applicable_month", applicableMonth);
            uploadData.append("status", formData.status);
            uploadData.append("sub_company", formData.sub_company);
            uploadData.append('days_calculated', formData.days_calculated || 0);
            uploadData.append("created_by", formData.created_by);
            uploadData.append("updated_by", formData.updated_by);

            const attachmentFile = formData.proof;
            if (attachmentFile && typeof attachmentFile !== 'string') {
                const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                uploadData.append("proof", customFile);

            }


            if (calculationType === "amount") {
                uploadData.append("amount", formData.amount || 0);
                uploadData.append("date_list", JSON.stringify([]));
                uploadData.append("start_date", "");
                uploadData.append("end_date", "");
            }

            else if (calculationType === "days") {
                uploadData.append("amount", 0);
                uploadData.append("date_list", JSON.stringify(formData.date_list || []));
                uploadData.append("start_date", "");
                uploadData.append("end_date", "");
            }

            else if (calculationType === "months") {
                uploadData.append("amount", 0);
                uploadData.append("date_list", JSON.stringify([]));
                uploadData.append("start_date", formData.start_date || "");
                uploadData.append("end_date", formData.end_date || "");
            }


            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/arrear/${i.id}/`,
                    uploadData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
                );

                if (res.status === 200 || res.status === 201) {
                    await getArrear();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Arrear updated successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };


    useEffect(() => {
        if (formData?.applicable_month && formData?.applicable_year) {
            const monthStr = String(formData.applicable_month).padStart(2, "0");
            setFormData(prev => ({
                ...prev,
                applicable_month_year: `${formData.applicable_year}-${monthStr}`,
            }));
        }
    }, [formData.applicable_month, formData.applicable_year]);

    useEffect(() => {
        if (isSubmitted) {
            validateForm();
        }
    }, [formData.applicable_month_year]);


    return (
        <>
            <button className="model-edit-button" title="Update Arrear" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Arrear</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.sub_company
                                            ? "error"
                                            : inputState.sub_company
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>
                                                {i.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.sub_company && (
                                        <span className="error-message font-size-text ">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>

                            )}
                            <div className="flex-column ">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    To Employee<span className="required">*</span>
                                </label>
                                {buffer1 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <select
                                        name="emp_code"
                                        value={formData.emp_code}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.emp_code
                                            ? "error"
                                            : inputState.emp_code
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select An Employee</option>
                                        {empList
                                            .sort((a, b) => a.emp_code - b.emp_code)
                                            .map((i, index) => (
                                                <option value={i.emp_code}>
                                                    {i.emp_code} - {i.name}
                                                </option>
                                            ))}
                                    </select>
                                )}
                                {errors.emp_code && (
                                    <span className="error-message font-size-text ">
                                        {errors.emp_code}
                                    </span>
                                )}
                            </div>





                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Applicable Month & Year <span className="required">*</span>
                                </label>

                                <input
                                    type="month"
                                    name="applicable_month_year"
                                    value={formData.applicable_month_year}
                                    onChange={handleApplicableMonthYearChange}
                                    // min={payrunList?.joining_date?.slice(0, 7)}
                                    // max={new Date().toISOString().slice(0, 7)}
                                    // min={minMaxDates?.applicableMin
                                    //     ? minMaxDates.applicableMin.toISOString().slice(0, 7)
                                    //     : undefined}
                                    // max={
                                    //     minMaxDates?.applicableMax
                                    //         ? minMaxDates.applicableMax.toISOString().slice(0, 7)
                                    //         : undefined
                                    // }
                                    min={
                                        minMaxDates?.applicableMin
                                            ? formatToYYYYMM(minMaxDates.applicableMin)
                                            : undefined
                                    }
                                    max={
                                        minMaxDates?.applicableMax
                                            ? formatToYYYYMM(minMaxDates.applicableMax)
                                            : undefined
                                    }
                                    className={`multi-day-input1 form-input w-auto form-input-background 
                                        ${errors.applicable_month_year ? "error" : inputState.applicable_month_year ? "success" : ""}`}
                                />

                                {errors.applicable_month_year && (
                                    <span className="error-message font-size-text">
                                        {errors.applicable_month_year}
                                    </span>
                                )}
                            </div>

                            <div className="flex-column ">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Nature<span className="required">*</span>
                                </label>
                                {buffer2 ? (
                                    <div className="form-loader">
                                        <div className="bar-loader"></div>
                                    </div>
                                ) : (
                                    <select
                                        name="nature_option"
                                        value={formData.nature_option}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.nature_option
                                            ? "error"
                                            : inputState.nature_option
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select Nature</option>
                                        {natureOptionList
                                            .map((i, index) => (
                                                <option value={i.id}>
                                                    {i.name}
                                                </option>
                                            ))}
                                    </select>
                                )}

                                {errors.nature_option && (
                                    <span className="error-message font-size-text ">
                                        {errors.nature_option}
                                    </span>
                                )}
                            </div>

                            {(calculationType === "amount") && <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Amount<span className="required">*</span>
                                </label>
                                <input
                                    type="number"
                                    name="amount"
                                    min={0}
                                    disabled={!formData.applicable_month_year}
                                    title={
                                        !formData.applicable_month_year
                                            ? "Please select Applicable Month & Year first"
                                            : ""
                                    }
                                    style={{
                                        cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                    }}
                                    placeholder="Enter amount"
                                    onWheel={(e) => e.target.blur()}
                                    value={formData.amount}
                                    onChange={handleInputChange}
                                    className={` form-input w-auto
                                        errors.amount ? "error" : inputState.amount ? "success" : ""}`}
                                />
                                {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
                            </div>}


                            {(calculationType === "days") && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Date <span className="required">*</span>
                                    </label>


                                    <MultiDateSelectBackupLatest
                                        value={formData.date_list}
                                        onChange={(selectedDates) => handleDateSelect(selectedDates)}
                                        placeholder="Click to select dates"
                                        error={errors.date_list}
                                        // Disabledtitle={
                                        //     !formData.applicable_month_year
                                        //         ? "Please select Applicable Month & Year first"
                                        //         : ""
                                        // }
                                        disabled={loading || buffer2 || !formData.applicable_month_year}

                                        style={{
                                            // width: '98%',
                                            cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                        }}
                                        // disableDate={(current) => {
                                        //     if (!formData.applicable_month_year) return true;
                                        //     if (!current || !minMaxDates) return false;

                                        //     const date = current.toDate();
                                        //     const today = new Date();
                                        //     today.setHours(0, 0, 0, 0);

                                        //     const applicableDate = new Date(formData.applicable_month_year + "-01");
                                        //     const { minBase } = minMaxDates;

                                        //     const monthKey = current.format("YYYY-MM");

                                        //     // ❌ Before allowed range


                                        //     if (
                                        //         date.getFullYear() !== minBase.getFullYear() ||
                                        //         date.getMonth() !== minBase.getMonth()
                                        //     ) return true;

                                        //     // ❌ Future dates
                                        //     if (date >= today) return true;

                                        //     // ❌ Same month as applicable
                                        //     if (
                                        //         date.getFullYear() === applicableDate.getFullYear() &&
                                        //         date.getMonth() === applicableDate.getMonth()
                                        //     ) return true;

                                        //     // ❌ block full month if month-type used
                                        //     if (usedMonthTypeSet.has(monthKey)) return true;

                                        //     // ❌ block specific used dates
                                        //     if (usedDatesSet.has(current.format("YYYY-MM-DD"))) return true;

                                        //     return false;
                                        // }}
                                        disableDate={(current) => {
                                            if (!formData.applicable_month_year) return true;

                                            if (!current || !minMaxDates) return { disabled: false };

                                            const date = current.toDate();
                                            const today = new Date();
                                            today.setHours(0, 0, 0, 0);

                                            const applicableDate = new Date(formData.applicable_month_year + "-01");
                                            const { minBase } = minMaxDates;

                                            const monthKey = current.format("YYYY-MM");
                                            const dateStr = current.format("YYYY-MM-DD");

                                            // ❌ Only allowed month
                                            if (
                                                date.getFullYear() !== minBase.getFullYear() ||
                                                date.getMonth() !== minBase.getMonth()
                                            ) return true;

                                            // ❌ Future
                                            if (date >= today) {
                                                return { disabled: true, reason: "Future dates are not allowed" };
                                            }

                                            // ❌ Applicable month
                                            if (
                                                date.getFullYear() === applicableDate.getFullYear() &&
                                                date.getMonth() === applicableDate.getMonth()
                                            ) {
                                                return { disabled: true, reason: "Applicable month dates not allowed" };
                                            }

                                            // ❌ Full month lock
                                            if (usedMonthTypeSet.has(monthKey)) {
                                                return { disabled: true, reason: "This month already has arrear applied" };
                                            }

                                            // ❌ Specific date lock
                                            if (usedDatesSet.has(dateStr)) {
                                                return { disabled: true, reason: "This date already has arrear applied" };
                                            }

                                            return { disabled: false };
                                        }}
                                    />

                                    {formData.date_list.length > 0 && (
                                        <div style={{
                                            fontSize: '12px',
                                            color: '#666',
                                            marginTop: '4px',
                                            marginLeft: '4px',
                                        }}>
                                            Selected {formData.date_list.length} date(s) •
                                            Total days: {formData.days_calculated}
                                        </div>
                                    )}

                                    {(usedMonthTypeSet.size > 0 || usedDatesSet.size > 0) && (
                                        <div style={{
                                            fontSize: "12px",
                                            color: "#999",
                                            marginTop: "4px"
                                        }}>
                                            {usedMonthTypeSet.size > 0 && (
                                                <div>
                                                    Full months locked: {[...usedMonthTypeSet].join(", ")} because of already applied
                                                </div>
                                            )}

                                            {usedDatesSet.size > 0 && (
                                                <div>
                                                    Some dates are already used and cannot be selected again.
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            )}



                            {(calculationType === "months") &&
                                <div className="form-flex-wrap flex-row" style={{ marginBottom: '20px' }}>
                                    <div className="flex-column">
                                        <label htmlFor="start_date" className="form-labels font-weight500 font-size-subheading">
                                            Start Month<span className="required">*</span>
                                        </label>
                                        <input
                                            type="month"
                                            name="start_date"
                                            value={formData.start_date?.slice(0, 7) || ""}
                                            onChange={(e) => handleMonthInputChange(e, "start")}
                                            disabled={!formData.applicable_month_year}
                                            title={
                                                !formData.applicable_month_year
                                                    ? "Please select Applicable Month & Year first"
                                                    : ""
                                            }
                                            style={{
                                                cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                            }}
                                            max={formatToYYYYMM(minMaxDates?.minBase)}
                                            min={minMaxDates?.minBase ? formatToYYYYMM(minMaxDates.minBase) : undefined}
                                            className={`multi-day-input1 form-input-background ${errors.start_date ? "error" : inputState.start_date ? "success" : ""
                                                }`}
                                        />
                                        {errors.start_date && <span className="error-message font-size-text mt-2">{errors.start_date}</span>}
                                    </div>

                                    <div className="flex-column">
                                        <label htmlFor="end_date" className="form-labels font-weight500 font-size-subheading">
                                            End Month<span className="required">*</span>
                                        </label>

                                        <input
                                            type="month"
                                            name="end_date"
                                            value={formData.end_date?.slice(0, 7) || ""}
                                            onChange={(e) => handleMonthInputChange(e, "end")}
                                            disabled={!formData.applicable_month_year}
                                            title={
                                                !formData.applicable_month_year
                                                    ? "Please select Applicable Month & Year first"
                                                    : ""
                                            }
                                            style={{
                                                cursor: !formData.applicable_month_year ? 'not-allowed' : 'pointer'
                                            }}
                                            // min={formData.start_date?.slice(0, 7)}
                                            // max={formData.applicable_month_year ? getPreviousMonth(formData.applicable_month_year) : undefined}
                                            min={formData.start_date?.slice(0, 7)}
                                            max={formData.start_date?.slice(0, 7)}
                                            className={`multi-day-input1 form-input-background ${errors.end_date ? "error" : inputState.end_date ? "success" : ""
                                                }`}
                                        />
                                        {errors.end_date && <span className="error-message font-size-text mt-2">{errors.end_date}</span>}
                                    </div>
                                </div>
                            }



                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Reason<span className="required">*</span>
                                </label>
                                <textarea
                                    id="reason"
                                    type="text"
                                    name="reason"
                                    placeholder="Reason"
                                    onChange={handleInputChange}
                                    // maxLength={200}
                                    value={formData.reason}
                                    className={`form-input-textarea w-auto font-weight400  font-size-subheading ${errors.reason
                                        ? "error"
                                        : inputState.reason
                                            ? "success"
                                            : ""
                                        }`}
                                />


                                {errors.reason && <span className="error-message font-size-text">{errors.reason}</span>}
                            </div>



                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Proof<span className="required">*</span>
                                </label>

                                <div
                                    className={`file-upload-container flex-row justify-between file-in-upload w-auto`}
                                    style={{ padding: "0 3px", marginBottom: '20px' }}
                                >
                                    <label
                                        className="popup-label"
                                        htmlFor="proof"
                                    >
                                        <CloudUpload />
                                        <span className="truncate-url">
                                            {formData?.proof
                                                ? formData?.proof instanceof File
                                                    ? formData?.proof.name
                                                    : getFileNameFromUrl(formData?.proof)
                                                : "No file selected"}
                                        </span>
                                    </label>

                                    <input
                                        type="file"
                                        id="proof"
                                        name="proof"
                                        accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
                                        onChange={handleFileChange}
                                        className="popup-input w-auto"

                                    />
                                    <br />
                                    {formData?.proof && (
                                        <span
                                            className="file-clear"
                                            onClick={() => handleFileClear("proof")}
                                        >
                                            Clear
                                        </span>
                                    )}

                                </div>
                                {errors.proof && (
                                    <span className="error-message font-size-text">
                                        {errors.proof}
                                    </span>
                                )}
                            </div>

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors)
                                        .map((field) =>
                                            field
                                                .replace(/_/g, ' ')
                                                .replace(/\b\w/g, (char) => char.toUpperCase())
                                        )
                                        .join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal>
        </>
    );
};

const DeleteArrear = ({ i, getArrear }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/arrear/${i.id}/`);
            if (res.status === 200) {
                await getArrear();
                setShow(false);
                toast.success("Arrear Deleted Successfully!");
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Arrear">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Arrear</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are you sure you want to delete the
                        <b> {i.nature_name}</b> arrear for
                        <b> {i.emp_name} ({i.emp_code})</b>?

                        <div className="button-models">
                            <button
                                type="button"
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>
            <ToastContainer
                position="top-center"
                autoClose={1000}
                hideProgressBar={false}
                newestOnTop={true}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </>
    );
};

const SubmitArrearForApproval = ({ i, userData, getArrear }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        status: 'submitted'
    });

    const handleConfirmSubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-declaration-submit/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getArrear();
                setShow(false);
                toast.success("Arrear Submitted Successfully!");
            } else {
                alert(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>

            <button onClick={handleShow} className="model-add-button" title="Submit Arrear">
                <SubmitArrowHead1 />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Submit Arrear</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        Please confirm to submit the Arrear.


                        <div className="button-models">
                            <button
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmSubmit}
                                className="model-button   font-weight500    model-button-submit"
                                disabled={loading}
                            >
                                {loading ? "Submitting..." : "Submit"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>

        </>
    );
};

const ResubmitArrearForApproval = ({ i, userData, getArrear }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        status: 'submitted'
    });

    const handleConfirmResubmit = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Resubmitting... Please wait...");
        setLoading(true);

        try {
            const res = await axios.put(`${BASE_URL}/wfm/investment-form-resubmit-declaration/${i.id}/`, formData);
            if (res.status === 200 || res.status === 201) {
                await getArrear();
                setShow(false);
                toast.success("Arrear Resubmitted Successfully!");
            } else {
                toast.error("Failed to resubmit arrear");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button
                onClick={handleShow}
                className="model-partial-button"
                title="Resubmit Rejected Arrear"
            >
                <SubmitArrowHead1 color={'#f7ba1e'} />
            </button>

            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Resubmit Arrear</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div text-center" style={{ fontSize: '18px' }}>
                        <p>Are you sure you want to resubmit this rejected arrear?</p>
                        <p style={{ fontSize: '14px', color: '#666', marginTop: '10px' }}>
                            This will reset the approval process and set the status back to submitted.
                        </p>

                        <div className="button-models" style={{ marginTop: '20px' }}>
                            <button
                                className="model-button model-button-cancel font-weight500"
                                onClick={handleClose}
                                disabled={loading}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleConfirmResubmit}
                                className="model-button model-button-submit font-weight500"
                                disabled={loading}
                            >
                                {loading ? "Resubmitting..." : "Confirm Resubmit"}
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};


// --------------------------------------------------------Incentive-------------------
const AddIncentive = ({ getIncentive, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        getAllEmp_code(formData.sub_company);
        getDynamicNatureOption(formData.sub_company)
        setShow(true);
    }

    const initialData = {
        emp_code: "",
        sub_company: sessionStorage.getItem('company_id'),
        amount: "",
        reason: "",
        nature_option: "",
        proof: null,
        month_year: "",
        approved_amount: "",
        status: "pending",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);

    //**************************valedation Start**************** */
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [empList, setEmpList] = useState([]);
    const [natureOptionList, setNatureOptionList] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["emp_code", "amount", "sub_company", "reason", "nature_option", "proof",
            "month_year", "approved_amount"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const numericFields = [
            "amount", "approved_amount",
        ];
        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        if (numericFields.includes(name)) {

            if (!isValidTwoDecimalNumber(value)) {
                return;
            }


            if (value.startsWith("-") || parseFloat(value) < 0) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: "Value cannot be negative",
                }));
                return;
            }


            const { success, error } = inputMinLimit(name, value, 0);

            if (!success) {
                setErrors((prevErrors) => ({
                    ...prevErrors,
                    [name]: error,
                }));
            }
        }


        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };

    //**************************valedation End**************** */
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true);

    const getAllEmp_code = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );

            const sortedList = customSortByKey(res.data, "emp_code");

            setEmpList(sortedList);
        } catch (err) {
        } finally {
            setBuffering1(false);
        }
    };

    const getDynamicNatureOption = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamic-nature-byfilter/${formData.sub_company}/arrear/`
            );

            setNatureOptionList(res.data);
        } catch (err) {
        } finally {
            setBuffering2(false);
        }
    };


    const handleFileChange = (e) => {
        const { name } = e.target;
        const file = e.target.files[0];
        setFormData({
            ...formData,
            [name]: file,
        });
    };

    const handleFileClear = (name) => {
        setFormData({
            ...formData,
            [name]: null,
        });
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
            const uploadData = new FormData();
            uploadData.append("emp_code", formData.emp_code);
            uploadData.append("amount", formData.amount);
            uploadData.append("reason", formData.reason);
            uploadData.append("nature_option", formData.nature_option);
            uploadData.append("month_year", formData.month_year);
            uploadData.append("approved_amount", formData.approved_amount);
            uploadData.append("sub_company", formData.sub_company);
            uploadData.append("status", formData.status);

            uploadData.append("created_by", formData.created_by);
            uploadData.append("updated_by", formData.updated_by);

            const attachmentFile = formData.proof;
            if (attachmentFile && typeof attachmentFile !== 'string') {
                const customFile = generateCustomFileForUpload(attachmentFile, 'Aimantra');
                uploadData.append("proof", customFile);

            }

            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/incentive-with-dynamicapproval/`,
                    uploadData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
                );

                if (res.status === 200) {
                    await getIncentive();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Incentive created successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Add Incentive">
                <AddwithWhiteCircle /> Add Incentive
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Add Incentive</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">
                            <div className="form-flex-wrap">
                                {SUPER_ADMIN && (
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Sub Company<span className="required">*</span>
                                        </label>
                                        <select
                                            name="sub_company"
                                            value={formData.sub_company}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.sub_company
                                                ? "error"
                                                : inputState.sub_company
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select a Company</option>
                                            {SUB_COMPANIES.map((i, index) => (
                                                <option key={index} value={i.id}>
                                                    {i.title}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.sub_company && (
                                            <span className="error-message font-size-text ">
                                                {errors.sub_company}
                                            </span>
                                        )}
                                    </div>
                                )}
                                <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        To Employee<span className="required">*</span>
                                    </label>
                                    {buffer1 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            name="emp_code"
                                            value={formData.emp_code}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.emp_code
                                                ? "error"
                                                : inputState.emp_code
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select An Employee</option>
                                            {empList
                                                .sort((a, b) => a.emp_code - b.emp_code)
                                                .map((i, index) => (
                                                    <option value={i.emp_code}>
                                                        {i.name} - {i.emp_code}
                                                    </option>
                                                ))}
                                        </select>
                                    )}
                                    {errors.emp_code && (
                                        <span className="error-message font-size-text">
                                            {errors.emp_code}
                                        </span>
                                    )}
                                </div>
                            </div>

                            <div className="form-flex-wrap">
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Amount<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="amount"
                                        min={0}
                                        onWheel={(e) => e.target.blur()}
                                        value={formData.amount}
                                        onChange={handleInputChange}
                                        className={` form-input
            ${errors.amount ? "error" : inputState.amount ? "success" : ""}`}
                                    />
                                    {errors.amount && <span className="error-message font-size-text">{errors.amount}</span>}
                                </div>




                                <div className="flex-column ">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Nature<span className="required">*</span>
                                    </label>
                                    {buffer2 ? (
                                        <div className="form-loader">
                                            <div className="bar-loader"></div>
                                        </div>
                                    ) : (
                                        <select
                                            name="nature_option"
                                            value={formData.nature_option}
                                            onChange={handleInputChange}
                                            className={`form-input ${errors.nature_option
                                                ? "error"
                                                : inputState.nature_option
                                                    ? "success"
                                                    : ""
                                                }`}
                                            required
                                        >
                                            <option value="">Select Nature</option>
                                            {natureOptionList
                                                .map((i, index) => (
                                                    <option value={i.id}>
                                                        {i.name}
                                                    </option>
                                                ))}
                                        </select>
                                    )}

                                    {errors.nature_option && (
                                        <span className="error-message font-size-text ">
                                            {errors.nature_option}
                                        </span>
                                    )}
                                </div>

                            </div>

                            <div className="form-flex-wrap">

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Month & Year<span className="required">*</span>
                                    </label>
                                    <input
                                        type="date"
                                        name="month_year"
                                        value={formData.month_year}
                                        onChange={handleInputChange}
                                        className={`form-input form-input-background 
            ${errors.month_year ? "error" : inputState.month_year ? "success" : ""}`}
                                    />
                                    {errors.month_year && <span className="error-message">{errors.month_year}</span>}
                                </div>

                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Approved Amount<span className="required">*</span>
                                    </label>
                                    <input
                                        type="number"
                                        name="approved_amount"
                                        min={0}
                                        onWheel={(e) => e.target.blur()}
                                        value={formData.approved_amount}
                                        onChange={handleInputChange}
                                        className={`form-input form-input-background 
            ${errors.approved_amount ? "error" : inputState.approved_amount ? "success" : ""}`}
                                    />
                                    {errors.approved_amount && <span className="error-message">{errors.approved_amount}</span>}
                                </div>
                            </div>


                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Reason<span className="required">*</span>
                                </label>
                                <textarea
                                    id="reason"
                                    type="text"
                                    name="reason"
                                    placeholder="Reason"
                                    onChange={handleInputChange}
                                    // maxLength={200}
                                    value={formData.reason}
                                    className={`form-input-textarea   font-weight400  font-size-subheading ${errors.reason
                                        ? "error"
                                        : inputState.reason
                                            ? "success"
                                            : ""
                                        }`}
                                />


                                {errors.reason && <span className="error-message">{errors.reason}</span>}
                            </div>



                            <div className="flex-column">
                                <label className="form-labels font-weight500 font-size-subheading">
                                    Proof<span className="required">*</span>
                                </label>

                                <div
                                    className={`file-upload-container flex-row justify-between file-in-upload`}
                                    style={{ padding: "0 3px" }}
                                >
                                    <label
                                        className="popup-label"
                                        htmlFor="proof"
                                    >
                                        <CloudUpload />
                                        <span className="truncate-url">
                                            {formData?.proof
                                                ? formData?.proof instanceof File
                                                    ? formData?.proof.name
                                                    : getFileNameFromUrl(formData?.proof)
                                                : "No file selected"}
                                        </span>
                                    </label>

                                    <input
                                        type="file"
                                        id="proof"
                                        name="proof"
                                        accept=".pdf, .doc, .docx, .xls, .xlsx, .csv, .txt, .png, .jpeg, .jpg, image/*"
                                        onChange={handleFileChange}
                                        className="popup-input"

                                    />
                                    <br />
                                    {formData?.proof && (
                                        <span
                                            className="file-clear"
                                            onClick={() => handleFileClear("proof")}
                                        >
                                            Clear
                                        </span>
                                    )}
                                    {errors.proof && (
                                        <span className="error-message font-size-text ">
                                            {errors.proof}
                                        </span>
                                    )}
                                </div>
                            </div>





                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>
                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors).map((field) =>
                                        field.charAt(0).toUpperCase() + field.slice(1)
                                    ).join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};

const UpdateIncentive = ({ i, getIncentive, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        getAllEmp_code();
        getDynamicNatureOption();
        setShow(true);
    };

    // --------------------- Initial Data---------------------
    const initialData = {
        emp_code: i.emp_code || "",
        sub_company: i.sub_company || sessionStorage.getItem("company_id"),
        amount: i.amount || "",
        reason: i.reason || "",
        nature_option: i.nature_option || "",
        proof: i.proof || null,
        month_year: i.month_year || "",
        approved_amount: i.approved_amount || "",
        status: i.status || "pending",
        created_by: i.created_by || sessionStorage.getItem("emp_code"),
        updated_by: sessionStorage.getItem("emp_code"),
    };

    const [formData, setFormData] = useState(initialData);

    // --------------------- State ---------------------
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [empList, setEmpList] = useState([]);
    const [natureOptionList, setNatureOptionList] = useState([]);
    const [buffer1, setBuffering1] = useState(true);
    const [buffer2, setBuffering2] = useState(true);
    const [loading, setLoading] = useState(false);

    // --------------------- Validation ---------------------
    const validateForm = () => {
        const newErrors = {};
        const requiredFields = [
            "emp_code",
            "amount",
            "reason",
            "nature_option",
            "month_year",
            "approved_amount",
        ];

        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] =
                    `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    // --------------------- Input Handler ---------------------
    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setErrors((prev) => {
            const x = { ...prev };
            delete x[name];
            return x;
        });

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({ ...formData, [name]: value });
    };

    // --------------------- File Upload ---------------------
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setFormData({ ...formData, proof: file });
    };

    const handleFileClear = () => {
        setFormData({ ...formData, proof: null });
    };

    // --------------------- Fetch Employee List ---------------------
    const getAllEmp_code = async () => {
        setBuffering1(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/ourcompanyempdetailsactive/${formData.sub_company}/`
            );
            setEmpList(customSortByKey(res.data, "emp_code"));
        } finally {
            setBuffering1(false);
        }
    };

    // --------------------- Fetch Nature Options ---------------------
    const getDynamicNatureOption = async () => {
        setBuffering2(true);
        try {
            const res = await axios.get(
                `${BASE_URL}/wfm/dynamic-nature-byfilter/${formData.sub_company}/arrear/`
            );
            setNatureOptionList(res.data);
        } finally {
            setBuffering2(false);
        }
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) return;

        setLoading(true);

        const loadingToastId = toast.loading("Updating... Please wait");

        const uploadData = new FormData();
        uploadData.append("emp_code", formData.emp_code);
        uploadData.append("amount", formData.amount);
        uploadData.append("reason", formData.reason);
        uploadData.append("nature_option", formData.nature_option);
        uploadData.append("month_year", formData.month_year);
        uploadData.append("approved_amount", formData.approved_amount);
        uploadData.append("sub_company", formData.sub_company);
        uploadData.append("status", formData.status);
        uploadData.append("updated_by", formData.updated_by);


        if (formData.proof && typeof formData.proof !== "string") {
            const customFile = generateCustomFileForUpload(formData.proof, "Aimantra");
            uploadData.append("proof", customFile);
        }

        try {
            const res = await axios.put(
                `${BASE_URL}/wfm/incentive-update/${i.id}/`,
                uploadData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            if (res.status === 200) {
                await getIncentive();
                setShow(false);
                toast.success("Incentive updated successfully!");
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };


    return (
        <>
            <button className="model-edit-button" title="Update Incentive" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="half-modal">
                <Modal.Header closeButton>
                    <Modal.Title>Update Incentive</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {SUPER_ADMIN && (
                        <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading">
                                Sub Company<span className="required">*</span>
                            </label>
                            <select
                                name="sub_company"
                                value={formData.sub_company}
                                onChange={handleInputChange}
                                className={`form-input ${errors.sub_company
                                    ? "error"
                                    : inputState.sub_company
                                        ? "success"
                                        : ""
                                    }`}
                                required
                            >
                                <option value="">Select a Company</option>
                                {SUB_COMPANIES.map((i, index) => (
                                    <option key={index} value={i.id}>
                                        {i.title}
                                    </option>
                                ))}
                            </select>
                            {errors.sub_company && (
                                <span className="error-message font-size-text ">
                                    {errors.sub_company}
                                </span>
                            )}
                        </div>
                    )}

                    <div className="flex-column">
                        <label className="form-labels">
                            To Employee <span className="required">*</span>
                        </label>
                        {buffer1 ? (
                            <div className="form-loader"><div className="bar-loader"></div></div>
                        ) : (
                            <select
                                name="emp_code"
                                value={formData.emp_code}
                                onChange={handleInputChange}
                                className={`form-input ${errors.emp_code
                                    ? "error"
                                    : inputState.emp_code
                                        ? "success"
                                        : ""
                                    }`}
                            >
                                <option value="">Select Employee</option>
                                {empList.map((emp) => (
                                    <option value={emp.emp_code}>
                                        {emp.name} - {emp.emp_code}
                                    </option>
                                ))}
                            </select>
                        )}
                        {errors.emp_code && <span className="error-message">{errors.emp_code}</span>}
                    </div>


                    <div className="form-flex-wrap">
                        <div className="flex-column">
                            <label className="form-labels">
                                Amount <span className="required">*</span>
                            </label>
                            <input
                                type="number"
                                name="amount"
                                value={formData.amount}
                                onChange={handleInputChange}
                                className="form-input"
                            />
                            {errors.amount && <span className="error-message">{errors.amount}</span>}
                        </div>

                        <div className="flex-column">
                            <label className="form-labels">
                                Nature <span className="required">*</span>
                            </label>
                            {buffer2 ? (
                                <div className="form-loader"><div className="bar-loader"></div></div>
                            ) : (
                                <select
                                    name="nature_option"
                                    value={formData.nature_option}
                                    onChange={handleInputChange}
                                    className="form-input"
                                >
                                    <option value="">Select Nature</option>
                                    {natureOptionList.map((n) => (
                                        <option value={n.id}>{n.name}</option>
                                    ))}
                                </select>
                            )}
                            {errors.nature_option && (
                                <span className="error-message">{errors.nature_option}</span>
                            )}
                        </div>
                    </div>


                    <div className="form-flex-wrap">
                        <div className="flex-column">
                            <label className="form-labels">
                                Month & Year <span className="required">*</span>
                            </label>
                            <input
                                type="date"
                                name="month_year"
                                value={formData.month_year}
                                onChange={handleInputChange}
                                className="form-input"
                            />
                        </div>

                        <div className="flex-column">
                            <label className="form-labels">
                                Approved Amount <span className="required">*</span>
                            </label>
                            <input
                                type="number"
                                name="approved_amount"
                                value={formData.approved_amount}
                                onChange={handleInputChange}
                                className="form-input"
                            />
                        </div>
                    </div>


                    <div className="flex-column">
                        <label className="form-labels">
                            Reason <span className="required">*</span>
                        </label>
                        <textarea
                            name="reason"
                            value={formData.reason}
                            onChange={handleInputChange}
                            className="form-input-textarea"
                        />
                        {errors.reason && <span className="error-message">{errors.reason}</span>}
                    </div>

                    {/* Proof */}
                    <div className="flex-column">
                        <label className="form-labels">
                            Proof <span className="required">*</span>
                        </label>
                        <div className="file-upload-container flex-row justify-between">
                            <label htmlFor="proof">
                                <CloudUpload />{" "}
                                <span className="truncate-url">
                                    {formData?.proof
                                        ? formData.proof instanceof File
                                            ? formData.proof.name
                                            : getFileNameFromUrl(formData.proof)
                                        : "No file selected"}
                                </span>
                            </label>

                            <input
                                type="file"
                                id="proof"
                                name="proof"
                                onChange={handleFileChange}
                                className="popup-input"
                            />

                            {formData?.proof && (
                                <span className="file-clear" onClick={handleFileClear}>
                                    Clear
                                </span>
                            )}
                        </div>
                    </div>

                    {/* Buttons */}
                    <div className="button-models">
                        <button className="model-button model-button-cancel" onClick={handleClose}>
                            Cancel
                        </button>
                        <button
                            className="model-button model-button-leave"
                            disabled={loading}
                            onClick={handleFormSubmit}
                        >
                            Update
                        </button>
                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors).map((field) =>
                                        field.charAt(0).toUpperCase() + field.slice(1)
                                    ).join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>


                    <ToastContainer position="top-center" autoClose={1000} />
                </Modal.Body>
            </Modal>
        </>
    );
};

// --------------------------------------------------------Dynamic Nature Option-------------------
const AddDynamicNature = ({ getDynamicNature, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const initialData = {
        name: "",
        sub_company: sessionStorage.getItem('company_id'),
        description: "",
        format_for: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
        calculation_type: '',
    }
    const [formData, setFormData] = useState(initialData);

    //**************************valedation Start**************** */

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["name", "description", "sub_company", "format_for", "calculation_type"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });



        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };



    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic


            try {
                let res = await axios.post(
                    `${BASE_URL}/wfm/dynamic-nature/`,
                    formData,
                );

                if (res.status === 200 || res.status === 201) {
                    await getDynamicNature();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Dynamic Nature created successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Add Dynamic Nature">
                <AddwithWhiteCircle /> Dynamic Nature
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Dynamic Nature</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.sub_company
                                            ? "error"
                                            : inputState.sub_company
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>
                                                {i.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.sub_company && (
                                        <span className="error-message font-size-text ">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>
                            )}

                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Name"
                                    maxLength={150}
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input w-auto form-input-background ${errors.name ? "error" : inputState.name ? "success" : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>



                            <div className="flex-column">
                                <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                    Format<span className="required">*</span>

                                </label>

                                <select
                                    id="format_for"
                                    name="format_for"
                                    value={formData.format_for}
                                    onChange={handleInputChange}
                                    className={`form-input w-auto ${errors.format_for ? "error" : inputState.format_for ? "success" : ""}`}
                                >
                                    <option value="">Select Format</option>
                                    <option value="arrear">Arrear</option>
                                    <option value="incentive">Incentive</option>
                                </select>


                                {errors.format_for && (
                                    <span className="error-message font-size-text">{errors.format_for}</span>
                                )}
                            </div>




                            <div className="flex-column">
                                <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Description<span className="required">*</span>
                                </label>
                                <textarea
                                    id="description"
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                    onChange={handleInputChange}
                                    // maxLength={200}
                                    value={formData.description}
                                    className={`form-input-textarea w-auto  font-weight400  font-size-subheading ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text ">{errors.description}</span>
                                )}
                            </div>
                            <div className="flex-column">
                                <label htmlFor="calculation_type" className="form-labels font-weight500 font-size-subheading">
                                    Calculation Type<span className="required">*</span>

                                </label>

                                <select
                                    id="calculation_type"
                                    name="calculation_type"
                                    value={formData.calculation_type}
                                    onChange={handleInputChange}
                                    className={`form-input w-auto ${errors.calculation_type ? "error" : inputState.calculation_type ? "success" : ""}`}
                                >
                                    <option value="">Select Calculation Type</option>
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="amount">Amount</option>
                                </select>


                                {errors.calculation_type && (
                                    <span className="error-message font-size-text">{errors.calculation_type}</span>
                                )}
                            </div>


                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Add
                                </button>
                            </div>
                        </div>

                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors).map((field) =>
                                        field.charAt(0).toUpperCase() + field.slice(1)
                                    ).join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};

const UpdateDynamicNature = ({ i, getDynamicNature, SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});


    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }
    useEffect(() => {
        setFormData(i);
    }, [i]);

    const initialData = {
        name: "",
        sub_company: sessionStorage.getItem('company_id'),
        description: "",
        format_for: "",
        created_by: sessionStorage.getItem('emp_code'),
        updated_by: sessionStorage.getItem('emp_code'),
        calculation_type: '',
    }
    const [formData, setFormData] = useState(initialData);

    //**************************valedation Start**************** */


    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["name", "description", "sub_company", "format_for", "calculation_type"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });

        setFormData({
            ...formData,
            [name]: value,
        });
    };




    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic


            try {
                let res = await axios.put(
                    `${BASE_URL}/wfm/dynamic-nature/${i.id}/`,
                    formData,
                );

                if (res.status === 200) {
                    await getDynamicNature();
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Dynamic Nature updated successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId)
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };
    return (
        <>
            <button className="model-edit-button" title="Update Dynamic Nature" onClick={handleShow}>
                <UpdatePencil />
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog modal-dialog request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Update Dynamic Nature</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.sub_company
                                            ? "error"
                                            : inputState.sub_company
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>
                                                {i.title}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.sub_company && (
                                        <span className="error-message font-size-text ">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>
                            )}

                            <div className="flex-column">
                                <label
                                    htmlFor="name"
                                    className="form-labels font-weight500 font-size-subheading"
                                >
                                    Name<span className="required">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Name"
                                    maxLength={150}
                                    onChange={handleInputChange}
                                    value={formData.name}
                                    className={`form-input w-auto form-input-background ${errors.name ? "error" : inputState.name ? "success" : ""
                                        }`}
                                />
                                {errors.name && (
                                    <span className="error-message font-size-text">
                                        {errors.name}
                                    </span>
                                )}
                            </div>



                            <div className="flex-column">
                                <label htmlFor="format_for" className="form-labels font-weight500 font-size-subheading">
                                    Format<span className="required">*</span>

                                </label>

                                <select
                                    id="format_for"
                                    name="format_for"
                                    value={formData.format_for}
                                    onChange={handleInputChange}
                                    className={`form-input w-auto ${errors.format_for ? "error" : inputState.format_for ? "success" : ""}`}
                                >
                                    <option value="">Select Format</option>
                                    <option value="arrear">Arrear</option>
                                    <option value="incentive">Incentive</option>
                                </select>


                                {errors.format_for && (
                                    <span className="error-message font-size-text">{errors.format_for}</span>
                                )}
                            </div>


                            <div className="flex-column">
                                <label htmlFor="description" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                                    Description<span className="required">*</span>
                                </label>
                                <textarea
                                    id="description"
                                    type="text"
                                    name="description"
                                    placeholder="Description"
                                    onChange={handleInputChange}
                                    // maxLength={200}
                                    value={formData.description}
                                    className={`form-input-textarea w-auto  font-weight400  font-size-subheading ${errors.description
                                        ? "error"
                                        : inputState.description
                                            ? "success"
                                            : ""
                                        }`}
                                />
                                {errors.description && (
                                    <span className="error-message font-size-text ">{errors.description}</span>
                                )}
                            </div>
                            <div className="flex-column">
                                <label htmlFor="calculation_type" className="form-labels font-weight500 font-size-subheading">
                                    Calculation Type<span className="required">*</span>

                                </label>

                                <select
                                    id="calculation_type"
                                    name="calculation_type"
                                    value={formData.calculation_type}
                                    onChange={handleInputChange}
                                    className={`form-input w-auto ${errors.calculation_type ? "error" : inputState.calculation_type ? "success" : ""}`}
                                >
                                    <option value="">Select Calculation Type</option>
                                    <option value="days">Days</option>
                                    <option value="months">Months</option>
                                    <option value="amount">Amount</option>
                                </select>


                                {errors.calculation_type && (
                                    <span className="error-message font-size-text">{errors.calculation_type}</span>
                                )}
                            </div>



                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500    " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={loading}
                                >
                                    Update
                                </button>
                            </div>
                        </div>

                    </div>
                    <p className="error-message font-size-text">
                        {isSubmitted && Object.keys(errors).length > 0 && (
                            Object.keys(errors).length > 5 ? (
                                <h5 className="text-center">Please fill all mandatory fields!</h5>
                            ) : (
                                <h6 className="text-center">
                                    {Object.keys(errors).map((field) =>
                                        field.charAt(0).toUpperCase() + field.slice(1)
                                    ).join(', ') + ' are required!'}
                                </h6>
                            )
                        )}
                    </p>
                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};

const DeleteDynamicNature = ({ i, getDynamicNature }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    };
    const [loading, setLoading] = useState(false);

    const handleDelete = async (e) => {
        e.preventDefault();
        const loadingToastId = toast.loading("Loading: Please wait...");
        try {
            const res = await axios.delete(`${BASE_URL}/wfm/dynamic-nature/${i.id}/`);
            if (res.status === 200) {
                await getDynamicNature();
                setShow(false);
                toast.success("Dynamic Nature Deleted Successfully!");
            } else {
                console.error(res);
            }
        } catch (err) {
            handleErrorToast(err, loadingToastId);
        } finally {
            setLoading(false);
            toast.dismiss(loadingToastId);
        }
    };

    return (
        <>
            <button className="model-delete-button" onClick={handleShow} title="Delete Dynamic Nature">
                <DeleteDustbin />
            </button>
            <Modal
                show={show}
                onHide={handleClose}
                dialogClassName="request-leave width-40vw"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Delete Dynamic Nature of "{i?.name}"</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        Are You Sure You Want to delete Dynamic Nature of <b>{i?.name}</b>
                        <div className="button-models">
                            <button
                                type="button"
                                className="model-button model-button-cancel   font-weight500    "
                                onClick={handleClose}
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDelete}
                                className="model-button   font-weight500    model-button-delete"
                                disabled={loading}
                            >
                                {loading ? "Deleting..." : "Delete"}
                            </button>
                        </div>
                    </div>
                    <ToastContainer
                        position="top-center"
                        autoClose={1000}
                        hideProgressBar={false}
                        newestOnTop={true}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                </Modal.Body>
            </Modal>

        </>
    );
};


const AddSandwichRule = ({ SUB_COMPANIES, SUPER_ADMIN }) => {
    const [show, setShow] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [buffer, setBuffering] = useState(true);
    const [errors, setErrors] = useState({});
    const [inputState, setInputState] = useState({});
    const [loading1, setLoading1] = useState(false);
    // const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
    const [settings, setSettings] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = () => {
        setShow(true);
    }

    const initialData = {
        sub_company: sessionStorage.getItem('company_id') || '',
        sandwichRuleType: '',
        applicable_month: '',
        reason: "",
        updated_by: sessionStorage.getItem('emp_code'),
    }
    const [formData, setFormData] = useState(initialData);

    //**************************valedation Start**************** */

    const validateForm = () => {
        const newErrors = {};
        const requiredFields = ["sub_company",
            "applicable_month", "reason"
        ];
        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
                    } is required !`;
            }
        });

        setErrors(newErrors);
        setIsSubmitted(true);
        return Object.keys(newErrors).length === 0;
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        console.log(value, "value");

        setErrors((prevErrors) => {
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[name];
            return updatedErrors;
        });

        setInputState({
            ...inputState,
            [name]: value.trim() ? "green" : "",
        });
        if (name === "sub_company") {
            fetchSettings(value);
        }


        setFormData({
            ...formData,
            [name]: value,
        });
    };


    const Sandwich_rule = [
        { value: 'include_holiday_cover', label: 'Include Holiday Cover' },
        { value: 'exclude_holiday_cover', label: 'Exclude Holiday Cover' },
        { value: 'ignore_holiday', label: 'Ignore Holiday' }
    ]

    const fetchSettings = async (companyId) => {
        try {
            setLoading1(true);
            const response = await axios.get(`${BASE_URL}/wfm/portal_setting_sub_company/${companyId}/`);
            setSettings(response.data);
        } catch (error) {
            handleAllError(error);
        } finally {
            setLoading1(false);
        }
    };

    const ruleEnabled = settings?.sandwich_rule_enabled;
    const holidayRule = settings?.sandwich_holiday_rule;
    const sandwichHoliday = settings?.sandwich_holiday;


    useEffect(() => {
        if (show && formData.sub_company) {
            fetchSettings(formData.sub_company);
        }
    }, [show]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();

        if (validateForm()) {
            setLoading(true);
            setBuffering(true);

            const loadingToastId = toast.loading("Loading: Please wait...");

            try {
                const { sub_company, applicable_month, reason, updated_by } = formData;

                if (!applicable_month) {
                    toast.error("Please select a month");
                    setLoading(false);
                    return;
                }


                const [year, month] = applicable_month.split("-");


                let res = await axios.post(
                    `https://pp1nvg0p-8002.inc1.devtunnels.ms/wfm/sandwichrule-by-subcompany-with-log/${sub_company}/${year}/${month}/`,
                    { reason, updated_by }
                );

                if (res.status === 200 || res.status === 201) {
                    setShow(false);
                    setFormData(initialData);
                    toast.success("Sandwich Rule Applied successfully!");
                } else {
                    console.error(res);
                }
            } catch (err) {
                handleErrorToast(err, loadingToastId);
            } finally {
                setLoading(false);
                toast.dismiss(loadingToastId);
            }
        }
    };



    const isDisabled =
        loading ||
        !settings ||
        ruleEnabled === false ||
        !holidayRule;

    return (
        <>
            <button className="upload-svg" onClick={handleShow} title="Add Sandwich Rule">
                <AddwithWhiteCircle /> Sandwich Rule
            </button>

            <Modal show={show} onHide={handleClose} dialogClassName="modal-dialog request-leave width-40vw">
                <Modal.Header closeButton>
                    <Modal.Title>Add Sandwich Rule</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="parent-div">
                        <div className="bdy-div">

                            {SUPER_ADMIN && (
                                <div className="flex-column">
                                    <label className="form-labels font-weight500 font-size-subheading">
                                        Sub Company<span className="required">*</span>
                                    </label>
                                    <select
                                        name="sub_company"
                                        value={formData.sub_company}
                                        onChange={handleInputChange}
                                        className={`form-input w-auto ${errors.sub_company
                                            ? "error"
                                            : inputState.sub_company
                                                ? "success"
                                                : ""
                                            }`}
                                        required
                                    >
                                        <option value="">Select a Company</option>
                                        {SUB_COMPANIES.map((i, index) => (
                                            <option key={index} value={i.id}>
                                                {i.title}
                                            </option>
                                        ))}
                                    </select>

                                    {ruleEnabled && (
                                        <div
                                            style={{
                                                background: "#f8f9ff",
                                                border: "1px solid #e0e6ff",
                                                padding: "10px 14px",
                                                borderRadius: "10px",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "10px",
                                                fontSize: "14px"
                                            }}
                                        >

                                            <div>
                                                <div style={{ color: "#303030" }}>
                                                    Sandwich rule as per {SUPER_ADMIN && "company"} settings
                                                </div>

                                                <div style={{ fontWeight: "600", color: "#2b3a8f" }}>
                                                    {formatFieldName(holidayRule) || "Default Sandwich Rule"}
                                                    <span style={{ marginLeft: "6px" }}>
                                                        <SandwichRuleExplanation customStyle={{ top: "135px" }} settings={settings} />
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {settings && ruleEnabled && !sandwichHoliday && (
                                        <p className="info-text">
                                            Default Sandwich Rule is currently active. Holiday-based sandwich policy is not enabled.
                                        </p>
                                    )}


                                    {errors.sub_company && (
                                        <span className="error-message font-size-text ">
                                            {errors.sub_company}
                                        </span>
                                    )}
                                </div>
                            )}
                            {settings && ruleEnabled === true && (
                                <>

                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Applicable Month <span className="required">*</span>
                                        </label>

                                        <input
                                            type="month"
                                            name="applicable_month"
                                            value={formData.applicable_month}
                                            onChange={handleInputChange}
                                            className={`multi-day-input1 form-input w-auto 
                                 ${errors.applicable_month ? "error" : inputState.applicable_month ? "success" : ""}`}
                                        />

                                        {errors.applicable_month && (
                                            <span className="error-message font-size-text">
                                                {errors.applicable_month}
                                            </span>
                                        )}
                                    </div>

                                    {/* {sandwichHoliday === true && ruleEnabled === true && (


                                        <div className="flex-column">
                                            <div className="flex-row">
                                                <label className="form-labels font-weight500 font-size-subheading">
                                                    Sandwich rule type<span className="required">*</span>
                                                </label>
                                                <hr className="field-cont-hr" />
                                                <SandwichRuleExplanation customStyle={{ top: '135px' }} settings={settings} />
                                            </div>
                                            <select
                                                className={`form-input w-auto ${errors.sandwichRuleType
                                                    ? "error"
                                                    : inputState.sandwichRuleType
                                                        ? "success"
                                                        : ""
                                                    }`}
                                                value={formData.sandwichRuleType || ''}
                                                onChange={handleInputChange}
                                                name="sandwichRuleType"
                                            >
                                                <option value="">Select an option</option>
                                                {Sandwich_rule.map(option => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                            {errors.sandwichRuleType && <span className="error-message font-size-text">{errors.sandwichRuleType}</span>}
                                        </div>
                                    )} */}
                                    <div className="flex-column">
                                        <label className="form-labels font-weight500 font-size-subheading">
                                            Reason<span className="required">*</span>
                                        </label>
                                        <textarea
                                            id="reason"
                                            type="text"
                                            name="reason"
                                            placeholder="Reason"
                                            onChange={handleInputChange}
                                            // maxLength={200}
                                            value={formData.reason}
                                            className={`form-input-textarea w-auto font-weight400  font-size-subheading ${errors.reason
                                                ? "error"
                                                : inputState.reason
                                                    ? "success"
                                                    : ""
                                                }`}
                                        />
                                        {errors.reason && <span className="error-message font-size-text">{errors.reason}</span>}
                                    </div>
                                </>
                            )}

                            {settings && ruleEnabled === false && (
                                <div className='padding_ color-tab-yellow text-warning-color-dark notice-badge' >
                                    Sandwich rule is not applicable for this subcompany.
                                </div>
                            )}


                            {settings && ruleEnabled === true && !holidayRule && (
                                <div className='padding_ color-tab-yellow text-warning-color-dark notice-badge' >
                                    Holiday rule is not configured. <strong>Default sandwich rule</strong> will be applied.
                                </div>
                            )}

                            <div className="button-models">
                                <button className="model-button model-button-cancel  font-weight500 " onClick={handleClose}>
                                    Cancel
                                </button>
                                <button
                                    //   type="submit"
                                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                                    onClick={handleFormSubmit}
                                    disabled={isDisabled}
                                    style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
                                >
                                    Submit
                                </button>
                            </div>
                        </div>

                    </div>

                    <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
                </Modal.Body>
            </Modal >
        </>
    );
};


export { AddPopup, PopupUpdate, PopupDelete, ViewPopup, ShowBannerPopups, AnnouncentAdd, AnnouncementUpdate, AnnouncementDelete, AttReguralizeAdd, AttReguralizeUpdate, AttReguralizeDelete, StarperformanceAdd, StarperformanceUpdate, StarperformanceDelete, EventAdd, EventDelete, EventUpdate, Importantmessage, ImportantmessageUpdate, ImportantmessageDelete, AttendanceReguralizationTable, AttendanceExtraDetailsTable, AddDynamicNature, UpdateDynamicNature, DeleteDynamicNature, AddArrear, UpdateArrear, DeleteArrear, AddIncentive, UpdateIncentive, SubmitArrearForApproval, ResubmitArrearForApproval, AddSandwichRule };








